import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
}

/** Defines the bundle products to add to the cart. */
export type AddBundleProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']
  /** An array of bundle products to add. */
  cart_items: Array<InputMaybe<BundleProductCartItemInput>>
}

/** Contains details about the cart after adding bundle products. */
export type AddBundleProductsToCartOutput = {
  __typename?: 'AddBundleProductsToCartOutput'
  /** The cart after adding products. */
  cart: Cart
}

/** Defines the configurable products to add to the cart. */
export type AddConfigurableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']
  /** An array of configurable products to add. */
  cart_items: Array<InputMaybe<ConfigurableProductCartItemInput>>
}

/** Contains details about the cart after adding configurable products. */
export type AddConfigurableProductsToCartOutput = {
  __typename?: 'AddConfigurableProductsToCartOutput'
  /** The cart after adding products. */
  cart: Cart
}

export type AddDownloadableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']
  /** An array of downloadable products to add. */
  cart_items: Array<InputMaybe<DownloadableProductCartItemInput>>
}

/** Contains details about the cart after adding downloadable products. */
export type AddDownloadableProductsToCartOutput = {
  __typename?: 'AddDownloadableProductsToCartOutput'
  /** The cart after adding products. */
  cart: Cart
}

/** Contains details about the cart after adding products to it. */
export type AddProductsToCartOutput = {
  __typename?: 'AddProductsToCartOutput'
  /** The cart after products have been added. */
  cart: Cart
  /** Contains errors encountered while adding an item to the cart. */
  user_errors: Array<Maybe<CartUserInputError>>
}

/** Contains products to add to an existing compare list. */
export type AddProductsToCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products: Array<InputMaybe<Scalars['ID']>>
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID']
}

/** Contains the customer's wish list and any errors encountered. */
export type AddProductsToWishlistOutput = {
  __typename?: 'AddProductsToWishlistOutput'
  /** An array of errors encountered while adding products to a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist
}

/** Defines the simple and group products to add to the cart. */
export type AddSimpleProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** An array of simple and group items to add. */
  cart_items: Array<InputMaybe<SimpleProductCartItemInput>>
}

/** Contains details about the cart after adding simple or group products. */
export type AddSimpleProductsToCartOutput = {
  __typename?: 'AddSimpleProductsToCartOutput'
  /** The cart after adding products. */
  cart: Cart
}

/** Defines the virtual products to add to the cart. */
export type AddVirtualProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** An array of virtual products to add. */
  cart_items: Array<InputMaybe<VirtualProductCartItemInput>>
}

/** Contains details about the cart after adding virtual products. */
export type AddVirtualProductsToCartOutput = {
  __typename?: 'AddVirtualProductsToCartOutput'
  /** The cart after adding products. */
  cart: Cart
}

/** Contains the resultant wish list and any error information. */
export type AddWishlistItemsToCartOutput = {
  __typename?: 'AddWishlistItemsToCartOutput'
  /** An array of errors encountered while adding products to the customer's cart. */
  add_wishlist_items_to_cart_user_errors: Array<Maybe<WishlistCartUserInputError>>
  /** Indicates whether the attempt to add items to the customer's cart was successful. */
  status: Scalars['Boolean']
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist
}

/** Contains information for each filterable option (such as price, category `UID`, and custom attributes). */
export type Aggregation = {
  __typename?: 'Aggregation'
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String']
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']>
  /** The aggregation display name. */
  label?: Maybe<Scalars['String']>
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<AggregationOption>>>
  /** The relative position of the attribute in a layered navigation block. */
  position?: Maybe<Scalars['Int']>
}

/** An implementation of `AggregationOptionInterface`. */
export type AggregationOption = AggregationOptionInterface & {
  __typename?: 'AggregationOption'
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']>
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']>
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']
}

/** Defines aggregation option fields. */
export type AggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']>
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']>
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']
}

/** Filter category aggregations in layered navigation. */
export type AggregationsCategoryFilterInput = {
  /** Indicates whether to include only direct subcategories or all children categories at all levels. */
  includeDirectChildrenOnly?: InputMaybe<Scalars['Boolean']>
}

/** An input object that specifies the filters used in product aggregations. */
export type AggregationsFilterInput = {
  /** Filter category aggregations in layered navigation. */
  category?: InputMaybe<AggregationsCategoryFilterInput>
}

export type ApplePaymentMerchantSession = {
  __typename?: 'ApplePaymentMerchantSession'
  session?: Maybe<Scalars['String']>
}

/** Contains the applied coupon code. */
export type AppliedCoupon = {
  __typename?: 'AppliedCoupon'
  /** The coupon code the shopper applied to the card. */
  code: Scalars['String']
}

/** Specifies the coupon code to apply to the cart. */
export type ApplyCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** A valid coupon code. */
  coupon_code: Scalars['String']
}

/** Contains details about the cart after applying a coupon. */
export type ApplyCouponToCartOutput = {
  __typename?: 'ApplyCouponToCartOutput'
  /** The cart after applying a coupon. */
  cart: Cart
}

/** AreaInput defines the parameters which will be used for filter by specified location. */
export type AreaInput = {
  /** The radius for the search in KM. */
  radius: Scalars['Int']
  /** The country code where search must be performed. Required parameter together with region, city or postcode. */
  search_term: Scalars['String']
}

/** Contains the results of the request to assign a compare list. */
export type AssignCompareListToCustomerOutput = {
  __typename?: 'AssignCompareListToCustomerOutput'
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<CompareList>
  /** Indicates whether the compare list was successfully assigned to the customer. */
  result: Scalars['Boolean']
}

/** Contains details about the attribute, including the code and type. */
export type Attribute = {
  __typename?: 'Attribute'
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: Maybe<Scalars['String']>
  /** Attribute options list. */
  attribute_options?: Maybe<Array<Maybe<AttributeOption>>>
  /** The data type of the attribute. */
  attribute_type?: Maybe<Scalars['String']>
  /** The type of entity that defines the attribute. */
  entity_type?: Maybe<Scalars['String']>
  /** The frontend input type of the attribute. */
  input_type?: Maybe<Scalars['String']>
  /** Details about the storefront properties configured for the attribute. */
  storefront_properties?: Maybe<StorefrontProperties>
}

/** Defines the attribute characteristics to search for the `attribute_code` and `entity_type` to search. */
export type AttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: InputMaybe<Scalars['String']>
  /** The type of entity that defines the attribute. */
  entity_type?: InputMaybe<Scalars['String']>
}

/** Defines an attribute option. */
export type AttributeOption = {
  __typename?: 'AttributeOption'
  /** The label assigned to the attribute option. */
  label?: Maybe<Scalars['String']>
  /** The attribute option value. */
  value?: Maybe<Scalars['String']>
}

/** Describes a payment method that the shopper can use to pay for the order. */
export type AvailablePaymentMethod = {
  __typename?: 'AvailablePaymentMethod'
  /** The payment method code. */
  code: Scalars['String']
  /** If the payment method is an online integration */
  is_deferred: Scalars['Boolean']
  /** The payment method title. */
  title: Scalars['String']
}

/** Contains details about the possible shipping methods and carriers. */
export type AvailableShippingMethod = {
  __typename?: 'AvailableShippingMethod'
  /** The cost of shipping using this shipping method. */
  amount: Money
  /** Indicates whether this shipping method can be applied to the cart. */
  available: Scalars['Boolean']
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String']
  /** The label for the carrier code. */
  carrier_title: Scalars['String']
  /** Describes an error condition. */
  error_message?: Maybe<Scalars['String']>
  /** A shipping method code associated with a carrier. The value could be null if no method is available. */
  method_code?: Maybe<Scalars['String']>
  /** The label for the shipping method code. The value could be null if no method is available. */
  method_title?: Maybe<Scalars['String']>
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money
}

export const BatchMutationStatus = {
  Failure: 'FAILURE',
  MixedResults: 'MIXED_RESULTS',
  Success: 'SUCCESS',
} as const

export type BatchMutationStatus = (typeof BatchMutationStatus)[keyof typeof BatchMutationStatus]
export type BestsellersProductOutput = {
  __typename?: 'BestsellersProductOutput'
  /** Currency */
  currency?: Maybe<Scalars['String']>
  /** Period. */
  period?: Maybe<Scalars['String']>
  /** Product ID */
  product_id?: Maybe<Scalars['String']>
  /** Product Image URL */
  product_image_url?: Maybe<Scalars['String']>
  /** Product Name */
  product_name?: Maybe<Scalars['String']>
  /** Product Price */
  product_price?: Maybe<Scalars['String']>
  /** Product SKU */
  product_sku?: Maybe<Scalars['String']>
  /** Product URL */
  product_url?: Maybe<Scalars['String']>
  /** Order Quantity. */
  qty_ordered?: Maybe<Scalars['Int']>
}

/** Defines the billing address. */
export type BillingAddressInput = {
  /** Defines a billing address. */
  address?: InputMaybe<CartAddressInput>
  /** An ID from the customer's address book that uniquely identifies the address to be used for billing. */
  customer_address_id?: InputMaybe<Scalars['Int']>
  /** Indicates whether to set the billing address to be the same as the existing shipping address on the cart. */
  same_as_shipping?: InputMaybe<Scalars['Boolean']>
  /** Indicates whether to set the shipping address to be the same as this billing address. */
  use_for_shipping?: InputMaybe<Scalars['Boolean']>
}

/** Contains details about the billing address. */
export type BillingCartAddress = CartAddressInterface & {
  __typename?: 'BillingCartAddress'
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>
  /** An object containing the country label and code. */
  country: CartAddressCountry
  /** @deprecated The field is used only in shipping address. */
  customer_notes?: Maybe<Scalars['String']>
  /** The first name of the customer or guest. */
  firstname: Scalars['String']
  /** The last name of the customer or guest. */
  lastname: Scalars['String']
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>
  /** The unique id of the customer address. */
  uid: Scalars['String']
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>
}

/** Contains details about an individual category that comprises a breadcrumb. */
export type Breadcrumb = {
  __typename?: 'Breadcrumb'
  /**
   * The ID of the category.
   * @deprecated Use `category_uid` instead.
   */
  category_id?: Maybe<Scalars['Int']>
  /** The category level. */
  category_level?: Maybe<Scalars['Int']>
  /** The display name of the category. */
  category_name?: Maybe<Scalars['String']>
  /** The unique ID for a `Breadcrumb` object. */
  category_uid: Scalars['ID']
  /** The URL key of the category. */
  category_url_key?: Maybe<Scalars['String']>
  /** The URL path of the category. */
  category_url_path?: Maybe<Scalars['String']>
}

/** An implementation for bundle product cart items. */
export type BundleCartItem = CartItemInterface & {
  __typename?: 'BundleCartItem'
  /** An array containing the bundle options the shopper selected. */
  bundle_options: Array<Maybe<SelectedBundleOption>>
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']
  /** Cart item attributes */
  item_attributes?: Maybe<CartItemAttributes>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']
}

/** Defines bundle product options for `CreditMemoItemInterface`. */
export type BundleCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'BundleCreditMemoItem'
  /** A list of bundle options that are assigned to a bundle product that is part of a credit memo. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>
}

/** Defines bundle product options for `InvoiceItemInterface`. */
export type BundleInvoiceItem = InvoiceItemInterface & {
  __typename?: 'BundleInvoiceItem'
  /** A list of bundle options that are assigned to an invoiced bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>
}

/** Defines an individual item within a bundle product. */
export type BundleItem = {
  __typename?: 'BundleItem'
  /**
   * An ID assigned to each type of item in a bundle product.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>
  /** An array of additional options for this bundle item. */
  options?: Maybe<Array<Maybe<BundleItemOption>>>
  /** A number indicating the sequence order of this item compared to the other bundle items. */
  position?: Maybe<Scalars['Int']>
  /** The range of prices for the product */
  price_range: PriceRange
  /** Indicates whether the item must be included in the bundle. */
  required?: Maybe<Scalars['Boolean']>
  /** The SKU of the bundle product. */
  sku?: Maybe<Scalars['String']>
  /** The display name of the item. */
  title?: Maybe<Scalars['String']>
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type?: Maybe<Scalars['String']>
  /** The unique ID for a `BundleItem` object. */
  uid?: Maybe<Scalars['ID']>
}

/** Defines the characteristics that comprise a specific bundle item and its options. */
export type BundleItemOption = {
  __typename?: 'BundleItemOption'
  /** Indicates whether the customer can change the number of items for this option. */
  can_change_quantity?: Maybe<Scalars['Boolean']>
  /**
   * The ID assigned to the bundled item option.
   * @deprecated Use `uid` instead
   */
  id?: Maybe<Scalars['Int']>
  /** Indicates whether this option is the default option. */
  is_default?: Maybe<Scalars['Boolean']>
  /** The text that identifies the bundled item option. */
  label?: Maybe<Scalars['String']>
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position?: Maybe<Scalars['Int']>
  /** The price of the selected option. */
  price?: Maybe<Scalars['Float']>
  /** One of FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>
  /** Contains details about this product option. */
  product?: Maybe<ProductInterface>
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated Use `quantity` instead.
   */
  qty?: Maybe<Scalars['Float']>
  /** The quantity of this specific bundle item. */
  quantity?: Maybe<Scalars['Float']>
  /** The unique ID for a `BundleItemOption` object. */
  uid: Scalars['ID']
}

/** Defines the input for a bundle option. */
export type BundleOptionInput = {
  /** The ID of the option. */
  id: Scalars['Int']
  /** The number of the selected item to add to the cart. */
  quantity: Scalars['Float']
  /** An array with the chosen value of the option. */
  value: Array<InputMaybe<Scalars['String']>>
}

/** Defines bundle product options for `OrderItemInterface`. */
export type BundleOrderItem = OrderItemInterface & {
  __typename?: 'BundleOrderItem'
  /** A list of bundle options that are assigned to the bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>
}

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProduct = CustomizableProductInterface &
  PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'BundleProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    a_z?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    activity?: Maybe<Scalars['String']>
    /** Advisor Tags based on advisor_tags attribute */
    advisor_tags?: Maybe<Array<Maybe<Scalars['String']>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    allow_credit_range?: Maybe<Scalars['Int']>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    category_gear?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    climate?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    collar?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_public?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_public?: Maybe<Scalars['String']>
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_amount?: Maybe<Scalars['Float']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_rate?: Maybe<Scalars['Float']>
    /** Crosssell Products */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_clinical_trials?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_patient_education?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_tech_sheet?: Maybe<Scalars['String']>
    /** Indicates whether the bundle product has a dynamic price. */
    dynamic_price?: Maybe<Scalars['Boolean']>
    /** Indicates whether the bundle product has a dynamic SKU. */
    dynamic_sku?: Maybe<Scalars['Boolean']>
    /** Indicates whether the bundle product has a dynamically calculated weight. */
    dynamic_weight?: Maybe<Scalars['Boolean']>
    /** @deprecated Use the `custom_attributes` field instead. */
    eco_collection?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    erin_recommends?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    features_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    format?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['String']>
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    heat_sensitive?: Maybe<Scalars['Int']>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /** An array containing information about individual bundle items. */
    items?: Maybe<Array<Maybe<BundleItem>>>
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    max_credit?: Maybe<Scalars['Float']>
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    min_credit?: Maybe<Scalars['Float']>
    /** Store Credit product attributes */
    mp_store_credit_attributes?: Maybe<Array<Maybe<StoreCreditProductAttributes>>>
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    natural_product_number?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    new?: Maybe<Scalars['Int']>
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    out_of_stock_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pattern?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    performance_fabric?: Maybe<Scalars['Int']>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    price_range: PriceRange
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>
    /** One of PRICE_RANGE or AS_LOW_AS. */
    price_view?: Maybe<PriceViewEnum>
    /**
     * Product Form based on product_form attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    product_form?: Maybe<Scalars['String']>
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** One of simple, virtual, bundle, downloadable, grouped, or configurable. */
    product_type_id?: Maybe<Scalars['String']>
    /**
     * Prop65 Message
     * @deprecated Use the `custom_attributes` field instead.
     */
    prop65_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    prop_sixty_five?: Maybe<Scalars['Int']>
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars['Float']
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int']
    /** An array of products to be displayed in a Related Products block. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>
    /** The total count of all the reviews given to the product. */
    review_count: Scalars['Int']
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    sale?: Maybe<Scalars['Int']>
    /** Indicates whether to ship bundle items together or individually. */
    ship_bundle_items?: Maybe<ShipBundleItemsEnum>
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars['Int']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sleeve?: Maybe<Scalars['String']>
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>
    /**
     * Specialty based on specialty attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    specialty?: Maybe<Array<Maybe<Scalars['String']>>>
    /** Stock Item Configuration */
    stock_configuration?: Maybe<StockItemConfiguration>
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>
    /** @deprecated Use the `custom_attributes` field instead. */
    strap_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bottom?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_general?: Maybe<Scalars['String']>
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>
    /** Upsell Products */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']>
  }

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

/** Defines a single bundle product. */
export type BundleProductCartItemInput = {
  /** A mandatory array of options for the bundle product, including each chosen option and specified quantity. */
  bundle_options: Array<InputMaybe<BundleOptionInput>>
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** The quantity and SKU of the bundle product. */
  data: CartItemInput
}

/** Defines bundle product options for `ShipmentItemInterface`. */
export type BundleShipmentItem = ShipmentItemInterface & {
  __typename?: 'BundleShipmentItem'
  /** A list of bundle options that are assigned to a shipped product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']
}

/** Defines bundle product options for `WishlistItemInterface`. */
export type BundleWishlistItem = WishlistItemInterface & {
  __typename?: 'BundleWishlistItem'
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']
  /** An array containing information about the selected bundle items. */
  bundle_options?: Maybe<Array<Maybe<SelectedBundleOption>>>
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']
}

/** Contains the contents and other details about a guest or customer cart. */
export type Cart = {
  __typename?: 'Cart'
  /** @deprecated Use `applied_coupons` instead. */
  applied_coupon?: Maybe<AppliedCoupon>
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code. */
  applied_coupons?: Maybe<Array<Maybe<AppliedCoupon>>>
  /** An array of available payment methods. */
  available_payment_methods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>
  /** The billing address assigned to the cart. */
  billing_address?: Maybe<BillingCartAddress>
  dispensary_promo_code?: Maybe<Scalars['String']>
  drop_ship?: Maybe<Scalars['String']>
  e_script_campaign?: Maybe<Scalars['String']>
  /** The email address of the guest or customer. */
  email?: Maybe<Scalars['String']>
  /** The entered gift message for the cart */
  gift_message?: Maybe<GiftMessage>
  hold_until_monday?: Maybe<Scalars['String']>
  /** The unique ID for a `Cart` object. */
  id: Scalars['ID']
  /** Indicates whether the cart contains only virtual products. */
  is_virtual: Scalars['Boolean']
  /** An array of products that have been added to the cart. */
  items?: Maybe<Array<Maybe<CartItemInterface>>>
  ns_customer_id?: Maybe<Scalars['String']>
  practitioner_code?: Maybe<Scalars['String']>
  /** Pricing details for the quote. */
  prices?: Maybe<CartPrices>
  /** Applied store credit to cart */
  rebate?: Maybe<Money>
  referrer_uri?: Maybe<Scalars['String']>
  /** Indicates which payment method was applied to the cart. */
  selected_payment_method?: Maybe<SelectedPaymentMethod>
  ship_date?: Maybe<Scalars['String']>
  /** An array of shipping addresses assigned to the cart. */
  shipping_addresses: Array<Maybe<ShippingCartAddress>>
  /** Set while a Shop Pay payment on this cart is Submitted, with when the page may offer to start over (DFH-29). */
  shop_pay_payment_in_flight?: Maybe<ShopPayPaymentInFlight>
  /** The total number of items in the cart. */
  total_quantity: Scalars['Float']
  ww_id?: Maybe<Scalars['String']>
  ww_practice_id?: Maybe<Scalars['String']>
  ww_practitioner_id?: Maybe<Scalars['String']>
  ww_store_id?: Maybe<Scalars['String']>
}

/** Contains details the country in a billing or shipping address. */
export type CartAddressCountry = {
  __typename?: 'CartAddressCountry'
  /** The country code. */
  code: Scalars['String']
  /** The display label for the country. */
  label: Scalars['String']
}

/** Defines the billing or shipping address to be applied to the cart. */
export type CartAddressInput = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']
  /** The company specified for the billing or shipping address. */
  company?: InputMaybe<Scalars['String']>
  /** The country code and label for the billing or shipping address. */
  country_code: Scalars['String']
  /** The first name of the customer or guest. */
  firstname: Scalars['String']
  /** The last name of the customer or guest. */
  lastname: Scalars['String']
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: InputMaybe<Scalars['String']>
  /** A string that defines the state or province of the billing or shipping address. */
  region?: InputMaybe<Scalars['String']>
  /** An integer that defines the state or province of the billing or shipping address. */
  region_id?: InputMaybe<Scalars['Int']>
  /** Determines whether to save the address in the customer's address book. The default value is true. */
  save_in_address_book?: InputMaybe<Scalars['Boolean']>
  /** An array containing the street for the billing or shipping address. */
  street: Array<InputMaybe<Scalars['String']>>
  /** The telephone number for the billing or shipping address. */
  telephone?: InputMaybe<Scalars['String']>
  /** The VAT company number for billing or shipping address. */
  vat_id?: InputMaybe<Scalars['String']>
}

export type CartAddressInterface = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>
  /** An object containing the country label and code. */
  country: CartAddressCountry
  /** The first name of the customer or guest. */
  firstname: Scalars['String']
  /** The last name of the customer or guest. */
  lastname: Scalars['String']
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>
  /** The unique id of the customer address. */
  uid: Scalars['String']
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>
}

/** Contains details about the region in a billing or shipping address. */
export type CartAddressRegion = {
  __typename?: 'CartAddressRegion'
  /** The state or province code. */
  code?: Maybe<Scalars['String']>
  /** The display label for the region. */
  label?: Maybe<Scalars['String']>
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>
}

/** Contains information about discounts applied to the cart. */
export type CartDiscount = {
  __typename?: 'CartDiscount'
  /** The amount of the discount applied to the item. */
  amount: Money
  /** The description of the discount. */
  label: Array<Maybe<Scalars['String']>>
}

export type CartItemAttributes = {
  __typename?: 'CartItemAttributes'
  description?: Maybe<Scalars['String']>
  dfh_autoship_interval?: Maybe<Scalars['Int']>
  dfh_order_type?: Maybe<Scalars['Int']>
  dosage?: Maybe<Scalars['String']>
  flavor?: Maybe<Scalars['String']>
  flavor_size?: Maybe<Scalars['String']>
  heat_sensitive?: Maybe<Scalars['Int']>
  prop65_message?: Maybe<Scalars['String']>
  prop_sixty_five?: Maybe<Scalars['Int']>
  short_description?: Maybe<Scalars['String']>
  size?: Maybe<Scalars['String']>
  thumbnail?: Maybe<Scalars['String']>
}

export type CartItemError = {
  __typename?: 'CartItemError'
  /** An error code that describes the error encountered */
  code: CartItemErrorType
  /** A localized error message */
  message: Scalars['String']
}

export const CartItemErrorType = {
  ItemIncrements: 'ITEM_INCREMENTS',
  ItemQty: 'ITEM_QTY',
  Undefined: 'UNDEFINED',
} as const

export type CartItemErrorType = (typeof CartItemErrorType)[keyof typeof CartItemErrorType]
/** Defines an item to be added to the cart. */
export type CartItemInput = {
  dfh_autoship_interval?: InputMaybe<Scalars['Int']>
  dfh_order_type?: InputMaybe<Scalars['Int']>
  /** An array of entered options for the base product, such as personalization text. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>
  /** For a child product, the SKU of its parent product. */
  parent_sku?: InputMaybe<Scalars['String']>
  /** The amount or number of an item to add. */
  quantity: Scalars['Float']
  /** The selected options for the base product, such as color or size, using the unique ID for an object such as `CustomizableRadioOption`, `CustomizableDropDownOption`, or `ConfigurableProductOptionsValues`. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  /** The SKU of the product. */
  sku: Scalars['String']
}

/** An interface for products in a cart. */
export type CartItemInterface = {
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']
  /** Cart item attributes */
  item_attributes?: Maybe<CartItemAttributes>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']
}

/** Contains details about the price of the item, including taxes and discounts. */
export type CartItemPrices = {
  __typename?: 'CartItemPrices'
  /** An array of discounts to be applied to the cart item. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** An array of FPTs applied to the cart item. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: Money
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: Money
  /** The value of the price multiplied by the quantity of the item. */
  row_total: Money
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: Money
  /** The total of all discounts applied to the item. */
  total_item_discount?: Maybe<Money>
}

/** Deprecated: The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
export type CartItemQuantity = {
  __typename?: 'CartItemQuantity'
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  cart_item_id: Scalars['Int']
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  quantity: Scalars['Float']
}

/** Contains details about the price of a selected customizable value. */
export type CartItemSelectedOptionValuePrice = {
  __typename?: 'CartItemSelectedOptionValuePrice'
  /** Indicates whether the price type is fixed, percent, or dynamic. */
  type: PriceTypeEnum
  /** A string that describes the unit of the value. */
  units: Scalars['String']
  /** A price value. */
  value: Scalars['Float']
}

/** A single item to be updated. */
export type CartItemUpdateInput = {
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']>
  /** The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']>
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  dfh_autoship_interval?: InputMaybe<Scalars['Int']>
  dfh_order_type?: InputMaybe<Scalars['Int']>
  /** Gift message details for the cart item */
  gift_message?: InputMaybe<GiftMessageInput>
  /** The new quantity of the item. */
  quantity?: InputMaybe<Scalars['Float']>
}

/** Contains details about the final price of items in the cart, including discount and tax information. */
export type CartPrices = {
  __typename?: 'CartPrices'
  /** An array containing the names and amounts of taxes applied to each item in the cart. */
  applied_taxes?: Maybe<Array<Maybe<CartTaxItem>>>
  /** Amount for Colorado Retail Delivery Fee if applicable */
  colorado_retail_delivery_fee?: Maybe<Money>
  /** @deprecated Use discounts instead. */
  discount?: Maybe<CartDiscount>
  /** An array containing cart rule discounts, store credit and gift cards applied to the cart. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The total, including discounts, taxes, shipping, and other fees. */
  grand_total?: Maybe<Money>
  /** Multiple Coupons Segments */
  segments?: Maybe<MultipleCouponsQuote>
  /** The subtotal without any applied taxes. */
  subtotal_excluding_tax?: Maybe<Money>
  /** The subtotal including any applied taxes. */
  subtotal_including_tax?: Maybe<Money>
  /** The subtotal with any discounts applied, but not taxes. */
  subtotal_with_discount_excluding_tax?: Maybe<Money>
}

/** Contains tax information about an item in the cart. */
export type CartTaxItem = {
  __typename?: 'CartTaxItem'
  /** The amount of tax applied to the item. */
  amount: Money
  /** The description of the tax. */
  label: Scalars['String']
}

/** An error encountered while adding an item to the the cart. */
export type CartUserInputError = {
  __typename?: 'CartUserInputError'
  /** A cart-specific error code. */
  code: CartUserInputErrorType
  /** A localized error message. */
  message: Scalars['String']
}

export const CartUserInputErrorType = {
  InsufficientStock: 'INSUFFICIENT_STOCK',
  NotSalable: 'NOT_SALABLE',
  ProductNotFound: 'PRODUCT_NOT_FOUND',
  Undefined: 'UNDEFINED',
} as const

export type CartUserInputErrorType =
  (typeof CartUserInputErrorType)[keyof typeof CartUserInputErrorType]
/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type CategoryFilterInput = {
  /** Filter by the unique category ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>
  /** Deprecated: use 'category_uid' to filter uniquely identifiers of categories. */
  ids?: InputMaybe<FilterEqualTypeInput>
  /** Filter by the display name of the category. */
  name?: InputMaybe<FilterMatchTypeInput>
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_category_uid?: InputMaybe<FilterEqualTypeInput>
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_id?: InputMaybe<FilterEqualTypeInput>
  /** Filter by the part of the URL that identifies the category. */
  url_key?: InputMaybe<FilterEqualTypeInput>
  /** Filter by the URL path for the category. */
  url_path?: InputMaybe<FilterEqualTypeInput>
}

/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterface = {
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']>>>
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars['String']>
  children_count?: Maybe<Scalars['String']>
  /** Contains a category CMS block. */
  cms_block?: Maybe<CmsBlock>
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>
  custom_layout_update_file?: Maybe<Scalars['String']>
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']>
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']>
  display_mode?: Maybe<Scalars['String']>
  filter_price_range?: Maybe<Scalars['Float']>
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>
  image?: Maybe<Scalars['String']>
  include_in_menu?: Maybe<Scalars['Int']>
  is_anchor?: Maybe<Scalars['Int']>
  landing_page?: Maybe<Scalars['Int']>
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']>
  meta_description?: Maybe<Scalars['String']>
  meta_keywords?: Maybe<Scalars['String']>
  meta_title?: Maybe<Scalars['String']>
  /** The display name of the category. */
  name?: Maybe<Scalars['String']>
  /** The full category path. */
  path?: Maybe<Scalars['String']>
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars['String']>
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']>
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars['Int']>
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID']
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars['String']>
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars['String']>
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>
}

/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterfaceProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<ProductAttributeSortInput>
}

/** Contains details about the products assigned to a category. */
export type CategoryProducts = {
  __typename?: 'CategoryProducts'
  /** An array of products that are assigned to the category. */
  items?: Maybe<Array<Maybe<ProductInterface>>>
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']>
}

/** Contains a collection of `CategoryTree` objects and pagination information. */
export type CategoryResult = {
  __typename?: 'CategoryResult'
  /** A list of categories that match the filter criteria. */
  items?: Maybe<Array<Maybe<CategoryTree>>>
  /** An object that includes the `page_info` and `currentPage` values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>
  /** The total number of categories that match the criteria. */
  total_count?: Maybe<Scalars['Int']>
}

/** Contains the hierarchy of categories. */
export type CategoryTree = CategoryInterface &
  RoutableInterface & {
    __typename?: 'CategoryTree'
    available_sort_by?: Maybe<Array<Maybe<Scalars['String']>>>
    /** An array of breadcrumb items. */
    breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
    canonical_url?: Maybe<Scalars['String']>
    /** A tree of child categories. */
    children?: Maybe<Array<Maybe<CategoryTree>>>
    children_count?: Maybe<Scalars['String']>
    /** Contains a category CMS block. */
    cms_block?: Maybe<CmsBlock>
    /**
     * The timestamp indicating when the category was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>
    custom_layout_update_file?: Maybe<Scalars['String']>
    /** The attribute to use for sorting. */
    default_sort_by?: Maybe<Scalars['String']>
    /** An optional description of the category. */
    description?: Maybe<Scalars['String']>
    display_mode?: Maybe<Scalars['String']>
    filter_price_range?: Maybe<Scalars['Float']>
    /**
     * An ID that uniquely identifies the category.
     * @deprecated Use `uid` instead.
     */
    id?: Maybe<Scalars['Int']>
    image?: Maybe<Scalars['String']>
    include_in_menu?: Maybe<Scalars['Int']>
    is_anchor?: Maybe<Scalars['Int']>
    landing_page?: Maybe<Scalars['Int']>
    /** The depth of the category within the tree. */
    level?: Maybe<Scalars['Int']>
    meta_description?: Maybe<Scalars['String']>
    meta_keywords?: Maybe<Scalars['String']>
    meta_title?: Maybe<Scalars['String']>
    /** The display name of the category. */
    name?: Maybe<Scalars['String']>
    /** The full category path. */
    path?: Maybe<Scalars['String']>
    /** The category path within the store. */
    path_in_store?: Maybe<Scalars['String']>
    /** The position of the category relative to other categories at the same level in tree. */
    position?: Maybe<Scalars['Int']>
    /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
    product_count?: Maybe<Scalars['Int']>
    /** The list of products assigned to the category. */
    products?: Maybe<CategoryProducts>
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int']
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /** The unique ID for a `CategoryInterface` object. */
    uid: Scalars['ID']
    /**
     * The timestamp indicating when the category was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>
    /** The URL key assigned to the category. */
    url_key?: Maybe<Scalars['String']>
    /** The URL path assigned to the category. */
    url_path?: Maybe<Scalars['String']>
    /** The part of the category URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>
  }

/** Contains the hierarchy of categories. */
export type CategoryTreeProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<ProductAttributeSortInput>
}

/** Defines details about an individual checkout agreement. */
export type CheckoutAgreement = {
  __typename?: 'CheckoutAgreement'
  /** The ID for a checkout agreement. */
  agreement_id: Scalars['Int']
  /** The checkbox text for the checkout agreement. */
  checkbox_text: Scalars['String']
  /** Required. The text of the agreement. */
  content: Scalars['String']
  /** The height of the text box where the Terms and Conditions statement appears during checkout. */
  content_height?: Maybe<Scalars['String']>
  /** Indicates whether the `content` text is in HTML format. */
  is_html: Scalars['Boolean']
  /** Indicates whether agreements are accepted automatically or manually. */
  mode: CheckoutAgreementMode
  /** The name given to the condition. */
  name: Scalars['String']
}

/** Indicates how agreements are accepted. */
export const CheckoutAgreementMode = {
  /** Conditions are automatically accepted upon checkout. */
  Auto: 'AUTO',
  /** Shoppers must manually accept the conditions to place an order. */
  Manual: 'MANUAL',
} as const

export type CheckoutAgreementMode =
  (typeof CheckoutAgreementMode)[keyof typeof CheckoutAgreementMode]
/** An error encountered while adding an item to the cart. */
export type CheckoutUserInputError = {
  __typename?: 'CheckoutUserInputError'
  /** An error code that is specific to Checkout. */
  code: CheckoutUserInputErrorCodes
  /** A localized error message. */
  message: Scalars['String']
  /** The path to the input field that caused an error. See the GraphQL specification about path errors for details: http://spec.graphql.org/draft/#sec-Errors */
  path: Array<Maybe<Scalars['String']>>
}

export const CheckoutUserInputErrorCodes = {
  InsufficientStock: 'INSUFFICIENT_STOCK',
  NotSalable: 'NOT_SALABLE',
  ProductNotFound: 'PRODUCT_NOT_FOUND',
  ReorderNotAvailable: 'REORDER_NOT_AVAILABLE',
  Undefined: 'UNDEFINED',
} as const

export type CheckoutUserInputErrorCodes =
  (typeof CheckoutUserInputErrorCodes)[keyof typeof CheckoutUserInputErrorCodes]
/** Contains details about a specific CMS block. */
export type CmsBlock = {
  __typename?: 'CmsBlock'
  /** The content of the CMS block in raw HTML. */
  content?: Maybe<Scalars['String']>
  /** The CMS block identifier. */
  identifier?: Maybe<Scalars['String']>
  /** The title assigned to the CMS block. */
  title?: Maybe<Scalars['String']>
}

/** Contains an array CMS block items. */
export type CmsBlocks = {
  __typename?: 'CmsBlocks'
  /** An array of CMS blocks. */
  items?: Maybe<Array<Maybe<CmsBlock>>>
}

/** Contains details about a CMS page. */
export type CmsPage = RoutableInterface & {
  __typename?: 'CmsPage'
  /** The content of the CMS page in raw HTML. */
  content?: Maybe<Scalars['String']>
  /** The heading that displays at the top of the CMS page. */
  content_heading?: Maybe<Scalars['String']>
  /** The ID of a CMS page. */
  identifier?: Maybe<Scalars['String']>
  /** A brief description of the page for search results listings. */
  meta_description?: Maybe<Scalars['String']>
  /** A brief description of the page for search results listings. */
  meta_keywords?: Maybe<Scalars['String']>
  /** A page title that is indexed by search engines and appears in search results listings. */
  meta_title?: Maybe<Scalars['String']>
  /** The design layout of the page, indicating the number of columns and navigation features used on the page. */
  page_layout?: Maybe<Scalars['String']>
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>
  /** The name that appears in the breadcrumb trail navigation and in the browser title bar and tab. */
  title?: Maybe<Scalars['String']>
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>
  /** The URL key of the CMS page, which is often based on the `content_heading`. */
  url_key?: Maybe<Scalars['String']>
}

export type ColorSwatchData = SwatchDataInterface & {
  __typename?: 'ColorSwatchData'
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>
}

/** Contains an attribute code that is used for product comparisons. */
export type ComparableAttribute = {
  __typename?: 'ComparableAttribute'
  /** An attribute code that is enabled for product comparisons. */
  code: Scalars['String']
  /** The label of the attribute code. */
  label: Scalars['String']
}

/** Defines an object used to iterate through items for product comparisons. */
export type ComparableItem = {
  __typename?: 'ComparableItem'
  /** An array of product attributes that can be used to compare products. */
  attributes: Array<Maybe<ProductAttribute>>
  /** Details about a product in a compare list. */
  product: ProductInterface
  /** The unique ID of an item in a compare list. */
  uid: Scalars['ID']
}

/** Contains iterable information such as the array of items, the count, and attributes that represent the compare list. */
export type CompareList = {
  __typename?: 'CompareList'
  /** An array of attributes that can be used for comparing products. */
  attributes?: Maybe<Array<Maybe<ComparableAttribute>>>
  /** The number of items in the compare list. */
  item_count: Scalars['Int']
  /** An array of products to compare. */
  items?: Maybe<Array<Maybe<ComparableItem>>>
  /** The unique ID assigned to the compare list. */
  uid: Scalars['ID']
}

/** Places an order for a referenced Truemed Payment Session. */
export type CompleteTruemedPaymentSessionInput = {
  /** The unique ID of a `Truemed Payment Session`. */
  payment_session_id: Scalars['String']
  /** Base64 encoded application state returned from 'startTruemedPaymentSession' mutation. */
  state: Scalars['String']
}

export type ComplexTextValue = {
  __typename?: 'ComplexTextValue'
  /** Text that can contain HTML tags. */
  html: Scalars['String']
}

/** Contains details about a configurable product attribute option. */
export type ConfigurableAttributeOption = {
  __typename?: 'ConfigurableAttributeOption'
  /** The ID assigned to the attribute. */
  code?: Maybe<Scalars['String']>
  /** A string that describes the configurable attribute option. */
  label?: Maybe<Scalars['String']>
  /** The unique ID for a `ConfigurableAttributeOption` object. */
  uid: Scalars['ID']
  /** A unique index number assigned to the configurable product option. */
  value_index?: Maybe<Scalars['Int']>
}

/** An implementation for configurable product cart items. */
export type ConfigurableCartItem = CartItemInterface & {
  __typename?: 'ConfigurableCartItem'
  /** An array containing the configuranle options the shopper selected. */
  configurable_options: Array<Maybe<SelectedConfigurableOption>>
  /** Product details of the cart item. */
  configured_variant: ProductInterface
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']
  /** Cart item attributes */
  item_attributes?: Maybe<CartItemAttributes>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']
}

/** Describes configurable options that have been selected and can be selected as a result of the previous selections. */
export type ConfigurableOptionAvailableForSelection = {
  __typename?: 'ConfigurableOptionAvailableForSelection'
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String']
  /** An array of selectable option value IDs. */
  option_value_uids: Array<Maybe<Scalars['ID']>>
}

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProduct = CustomizableProductInterface &
  PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'ConfigurableProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    a_z?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    activity?: Maybe<Scalars['String']>
    /** Advisor Tags based on advisor_tags attribute */
    advisor_tags?: Maybe<Array<Maybe<Scalars['String']>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    allow_credit_range?: Maybe<Scalars['Int']>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    category_gear?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    climate?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    collar?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']>
    /** An array of options for the configurable product. */
    configurable_options?: Maybe<Array<Maybe<ConfigurableProductOptions>>>
    /** An array of media gallery items and other details about selected configurable product options as well as details about remaining selectable options. */
    configurable_product_options_selection?: Maybe<ConfigurableProductOptionsSelection>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_public?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_public?: Maybe<Scalars['String']>
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_amount?: Maybe<Scalars['Float']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_rate?: Maybe<Scalars['Float']>
    /** Crosssell Products */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_clinical_trials?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_patient_education?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_tech_sheet?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    eco_collection?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    erin_recommends?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    features_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    format?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['String']>
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    heat_sensitive?: Maybe<Scalars['Int']>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    max_credit?: Maybe<Scalars['Float']>
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    min_credit?: Maybe<Scalars['Float']>
    /** Store Credit product attributes */
    mp_store_credit_attributes?: Maybe<Array<Maybe<StoreCreditProductAttributes>>>
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    natural_product_number?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    new?: Maybe<Scalars['Int']>
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    out_of_stock_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pattern?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    performance_fabric?: Maybe<Scalars['Int']>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    price_range: PriceRange
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>
    /**
     * Product Form based on product_form attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    product_form?: Maybe<Scalars['String']>
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** One of simple, virtual, bundle, downloadable, grouped, or configurable. */
    product_type_id?: Maybe<Scalars['String']>
    /**
     * Prop65 Message
     * @deprecated Use the `custom_attributes` field instead.
     */
    prop65_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    prop_sixty_five?: Maybe<Scalars['Int']>
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars['Float']
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int']
    /** An array of products to be displayed in a Related Products block. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>
    /** The total count of all the reviews given to the product. */
    review_count: Scalars['Int']
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    sale?: Maybe<Scalars['Int']>
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars['Int']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sleeve?: Maybe<Scalars['String']>
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>
    /**
     * Specialty based on specialty attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    specialty?: Maybe<Array<Maybe<Scalars['String']>>>
    /** Stock Item Configuration */
    stock_configuration?: Maybe<StockItemConfiguration>
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>
    /** @deprecated Use the `custom_attributes` field instead. */
    strap_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bottom?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_general?: Maybe<Scalars['String']>
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>
    /** Upsell Products */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>
    /** An index of product variants */
    variant_index?: Maybe<ConfigurableVariantIndex>
    /** An array of simple product variants. */
    variants?: Maybe<Array<Maybe<ConfigurableVariant>>>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']>
  }

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductConfigurable_Product_Options_SelectionArgs = {
  configurableOptionValueUids?: InputMaybe<Array<Scalars['ID']>>
}

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

export type ConfigurableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** The quantity and SKU of the configurable product. */
  data: CartItemInput
  /** The SKU of the parent configurable product. */
  parent_sku?: InputMaybe<Scalars['String']>
  /** Deprecated. Use `CartItemInput.sku` instead. */
  variant_sku?: InputMaybe<Scalars['String']>
}

/** Contains details about configurable product options. */
export type ConfigurableProductOption = {
  __typename?: 'ConfigurableProductOption'
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String']
  /** The display name of the option. */
  label: Scalars['String']
  /** The unique ID of the configurable option. */
  uid: Scalars['ID']
  /** An array of values that are applicable for this option. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionValue>>>
}

/** Defines a value for a configurable product option. */
export type ConfigurableProductOptionValue = {
  __typename?: 'ConfigurableProductOptionValue'
  /** Indicates whether the product is available with this selected option. */
  is_available: Scalars['Boolean']
  /** Indicates whether the value is the default. */
  is_use_default: Scalars['Boolean']
  /** The display name of the value. */
  label: Scalars['String']
  /** The URL assigned to the thumbnail of the swatch image. */
  swatch?: Maybe<SwatchDataInterface>
  /** The unique ID of the value. */
  uid: Scalars['ID']
}

/** Defines configurable attributes for the specified product. */
export type ConfigurableProductOptions = {
  __typename?: 'ConfigurableProductOptions'
  /** A string that identifies the attribute. */
  attribute_code?: Maybe<Scalars['String']>
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id?: Maybe<Scalars['String']>
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id_v2?: Maybe<Scalars['Int']>
  /** The unique ID for an `Attribute` object. */
  attribute_uid: Scalars['ID']
  /**
   * The configurable option ID number assigned by the system.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>
  /** A displayed string that describes the configurable product option. */
  label?: Maybe<Scalars['String']>
  /** A number that indicates the order in which the attribute is displayed. */
  position?: Maybe<Scalars['Int']>
  /**
   * This is the same as a product's `id` field.
   * @deprecated `product_id` is not needed and can be obtained from its parent.
   */
  product_id?: Maybe<Scalars['Int']>
  /** The unique ID for a `ConfigurableProductOptions` object. */
  uid: Scalars['ID']
  /** Indicates whether the option is the default. */
  use_default?: Maybe<Scalars['Boolean']>
  /** An array that defines the `value_index` codes assigned to the configurable product. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionsValues>>>
}

/** Contains metadata corresponding to the selected configurable options. */
export type ConfigurableProductOptionsSelection = {
  __typename?: 'ConfigurableProductOptionsSelection'
  /** An array of all possible configurable options. */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOption>>>
  /** Product images and videos corresponding to the specified configurable options selection. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
  /** The configurable options available for further selection based on the current selection. */
  options_available_for_selection?: Maybe<Array<Maybe<ConfigurableOptionAvailableForSelection>>>
  /** A variant represented by the specified configurable options selection. The value is expected to be null until selections are made for each configurable option. */
  variant?: Maybe<SimpleProduct>
}

/** Contains the index number assigned to a configurable product option. */
export type ConfigurableProductOptionsValues = {
  __typename?: 'ConfigurableProductOptionsValues'
  /** The label of the product on the default store. */
  default_label?: Maybe<Scalars['String']>
  /** The label of the product. */
  label?: Maybe<Scalars['String']>
  /** The label of the product on the current store. */
  store_label?: Maybe<Scalars['String']>
  /** Swatch data for a configurable product option. */
  swatch_data?: Maybe<SwatchDataInterface>
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  uid?: Maybe<Scalars['ID']>
  /** Indicates whether to use the default_label. */
  use_default_value?: Maybe<Scalars['Boolean']>
  /**
   * A unique index number assigned to the configurable product option.
   * @deprecated Use `uid` instead.
   */
  value_index?: Maybe<Scalars['Int']>
}

/** Contains all the simple product variants of a configurable product. */
export type ConfigurableVariant = {
  __typename?: 'ConfigurableVariant'
  /** An array of configurable attribute options. */
  attributes?: Maybe<Array<Maybe<ConfigurableAttributeOption>>>
  /** An array of linked simple products. */
  product?: Maybe<SimpleProduct>
}

/** An index containing all the simple product variants of a configurable product */
export type ConfigurableVariantIndex = {
  __typename?: 'ConfigurableVariantIndex'
  /** An array of used attribute values and available child products */
  attribute_product_list?: Maybe<Scalars['String']>
  /** An array of used attribute values */
  attribute_values?: Maybe<Scalars['String']>
  /** Attribute value to child product mapping */
  mapping?: Maybe<Scalars['String']>
  /** An array of child products of a configurable product with resolved values */
  product_index?: Maybe<Scalars['String']>
  /** An array of used product attributes of a configurable product */
  used_attributes?: Maybe<Array<Maybe<Scalars['String']>>>
}

/** A configurable product wish list item. */
export type ConfigurableWishlistItem = WishlistItemInterface & {
  __typename?: 'ConfigurableWishlistItem'
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']
  /**
   * The SKU of the simple product corresponding to a set of selected configurable options.
   * @deprecated Use `ConfigurableWishlistItem.configured_variant.sku` instead.
   */
  child_sku: Scalars['String']
  /** An array of selected configurable options. */
  configurable_options?: Maybe<Array<Maybe<SelectedConfigurableOption>>>
  /** Product details of the selected variant. The value is null if some options are not configured. */
  configured_variant?: Maybe<ProductInterface>
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']
}

export type Country = {
  __typename?: 'Country'
  /** An array of regions within a particular country. */
  available_regions?: Maybe<Array<Maybe<Region>>>
  /** The name of the country in English. */
  full_name_english?: Maybe<Scalars['String']>
  /** The name of the country in the current locale. */
  full_name_locale?: Maybe<Scalars['String']>
  /** The unique ID for a `Country` object. */
  id?: Maybe<Scalars['String']>
  /** The three-letter abbreviation of the country, such as USA. */
  three_letter_abbreviation?: Maybe<Scalars['String']>
  /** The two-letter abbreviation of the country, such as US. */
  two_letter_abbreviation?: Maybe<Scalars['String']>
}

/** The list of country codes. */
export const CountryCodeEnum = {
  /** Andorra */
  Ad: 'AD',
  /** United Arab Emirates */
  Ae: 'AE',
  /** Afghanistan */
  Af: 'AF',
  /** Antigua & Barbuda */
  Ag: 'AG',
  /** Anguilla */
  Ai: 'AI',
  /** Albania */
  Al: 'AL',
  /** Armenia */
  Am: 'AM',
  /** Netherlands Antilles */
  An: 'AN',
  /** Angola */
  Ao: 'AO',
  /** Antarctica */
  Aq: 'AQ',
  /** Argentina */
  Ar: 'AR',
  /** American Samoa */
  As: 'AS',
  /** Austria */
  At: 'AT',
  /** Australia */
  Au: 'AU',
  /** Aruba */
  Aw: 'AW',
  /** Åland Islands */
  Ax: 'AX',
  /** Azerbaijan */
  Az: 'AZ',
  /** Bosnia & Herzegovina */
  Ba: 'BA',
  /** Barbados */
  Bb: 'BB',
  /** Bangladesh */
  Bd: 'BD',
  /** Belgium */
  Be: 'BE',
  /** Burkina Faso */
  Bf: 'BF',
  /** Bulgaria */
  Bg: 'BG',
  /** Bahrain */
  Bh: 'BH',
  /** Burundi */
  Bi: 'BI',
  /** Benin */
  Bj: 'BJ',
  /** St. Barthélemy */
  Bl: 'BL',
  /** Bermuda */
  Bm: 'BM',
  /** Brunei */
  Bn: 'BN',
  /** Bolivia */
  Bo: 'BO',
  /** Brazil */
  Br: 'BR',
  /** Bahamas */
  Bs: 'BS',
  /** Bhutan */
  Bt: 'BT',
  /** Bouvet Island */
  Bv: 'BV',
  /** Botswana */
  Bw: 'BW',
  /** Belarus */
  By: 'BY',
  /** Belize */
  Bz: 'BZ',
  /** Canada */
  Ca: 'CA',
  /** Cocos (Keeling) Islands */
  Cc: 'CC',
  /** Congo-Kinshasa */
  Cd: 'CD',
  /** Central African Republic */
  Cf: 'CF',
  /** Congo-Brazzaville */
  Cg: 'CG',
  /** Switzerland */
  Ch: 'CH',
  /** Côte d’Ivoire */
  Ci: 'CI',
  /** Cook Islands */
  Ck: 'CK',
  /** Chile */
  Cl: 'CL',
  /** Cameroon */
  Cm: 'CM',
  /** China */
  Cn: 'CN',
  /** Colombia */
  Co: 'CO',
  /** Costa Rica */
  Cr: 'CR',
  /** Cuba */
  Cu: 'CU',
  /** Cape Verde */
  Cv: 'CV',
  /** Christmas Island */
  Cx: 'CX',
  /** Cyprus */
  Cy: 'CY',
  /** Czech Republic */
  Cz: 'CZ',
  /** Germany */
  De: 'DE',
  /** Djibouti */
  Dj: 'DJ',
  /** Denmark */
  Dk: 'DK',
  /** Dominica */
  Dm: 'DM',
  /** Dominican Republic */
  Do: 'DO',
  /** Algeria */
  Dz: 'DZ',
  /** Ecuador */
  Ec: 'EC',
  /** Estonia */
  Ee: 'EE',
  /** Egypt */
  Eg: 'EG',
  /** Western Sahara */
  Eh: 'EH',
  /** Eritrea */
  Er: 'ER',
  /** Spain */
  Es: 'ES',
  /** Ethiopia */
  Et: 'ET',
  /** Finland */
  Fi: 'FI',
  /** Fiji */
  Fj: 'FJ',
  /** Falkland Islands */
  Fk: 'FK',
  /** Micronesia */
  Fm: 'FM',
  /** Faroe Islands */
  Fo: 'FO',
  /** France */
  Fr: 'FR',
  /** Gabon */
  Ga: 'GA',
  /** United Kingdom */
  Gb: 'GB',
  /** Grenada */
  Gd: 'GD',
  /** Georgia */
  Ge: 'GE',
  /** French Guiana */
  Gf: 'GF',
  /** Guernsey */
  Gg: 'GG',
  /** Ghana */
  Gh: 'GH',
  /** Gibraltar */
  Gi: 'GI',
  /** Greenland */
  Gl: 'GL',
  /** Gambia */
  Gm: 'GM',
  /** Guinea */
  Gn: 'GN',
  /** Guadeloupe */
  Gp: 'GP',
  /** Equatorial Guinea */
  Gq: 'GQ',
  /** Greece */
  Gr: 'GR',
  /** South Georgia & South Sandwich Islands */
  Gs: 'GS',
  /** Guatemala */
  Gt: 'GT',
  /** Guam */
  Gu: 'GU',
  /** Guinea-Bissau */
  Gw: 'GW',
  /** Guyana */
  Gy: 'GY',
  /** Hong Kong SAR China */
  Hk: 'HK',
  /** Heard &amp; McDonald Islands */
  Hm: 'HM',
  /** Honduras */
  Hn: 'HN',
  /** Croatia */
  Hr: 'HR',
  /** Haiti */
  Ht: 'HT',
  /** Hungary */
  Hu: 'HU',
  /** Indonesia */
  Id: 'ID',
  /** Ireland */
  Ie: 'IE',
  /** Israel */
  Il: 'IL',
  /** Isle of Man */
  Im: 'IM',
  /** India */
  In: 'IN',
  /** British Indian Ocean Territory */
  Io: 'IO',
  /** Iraq */
  Iq: 'IQ',
  /** Iran */
  Ir: 'IR',
  /** Iceland */
  Is: 'IS',
  /** Italy */
  It: 'IT',
  /** Jersey */
  Je: 'JE',
  /** Jamaica */
  Jm: 'JM',
  /** Jordan */
  Jo: 'JO',
  /** Japan */
  Jp: 'JP',
  /** Kenya */
  Ke: 'KE',
  /** Kyrgyzstan */
  Kg: 'KG',
  /** Cambodia */
  Kh: 'KH',
  /** Kiribati */
  Ki: 'KI',
  /** Comoros */
  Km: 'KM',
  /** St. Kitts & Nevis */
  Kn: 'KN',
  /** North Korea */
  Kp: 'KP',
  /** South Korea */
  Kr: 'KR',
  /** Kuwait */
  Kw: 'KW',
  /** Cayman Islands */
  Ky: 'KY',
  /** Kazakhstan */
  Kz: 'KZ',
  /** Laos */
  La: 'LA',
  /** Lebanon */
  Lb: 'LB',
  /** St. Lucia */
  Lc: 'LC',
  /** Liechtenstein */
  Li: 'LI',
  /** Sri Lanka */
  Lk: 'LK',
  /** Liberia */
  Lr: 'LR',
  /** Lesotho */
  Ls: 'LS',
  /** Lithuania */
  Lt: 'LT',
  /** Luxembourg */
  Lu: 'LU',
  /** Latvia */
  Lv: 'LV',
  /** Libya */
  Ly: 'LY',
  /** Morocco */
  Ma: 'MA',
  /** Monaco */
  Mc: 'MC',
  /** Moldova */
  Md: 'MD',
  /** Montenegro */
  Me: 'ME',
  /** St. Martin */
  Mf: 'MF',
  /** Madagascar */
  Mg: 'MG',
  /** Marshall Islands */
  Mh: 'MH',
  /** Macedonia */
  Mk: 'MK',
  /** Mali */
  Ml: 'ML',
  /** Myanmar (Burma) */
  Mm: 'MM',
  /** Mongolia */
  Mn: 'MN',
  /** Macau SAR China */
  Mo: 'MO',
  /** Northern Mariana Islands */
  Mp: 'MP',
  /** Martinique */
  Mq: 'MQ',
  /** Mauritania */
  Mr: 'MR',
  /** Montserrat */
  Ms: 'MS',
  /** Malta */
  Mt: 'MT',
  /** Mauritius */
  Mu: 'MU',
  /** Maldives */
  Mv: 'MV',
  /** Malawi */
  Mw: 'MW',
  /** Mexico */
  Mx: 'MX',
  /** Malaysia */
  My: 'MY',
  /** Mozambique */
  Mz: 'MZ',
  /** Namibia */
  Na: 'NA',
  /** New Caledonia */
  Nc: 'NC',
  /** Niger */
  Ne: 'NE',
  /** Norfolk Island */
  Nf: 'NF',
  /** Nigeria */
  Ng: 'NG',
  /** Nicaragua */
  Ni: 'NI',
  /** Netherlands */
  Nl: 'NL',
  /** Norway */
  No: 'NO',
  /** Nepal */
  Np: 'NP',
  /** Nauru */
  Nr: 'NR',
  /** Niue */
  Nu: 'NU',
  /** New Zealand */
  Nz: 'NZ',
  /** Oman */
  Om: 'OM',
  /** Panama */
  Pa: 'PA',
  /** Peru */
  Pe: 'PE',
  /** French Polynesia */
  Pf: 'PF',
  /** Papua New Guinea */
  Pg: 'PG',
  /** Philippines */
  Ph: 'PH',
  /** Pakistan */
  Pk: 'PK',
  /** Poland */
  Pl: 'PL',
  /** St. Pierre & Miquelon */
  Pm: 'PM',
  /** Pitcairn Islands */
  Pn: 'PN',
  /** Palestinian Territories */
  Ps: 'PS',
  /** Portugal */
  Pt: 'PT',
  /** Palau */
  Pw: 'PW',
  /** Paraguay */
  Py: 'PY',
  /** Qatar */
  Qa: 'QA',
  /** Réunion */
  Re: 'RE',
  /** Romania */
  Ro: 'RO',
  /** Serbia */
  Rs: 'RS',
  /** Russia */
  Ru: 'RU',
  /** Rwanda */
  Rw: 'RW',
  /** Saudi Arabia */
  Sa: 'SA',
  /** Solomon Islands */
  Sb: 'SB',
  /** Seychelles */
  Sc: 'SC',
  /** Sudan */
  Sd: 'SD',
  /** Sweden */
  Se: 'SE',
  /** Singapore */
  Sg: 'SG',
  /** St. Helena */
  Sh: 'SH',
  /** Slovenia */
  Si: 'SI',
  /** Svalbard & Jan Mayen */
  Sj: 'SJ',
  /** Slovakia */
  Sk: 'SK',
  /** Sierra Leone */
  Sl: 'SL',
  /** San Marino */
  Sm: 'SM',
  /** Senegal */
  Sn: 'SN',
  /** Somalia */
  So: 'SO',
  /** Suriname */
  Sr: 'SR',
  /** São Tomé & Príncipe */
  St: 'ST',
  /** El Salvador */
  Sv: 'SV',
  /** Syria */
  Sy: 'SY',
  /** Swaziland */
  Sz: 'SZ',
  /** Turks & Caicos Islands */
  Tc: 'TC',
  /** Chad */
  Td: 'TD',
  /** French Southern Territories */
  Tf: 'TF',
  /** Togo */
  Tg: 'TG',
  /** Thailand */
  Th: 'TH',
  /** Tajikistan */
  Tj: 'TJ',
  /** Tokelau */
  Tk: 'TK',
  /** Timor-Leste */
  Tl: 'TL',
  /** Turkmenistan */
  Tm: 'TM',
  /** Tunisia */
  Tn: 'TN',
  /** Tonga */
  To: 'TO',
  /** Turkey */
  Tr: 'TR',
  /** Trinidad & Tobago */
  Tt: 'TT',
  /** Tuvalu */
  Tv: 'TV',
  /** Taiwan */
  Tw: 'TW',
  /** Tanzania */
  Tz: 'TZ',
  /** Ukraine */
  Ua: 'UA',
  /** Uganda */
  Ug: 'UG',
  /** U.S. Outlying Islands */
  Um: 'UM',
  /** United States */
  Us: 'US',
  /** Uruguay */
  Uy: 'UY',
  /** Uzbekistan */
  Uz: 'UZ',
  /** Vatican City */
  Va: 'VA',
  /** St. Vincent & Grenadines */
  Vc: 'VC',
  /** Venezuela */
  Ve: 'VE',
  /** British Virgin Islands */
  Vg: 'VG',
  /** U.S. Virgin Islands */
  Vi: 'VI',
  /** Vietnam */
  Vn: 'VN',
  /** Vanuatu */
  Vu: 'VU',
  /** Wallis & Futuna */
  Wf: 'WF',
  /** Samoa */
  Ws: 'WS',
  /** Yemen */
  Ye: 'YE',
  /** Mayotte */
  Yt: 'YT',
  /** South Africa */
  Za: 'ZA',
  /** Zambia */
  Zm: 'ZM',
  /** Zimbabwe */
  Zw: 'ZW',
} as const

export type CountryCodeEnum = (typeof CountryCodeEnum)[keyof typeof CountryCodeEnum]
/** Contains an array of product IDs to use for creating a compare list. */
export type CreateCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
}

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type CreatePayflowProTokenOutput = {
  __typename?: 'CreatePayflowProTokenOutput'
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars['String']
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int']
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars['Int']
  /** A secure token generated by PayPal. */
  secure_token: Scalars['String']
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars['String']
}

/** Defines a new product review. */
export type CreateProductReviewInput = {
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String']
  /** The ratings details by category. For example, Price: 5 stars, Quality: 4 stars, etc. */
  ratings: Array<InputMaybe<ProductReviewRatingInput>>
  /** The SKU of the reviewed product. */
  sku: Scalars['String']
  /** The summary (title) of the review. */
  summary: Scalars['String']
  /** The review text. */
  text: Scalars['String']
}

/** Contains the completed product review. */
export type CreateProductReviewOutput = {
  __typename?: 'CreateProductReviewOutput'
  /** Product review details. */
  review: ProductReview
}

/** Required fields for Payflow Pro and Payments Pro credit card payments. */
export type CreditCardDetailsInput = {
  /** The credit card expiration month. */
  cc_exp_month: Scalars['Int']
  /** The credit card expiration year. */
  cc_exp_year: Scalars['Int']
  /** The last 4 digits of the credit card. */
  cc_last_4: Scalars['Int']
  /** The credit card type. */
  cc_type: Scalars['String']
}

/** Contains credit memo details. */
export type CreditMemo = {
  __typename?: 'CreditMemo'
  /** Comments on the credit memo. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars['ID']
  /** An array containing details about refunded items. */
  items?: Maybe<Array<Maybe<CreditMemoItemInterface>>>
  /** The sequential credit memo number. */
  number: Scalars['String']
  /** Details about the total refunded amount. */
  total?: Maybe<CreditMemoTotal>
}

export type CreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'CreditMemoItem'
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>
}

/** Credit memo item details. */
export type CreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>
}

/** Contains credit memo price details. */
export type CreditMemoTotal = {
  __typename?: 'CreditMemoTotal'
  /** An adjustment manually applied to the order. */
  adjustment: Money
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money
  /** The applied discounts to the credit memo. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money
  /** Details about the shipping and handling costs for the credit memo. */
  shipping_handling?: Maybe<ShippingHandling>
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money
  /** The credit memo tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>
  /** The shipping amount for the credit memo. */
  total_shipping: Money
  /** The amount of tax applied to the credit memo. */
  total_tax: Money
}

export type Currency = {
  __typename?: 'Currency'
  /** An array of three-letter currency codes accepted by the store, such as USD and EUR. */
  available_currency_codes?: Maybe<Array<Maybe<Scalars['String']>>>
  /** The base currency set for the store, such as USD. */
  base_currency_code?: Maybe<Scalars['String']>
  /** The symbol for the specified base currency, such as $. */
  base_currency_symbol?: Maybe<Scalars['String']>
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code?: Maybe<Scalars['String']>
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_symbol?: Maybe<Scalars['String']>
  /** The currency that is displayed by default, such as USD. */
  default_display_currency_code?: Maybe<Scalars['String']>
  /** The currency symbol that is displayed by default, such as $. */
  default_display_currency_symbol?: Maybe<Scalars['String']>
  /** An array of exchange rates for currencies defined in the store. */
  exchange_rates?: Maybe<Array<Maybe<ExchangeRate>>>
}

/** The list of available currency codes. */
export const CurrencyEnum = {
  Aed: 'AED',
  Afn: 'AFN',
  All: 'ALL',
  Amd: 'AMD',
  Ang: 'ANG',
  Aoa: 'AOA',
  Ars: 'ARS',
  Aud: 'AUD',
  Awg: 'AWG',
  Azm: 'AZM',
  Azn: 'AZN',
  Bam: 'BAM',
  Bbd: 'BBD',
  Bdt: 'BDT',
  Bgn: 'BGN',
  Bhd: 'BHD',
  Bif: 'BIF',
  Bmd: 'BMD',
  Bnd: 'BND',
  Bob: 'BOB',
  Brl: 'BRL',
  Bsd: 'BSD',
  Btn: 'BTN',
  Buk: 'BUK',
  Bwp: 'BWP',
  Byn: 'BYN',
  Bzd: 'BZD',
  Cad: 'CAD',
  Cdf: 'CDF',
  Che: 'CHE',
  Chf: 'CHF',
  Chw: 'CHW',
  Clp: 'CLP',
  Cny: 'CNY',
  Cop: 'COP',
  Crc: 'CRC',
  Cup: 'CUP',
  Cve: 'CVE',
  Czk: 'CZK',
  Djf: 'DJF',
  Dkk: 'DKK',
  Dop: 'DOP',
  Dzd: 'DZD',
  Eek: 'EEK',
  Egp: 'EGP',
  Ern: 'ERN',
  Etb: 'ETB',
  Eur: 'EUR',
  Fjd: 'FJD',
  Fkp: 'FKP',
  Gbp: 'GBP',
  Gek: 'GEK',
  Gel: 'GEL',
  Ghs: 'GHS',
  Gip: 'GIP',
  Gmd: 'GMD',
  Gnf: 'GNF',
  Gqe: 'GQE',
  Gtq: 'GTQ',
  Gyd: 'GYD',
  Hkd: 'HKD',
  Hnl: 'HNL',
  Hrk: 'HRK',
  Htg: 'HTG',
  Huf: 'HUF',
  Idr: 'IDR',
  Ils: 'ILS',
  Inr: 'INR',
  Iqd: 'IQD',
  Irr: 'IRR',
  Isk: 'ISK',
  Jmd: 'JMD',
  Jod: 'JOD',
  Jpy: 'JPY',
  Kes: 'KES',
  Kgs: 'KGS',
  Khr: 'KHR',
  Kmf: 'KMF',
  Kpw: 'KPW',
  Krw: 'KRW',
  Kwd: 'KWD',
  Kyd: 'KYD',
  Kzt: 'KZT',
  Lak: 'LAK',
  Lbp: 'LBP',
  Lkr: 'LKR',
  Lrd: 'LRD',
  Lsl: 'LSL',
  Lsm: 'LSM',
  Ltl: 'LTL',
  Lvl: 'LVL',
  Lyd: 'LYD',
  Mad: 'MAD',
  Mdl: 'MDL',
  Mga: 'MGA',
  Mkd: 'MKD',
  Mmk: 'MMK',
  Mnt: 'MNT',
  Mop: 'MOP',
  Mro: 'MRO',
  Mur: 'MUR',
  Mvr: 'MVR',
  Mwk: 'MWK',
  Mxn: 'MXN',
  Myr: 'MYR',
  Mzn: 'MZN',
  Nad: 'NAD',
  Ngn: 'NGN',
  Nic: 'NIC',
  Nok: 'NOK',
  Npr: 'NPR',
  Nzd: 'NZD',
  Omr: 'OMR',
  Pab: 'PAB',
  Pen: 'PEN',
  Pgk: 'PGK',
  Php: 'PHP',
  Pkr: 'PKR',
  Pln: 'PLN',
  Pyg: 'PYG',
  Qar: 'QAR',
  Rhd: 'RHD',
  Rol: 'ROL',
  Ron: 'RON',
  Rsd: 'RSD',
  Rub: 'RUB',
  Rwf: 'RWF',
  Sar: 'SAR',
  Sbd: 'SBD',
  Scr: 'SCR',
  Sdg: 'SDG',
  Sek: 'SEK',
  Sgd: 'SGD',
  Shp: 'SHP',
  Skk: 'SKK',
  Sll: 'SLL',
  Sos: 'SOS',
  Srd: 'SRD',
  Std: 'STD',
  Svc: 'SVC',
  Syp: 'SYP',
  Szl: 'SZL',
  Thb: 'THB',
  Tjs: 'TJS',
  Tmm: 'TMM',
  Tnd: 'TND',
  Top: 'TOP',
  Trl: 'TRL',
  Try: 'TRY',
  Ttd: 'TTD',
  Twd: 'TWD',
  Tzs: 'TZS',
  Uah: 'UAH',
  Ugx: 'UGX',
  Usd: 'USD',
  Uyu: 'UYU',
  Uzs: 'UZS',
  Veb: 'VEB',
  Vef: 'VEF',
  Vnd: 'VND',
  Vuv: 'VUV',
  Wst: 'WST',
  Xcd: 'XCD',
  Xof: 'XOF',
  Xpf: 'XPF',
  Yer: 'YER',
  Ytl: 'YTL',
  Zar: 'ZAR',
  Zmk: 'ZMK',
  Zwd: 'ZWD',
} as const

export type CurrencyEnum = (typeof CurrencyEnum)[keyof typeof CurrencyEnum]
/** Defines an array of custom attributes. */
export type CustomAttributeMetadata = {
  __typename?: 'CustomAttributeMetadata'
  /** An array of attributes. */
  items?: Maybe<Array<Maybe<Attribute>>>
}

/** Defines the customer name, addresses, and other details. */
export type Customer = {
  __typename?: 'Customer'
  /** An array containing the customer's shipping and billing addresses. */
  addresses?: Maybe<Array<Maybe<CustomerAddress>>>
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance: Scalars['Boolean']
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<CompareList>
  /** Timestamp indicating when the account was created. */
  created_at?: Maybe<Scalars['String']>
  /** The customer's date of birth. */
  date_of_birth?: Maybe<Scalars['String']>
  /** The ID assigned to the billing address. */
  default_billing?: Maybe<Scalars['String']>
  /** The ID assigned to the shipping address. */
  default_shipping?: Maybe<Scalars['String']>
  /**
   * The customer's date of birth.
   * @deprecated Use `date_of_birth` instead.
   */
  dob?: Maybe<Scalars['String']>
  /** The customer's email address. Required. */
  email?: Maybe<Scalars['String']>
  /** The customer's first name. */
  firstname?: Maybe<Scalars['String']>
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: Maybe<Scalars['Int']>
  /** @deprecated Customer group should not be exposed in the storefront scenarios. */
  group_id?: Maybe<Scalars['Int']>
  /**
   * The ID assigned to the customer.
   * @deprecated `id` is not needed as part of `Customer`, because on the server side, it can be identified based on the customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id?: Maybe<Scalars['Int']>
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: Maybe<Scalars['Boolean']>
  /** The customer's family name. */
  lastname?: Maybe<Scalars['String']>
  /** The customer's middle name. */
  middlename?: Maybe<Scalars['String']>
  /** Store Credit customer */
  mp_store_credit?: Maybe<MpStoreCreditCustomersOutput>
  orders?: Maybe<CustomerOrders>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>
  /** Contains the customer's product reviews. */
  reviews: ProductReviews
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  taxvat?: Maybe<Scalars['String']>
  vip_discount_name?: Maybe<Scalars['String']>
  /**
   * Return a customer's wish lists.
   * @deprecated Use `Customer.wishlists` or `Customer.wishlist_v2` instead.
   */
  wishlist: Wishlist
  /** Retrieve the wish list identified by the unique ID for a `Wishlist` object. */
  wishlist_v2?: Maybe<Wishlist>
  /** An array of wishlists. In Magento Open Source, customers are limited to one wish list. The number of wish lists is configurable for Adobe Commerce. */
  wishlists: Array<Maybe<Wishlist>>
}

/** Defines the customer name, addresses, and other details. */
export type CustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  filter?: InputMaybe<CustomerOrdersFilterInput>
  pageSize?: InputMaybe<Scalars['Int']>
  scope?: InputMaybe<ScopeTypeEnum>
  sort?: InputMaybe<CustomerOrderSortInput>
}

/** Defines the customer name, addresses, and other details. */
export type CustomerReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

/** Defines the customer name, addresses, and other details. */
export type CustomerWishlist_V2Args = {
  id: Scalars['ID']
}

/** Defines the customer name, addresses, and other details. */
export type CustomerWishlistsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

/** Contains detailed information about a customer's billing or shipping address. */
export type CustomerAddress = {
  __typename?: 'CustomerAddress'
  /** The customer's city or town. */
  city?: Maybe<Scalars['String']>
  /** The customer's company. */
  company?: Maybe<Scalars['String']>
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>
  /**
   * The customer's country.
   * @deprecated Use `country_code` instead.
   */
  country_id?: Maybe<Scalars['String']>
  /** @deprecated Custom attributes should not be put into a container. */
  custom_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>
  /**
   * The customer ID
   * @deprecated `customer_id` is not needed as part of `CustomerAddress`. The `id` is a unique identifier for the addresses.
   */
  customer_id?: Maybe<Scalars['Int']>
  /** Indicates whether the address is the customer's default billing address. */
  default_billing?: Maybe<Scalars['Boolean']>
  /** Indicates whether the address is the customer's default shipping address. */
  default_shipping?: Maybe<Scalars['Boolean']>
  /** Contains any extension attributes for the address. */
  extension_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']>
  /** The first name of the person associated with the shipping/billing address. */
  firstname?: Maybe<Scalars['String']>
  /** The ID of a `CustomerAddress` object. */
  id?: Maybe<Scalars['Int']>
  /** The family name of the person associated with the shipping/billing address. */
  lastname?: Maybe<Scalars['String']>
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']>
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<CustomerAddressRegion>
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>
  /** An array of strings that define the street number and name. */
  street?: Maybe<Array<Maybe<Scalars['String']>>>
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars['String']>
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']>
}

/** Specifies the attribute code and value of a customer address attribute. */
export type CustomerAddressAttribute = {
  __typename?: 'CustomerAddressAttribute'
  /** The name assigned to the customer address attribute. */
  attribute_code?: Maybe<Scalars['String']>
  /** The valuue assigned to the customer address attribute. */
  value?: Maybe<Scalars['String']>
}

/** Specifies the attribute code and value of a customer attribute. */
export type CustomerAddressAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code: Scalars['String']
  /** The value assigned to the attribute. */
  value: Scalars['String']
}

/** Contains details about a billing or shipping address. */
export type CustomerAddressInput = {
  /** The customer's city or town. */
  city?: InputMaybe<Scalars['String']>
  /** The customer's company. */
  company?: InputMaybe<Scalars['String']>
  /** The two-letter code representing the customer's country. */
  country_code?: InputMaybe<CountryCodeEnum>
  /** Deprecated: use `country_code` instead. */
  country_id?: InputMaybe<CountryCodeEnum>
  /** Deprecated: Custom attributes should not be put into container. */
  custom_attributes?: InputMaybe<Array<InputMaybe<CustomerAddressAttributeInput>>>
  /** Indicates whether the address is the default billing address. */
  default_billing?: InputMaybe<Scalars['Boolean']>
  /** Indicates whether the address is the default shipping address. */
  default_shipping?: InputMaybe<Scalars['Boolean']>
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars['String']>
  /** The first name of the person associated with the billing/shipping address. */
  firstname?: InputMaybe<Scalars['String']>
  /** The family name of the person associated with the billing/shipping address. */
  lastname?: InputMaybe<Scalars['String']>
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars['String']>
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars['String']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<CustomerAddressRegionInput>
  /** An array of strings that define the street number and name. */
  street?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>
  /** The customer's telephone number. */
  telephone?: InputMaybe<Scalars['String']>
  /** The customer's Tax/VAT number (for corporate customers). */
  vat_id?: InputMaybe<Scalars['String']>
}

/** Defines the customer's state or province. */
export type CustomerAddressRegion = {
  __typename?: 'CustomerAddressRegion'
  /** The state or province name. */
  region?: Maybe<Scalars['String']>
  /** The address region code. */
  region_code?: Maybe<Scalars['String']>
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>
}

/** Defines the customer's state or province. */
export type CustomerAddressRegionInput = {
  /** The state or province name. */
  region?: InputMaybe<Scalars['String']>
  /** The address region code. */
  region_code?: InputMaybe<Scalars['String']>
  /** The unique ID for a pre-defined region. */
  region_id?: InputMaybe<Scalars['Int']>
}

/** An input object for creating a customer. */
export type CustomerCreateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars['Boolean']>
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>
  /** The customer's email address. */
  email: Scalars['String']
  /** The customer's first name. */
  firstname: Scalars['String']
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>
  /** The customer's family name. */
  lastname: Scalars['String']
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>
}

/** Contains details about a single downloadable product. */
export type CustomerDownloadableProduct = {
  __typename?: 'CustomerDownloadableProduct'
  /** The date and time the purchase was made. */
  date?: Maybe<Scalars['String']>
  /** The fully qualified URL to the download file. */
  download_url?: Maybe<Scalars['String']>
  /** The unique ID assigned to the item. */
  order_increment_id?: Maybe<Scalars['String']>
  /** The remaining number of times the customer can download the product. */
  remaining_downloads?: Maybe<Scalars['String']>
  /** Indicates when the product becomes available for download. Options are `Pending` and `Invoiced`. */
  status?: Maybe<Scalars['String']>
}

/** Contains a list of downloadable products. */
export type CustomerDownloadableProducts = {
  __typename?: 'CustomerDownloadableProducts'
  /** An array of purchased downloadable items. */
  items?: Maybe<Array<Maybe<CustomerDownloadableProduct>>>
}

/** An input object that assigns or updates customer attributes. */
export type CustomerInput = {
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>
  /** The customer's email address. Required when creating a customer. */
  email?: InputMaybe<Scalars['String']>
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']>
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']>
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>
}

/** Contains details about each of the customer's orders. */
export type CustomerOrder = {
  __typename?: 'CustomerOrder'
  /** The billing address for the order. */
  billing_address?: Maybe<OrderAddress>
  /** The shipping carrier for the order delivery. */
  carrier?: Maybe<Scalars['String']>
  /** Comments about the order. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>
  /** @deprecated Use the `order_date` field instead. */
  created_at?: Maybe<Scalars['String']>
  /** A list of credit memos. */
  credit_memos?: Maybe<Array<Maybe<CreditMemo>>>
  /** The entered gift message for the order */
  gift_message?: Maybe<GiftMessage>
  /** @deprecated Use the `totals.grand_total` field instead. */
  grand_total?: Maybe<Scalars['Float']>
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars['ID']
  /** @deprecated Use the `id` field instead. */
  increment_id?: Maybe<Scalars['String']>
  /** A list of invoices for the order. */
  invoices: Array<Maybe<Invoice>>
  /** An array containing the items purchased in this order. */
  items?: Maybe<Array<Maybe<OrderItemInterface>>>
  /** The order number. */
  number: Scalars['String']
  /** The date the order was placed. */
  order_date: Scalars['String']
  /** @deprecated Use the `number` field instead. */
  order_number: Scalars['String']
  /** Payment details for the order. */
  payment_methods?: Maybe<Array<Maybe<OrderPaymentMethod>>>
  /** A list of shipments for the order. */
  shipments?: Maybe<Array<Maybe<OrderShipment>>>
  /** The shipping address for the order. */
  shipping_address?: Maybe<OrderAddress>
  /** The delivery method for the order. */
  shipping_method?: Maybe<Scalars['String']>
  /** The current status of the order. */
  status: Scalars['String']
  /** Details about the calculated totals for this order. */
  total?: Maybe<OrderTotal>
}

/** CustomerOrderSortInput specifies the field to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type CustomerOrderSortInput = {
  /** This enumeration indicates whether to return results in ascending or descending order */
  sort_direction: SortEnum
  /** Specifies the field to use for sorting */
  sort_field: CustomerOrderSortableField
}

/** Specifies the field to use for sorting */
export const CustomerOrderSortableField = {
  /** Sorts customer orders by created_at field */
  CreatedAt: 'CREATED_AT',
  /** Sorts customer orders by number */
  Number: 'NUMBER',
} as const

export type CustomerOrderSortableField =
  (typeof CustomerOrderSortableField)[keyof typeof CustomerOrderSortableField]
/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrders = {
  __typename?: 'CustomerOrders'
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>
  /** The total count of customer orders. */
  total_count?: Maybe<Scalars['Int']>
}

/** Identifies the filter to use for filtering orders. */
export type CustomerOrdersFilterInput = {
  /** Filters by order number. */
  number?: InputMaybe<FilterStringTypeInput>
}

/** Contains details about a newly-created or updated customer. */
export type CustomerOutput = {
  __typename?: 'CustomerOutput'
  /** Customer details after creating or updating a customer. */
  customer: Customer
}

/** Contains payment tokens stored in the customer's vault. */
export type CustomerPaymentTokens = {
  __typename?: 'CustomerPaymentTokens'
  /** An array of payment tokens. */
  items: Array<Maybe<PaymentToken>>
}

/** Contains a customer authorization token. */
export type CustomerToken = {
  __typename?: 'CustomerToken'
  /** The customer authorization token. */
  token?: Maybe<Scalars['String']>
}

/** An input object for updating a customer. */
export type CustomerUpdateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars['Boolean']>
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']>
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']>
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>
}

/** Contains information about a text area that is defined as part of a customizable option. */
export type CustomizableAreaOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableAreaOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']
  /** An object that defines a text area. */
  value?: Maybe<CustomizableAreaValue>
}

/** Defines the price and sku of a product whose page contains a customized text area. */
export type CustomizableAreaValue = {
  __typename?: 'CustomizableAreaValue'
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableAreaValue` object. */
  uid: Scalars['ID']
}

/** Contains information about a set of checkbox values that are defined as part of a customizable option. */
export type CustomizableCheckboxOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableCheckboxOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']
  /** An array that defines a set of checkbox values. */
  value?: Maybe<Array<Maybe<CustomizableCheckboxValue>>>
}

/** Defines the price and sku of a product whose page contains a customized set of checkbox values. */
export type CustomizableCheckboxValue = {
  __typename?: 'CustomizableCheckboxValue'
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>
  /** The order in which the checkbox value is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableCheckboxValue` object. */
  uid: Scalars['ID']
}

/** Contains information about a date picker that is defined as part of a customizable option. */
export type CustomizableDateOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDateOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']
  /** An object that defines a date field in a customizable option. */
  value?: Maybe<CustomizableDateValue>
}

/** Defines the customizable date type. */
export const CustomizableDateTypeEnum = {
  Date: 'DATE',
  DateTime: 'DATE_TIME',
  Time: 'TIME',
} as const

export type CustomizableDateTypeEnum =
  (typeof CustomizableDateTypeEnum)[keyof typeof CustomizableDateTypeEnum]
/** Defines the price and sku of a product whose page contains a customized date picker. */
export type CustomizableDateValue = {
  __typename?: 'CustomizableDateValue'
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>
  /** DATE, DATE_TIME or TIME */
  type?: Maybe<CustomizableDateTypeEnum>
  /** The unique ID for a `CustomizableDateValue` object. */
  uid: Scalars['ID']
}

/** Contains information about a drop down menu that is defined as part of a customizable option. */
export type CustomizableDropDownOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDropDownOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']
  /** An array that defines the set of options for a drop down menu. */
  value?: Maybe<Array<Maybe<CustomizableDropDownValue>>>
}

/** Defines the price and sku of a product whose page contains a customized drop down menu. */
export type CustomizableDropDownValue = {
  __typename?: 'CustomizableDropDownValue'
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableDropDownValue` object. */
  uid: Scalars['ID']
}

/** Contains information about a text field that is defined as part of a customizable option. */
export type CustomizableFieldOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFieldOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']
  /** An object that defines a text field. */
  value?: Maybe<CustomizableFieldValue>
}

/** Defines the price and sku of a product whose page contains a customized text field. */
export type CustomizableFieldValue = {
  __typename?: 'CustomizableFieldValue'
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']>
  /** The price of the custom value. */
  price?: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableFieldValue` object. */
  uid: Scalars['ID']
}

/** Contains information about a file picker that is defined as part of a customizable option. */
export type CustomizableFileOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFileOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']
  /** An object that defines a file value. */
  value?: Maybe<CustomizableFileValue>
}

/** Defines the price and sku of a product whose page contains a customized file picker. */
export type CustomizableFileValue = {
  __typename?: 'CustomizableFileValue'
  /** The file extension to accept. */
  file_extension?: Maybe<Scalars['String']>
  /** The maximum width of an image. */
  image_size_x?: Maybe<Scalars['Int']>
  /** The maximum height of an image. */
  image_size_y?: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableFileValue` object. */
  uid: Scalars['ID']
}

/** Contains information about a multiselect that is defined as part of a customizable option. */
export type CustomizableMultipleOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableMultipleOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']
  /** An array that defines the set of options for a multiselect. */
  value?: Maybe<Array<Maybe<CustomizableMultipleValue>>>
}

/** Defines the price and sku of a product whose page contains a customized multiselect. */
export type CustomizableMultipleValue = {
  __typename?: 'CustomizableMultipleValue'
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableMultipleValue` object. */
  uid: Scalars['ID']
}

/** Defines a customizable option. */
export type CustomizableOptionInput = {
  /** The customizable option ID of the product. */
  id?: InputMaybe<Scalars['Int']>
  /** The string value of the option. */
  value_string: Scalars['String']
}

/** Contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type CustomizableOptionInterface = {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']
}

/** Contains information about customizable product options. */
export type CustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
}

/** Contains information about a set of radio buttons that are defined as part of a customizable option. */
export type CustomizableRadioOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableRadioOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']
  /** An array that defines a set of radio buttons. */
  value?: Maybe<Array<Maybe<CustomizableRadioValue>>>
}

/** Defines the price and sku of a product whose page contains a customized set of radio buttons. */
export type CustomizableRadioValue = {
  __typename?: 'CustomizableRadioValue'
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>
  /** The order in which the radio button is displayed. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `CustomizableRadioValue` object. */
  uid: Scalars['ID']
}

/** Contains the results of the request to delete a compare list. */
export type DeleteCompareListOutput = {
  __typename?: 'DeleteCompareListOutput'
  /** Indicates whether the compare list was successfully deleted. */
  result: Scalars['Boolean']
}

/** Indicates whether the request succeeded and returns the remaining customer payment tokens. */
export type DeletePaymentTokenOutput = {
  __typename?: 'DeletePaymentTokenOutput'
  /** A container for the customer's remaining payment tokens. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>
  /** Indicates whether the request succeeded. */
  result: Scalars['Boolean']
}

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item. */
export type Discount = {
  __typename?: 'Discount'
  /** The amount of the discount. */
  amount: Money
  /** A description of the discount. */
  label: Scalars['String']
}

/** An implementation for downloadable product cart items. */
export type DownloadableCartItem = CartItemInterface & {
  __typename?: 'DownloadableCartItem'
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']
  /** Cart item attributes */
  item_attributes?: Maybe<CartItemAttributes>
  /** An array containing information about the links for the downloadable product added to the cart. */
  links?: Maybe<Array<Maybe<DownloadableProductLinks>>>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']
  /** An array containing information about samples of the selected downloadable product. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']
}

/** Defines downloadable product options for `CreditMemoItemInterface`. */
export type DownloadableCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'DownloadableCreditMemoItem'
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** A list of downloadable links that are refunded from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>
}

export const DownloadableFileTypeEnum = {
  File: 'FILE',
  Url: 'URL',
} as const

export type DownloadableFileTypeEnum =
  (typeof DownloadableFileTypeEnum)[keyof typeof DownloadableFileTypeEnum]
/** Defines downloadable product options for `InvoiceItemInterface`. */
export type DownloadableInvoiceItem = InvoiceItemInterface & {
  __typename?: 'DownloadableInvoiceItem'
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** A list of downloadable links that are invoiced from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>
}

/** Defines characteristics of the links for downloadable product. */
export type DownloadableItemsLinks = {
  __typename?: 'DownloadableItemsLinks'
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name of the link. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `DownloadableItemsLinks` object. */
  uid: Scalars['ID']
}

/** Defines downloadable product options for `OrderItemInterface`. */
export type DownloadableOrderItem = OrderItemInterface & {
  __typename?: 'DownloadableOrderItem'
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** A list of downloadable links that are ordered from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>
}

/** Defines a product that the shopper downloads. */
export type DownloadableProduct = CustomizableProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'DownloadableProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    a_z?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    activity?: Maybe<Scalars['String']>
    /** Advisor Tags based on advisor_tags attribute */
    advisor_tags?: Maybe<Array<Maybe<Scalars['String']>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    allow_credit_range?: Maybe<Scalars['Int']>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    category_gear?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    climate?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    collar?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_public?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_public?: Maybe<Scalars['String']>
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_amount?: Maybe<Scalars['Float']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_rate?: Maybe<Scalars['Float']>
    /** Crosssell Products */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_clinical_trials?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_patient_education?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_tech_sheet?: Maybe<Scalars['String']>
    /** An array containing information about the links for this downloadable product. */
    downloadable_product_links?: Maybe<Array<Maybe<DownloadableProductLinks>>>
    /** An array containing information about samples of this downloadable product. */
    downloadable_product_samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    eco_collection?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    erin_recommends?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    features_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    format?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['String']>
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    heat_sensitive?: Maybe<Scalars['Int']>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /** A value of 1 indicates that each link in the array must be purchased separately. */
    links_purchased_separately?: Maybe<Scalars['Int']>
    /** The heading above the list of downloadable products. */
    links_title?: Maybe<Scalars['String']>
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    max_credit?: Maybe<Scalars['Float']>
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    min_credit?: Maybe<Scalars['Float']>
    /** Store Credit product attributes */
    mp_store_credit_attributes?: Maybe<Array<Maybe<StoreCreditProductAttributes>>>
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    natural_product_number?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    new?: Maybe<Scalars['Int']>
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    out_of_stock_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pattern?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    performance_fabric?: Maybe<Scalars['Int']>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    price_range: PriceRange
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>
    /**
     * Product Form based on product_form attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    product_form?: Maybe<Scalars['String']>
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** One of simple, virtual, bundle, downloadable, grouped, or configurable. */
    product_type_id?: Maybe<Scalars['String']>
    /**
     * Prop65 Message
     * @deprecated Use the `custom_attributes` field instead.
     */
    prop65_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    prop_sixty_five?: Maybe<Scalars['Int']>
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars['Float']
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int']
    /** An array of products to be displayed in a Related Products block. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>
    /** The total count of all the reviews given to the product. */
    review_count: Scalars['Int']
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    sale?: Maybe<Scalars['Int']>
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars['Int']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sleeve?: Maybe<Scalars['String']>
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>
    /**
     * Specialty based on specialty attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    specialty?: Maybe<Array<Maybe<Scalars['String']>>>
    /** Stock Item Configuration */
    stock_configuration?: Maybe<StockItemConfiguration>
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>
    /** @deprecated Use the `custom_attributes` field instead. */
    strap_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bottom?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_general?: Maybe<Scalars['String']>
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>
    /** Upsell Products */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
  }

/** Defines a product that the shopper downloads. */
export type DownloadableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

/** Defines a single downloadable product. */
export type DownloadableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** The quantity and SKU of the downloadable product. */
  data: CartItemInput
  /** An array of objects containing the link_id of the downloadable product link. */
  downloadable_product_links?: InputMaybe<Array<InputMaybe<DownloadableProductLinksInput>>>
}

/** Defines characteristics of a downloadable product. */
export type DownloadableProductLinks = {
  __typename?: 'DownloadableProductLinks'
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']>
  /** @deprecated This information should not be exposed on frontend. */
  is_shareable?: Maybe<Scalars['Boolean']>
  /** @deprecated `sample_url` serves to get the downloadable sample */
  link_type?: Maybe<DownloadableFileTypeEnum>
  /** @deprecated This information should not be exposed on frontend. */
  number_of_downloads?: Maybe<Scalars['Int']>
  /** The price of the downloadable product. */
  price?: Maybe<Scalars['Float']>
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']>
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars['String']>
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name of the link. */
  title?: Maybe<Scalars['String']>
  /** The unique ID for a `DownloadableProductLinks` object. */
  uid: Scalars['ID']
}

/** Contains the link ID for the downloadable product. */
export type DownloadableProductLinksInput = {
  /** The unique ID of the downloadable product link. */
  link_id: Scalars['Int']
}

/** Defines characteristics of a downloadable product. */
export type DownloadableProductSamples = {
  __typename?: 'DownloadableProductSamples'
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']>
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']>
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars['String']>
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']>
  /** The display name of the sample. */
  title?: Maybe<Scalars['String']>
}

/** A downloadable product wish list item. */
export type DownloadableWishlistItem = WishlistItemInterface & {
  __typename?: 'DownloadableWishlistItem'
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']
  /** An array containing information about the selected links. */
  links_v2?: Maybe<Array<Maybe<DownloadableProductLinks>>>
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']
  /** An array containing information about the selected samples. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>
}

/** Defines a customer-entered option. */
export type EnteredOptionInput = {
  /** The unique ID for a `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  uid: Scalars['ID']
  /** Text the customer entered. */
  value: Scalars['String']
}

/** Contains the `uid`, `relative_url`, and `type` attributes. */
export type EntityUrl = {
  __typename?: 'EntityUrl'
  /** @deprecated Use `relative_url` instead. */
  canonical_url?: Maybe<Scalars['String']>
  /** The unique ID for a `ProductInterface`, `CategoryInterface`, `CmsPage`, or similar object associated with the specified URL. This could be a product, category, or CMS page UID. */
  entity_uid?: Maybe<Scalars['ID']>
  /**
   * The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID.
   * @deprecated Use `entity_uid` instead.
   */
  id?: Maybe<Scalars['Int']>
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode?: Maybe<Scalars['Int']>
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>
}

export type ErrorInterface = {
  /** The returned error message. */
  message: Scalars['String']
}

/** Lists the exchange rate. */
export type ExchangeRate = {
  __typename?: 'ExchangeRate'
  /** Specifies the store’s default currency to exchange to. */
  currency_to?: Maybe<Scalars['String']>
  /** The exchange rate for the store’s default currency. */
  rate?: Maybe<Scalars['Float']>
}

/** Defines a filter that matches the input exactly. */
export type FilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq?: InputMaybe<Scalars['String']>
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

/** Defines a filter that performs a fuzzy search. */
export type FilterMatchTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific SKU, specify a value such as `24-MB01`. */
  match?: InputMaybe<Scalars['String']>
}

/** Defines a filter that matches a range of values, such as prices or dates. */
export type FilterRangeTypeInput = {
  /** Use this attribute to specify the lowest possible value in the range. */
  from?: InputMaybe<Scalars['String']>
  /** Use this attribute to specify the highest possible value in the range. */
  to?: InputMaybe<Scalars['String']>
}

/** Defines a filter for an input string. */
export type FilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq?: InputMaybe<Scalars['String']>
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match?: InputMaybe<Scalars['String']>
}

/** Defines the comparison operators that can be used in a filter. */
export type FilterTypeInput = {
  /** Equals. */
  eq?: InputMaybe<Scalars['String']>
  finset?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** From. Must be used with the `to` field. */
  from?: InputMaybe<Scalars['String']>
  /** Greater than. */
  gt?: InputMaybe<Scalars['String']>
  /** Greater than or equal to. */
  gteq?: InputMaybe<Scalars['String']>
  /** In. The value can contain a set of comma-separated values. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters. */
  like?: InputMaybe<Scalars['String']>
  /** Less than. */
  lt?: InputMaybe<Scalars['String']>
  /** Less than or equal to. */
  lteq?: InputMaybe<Scalars['String']>
  /** More than or equal to. */
  moreq?: InputMaybe<Scalars['String']>
  /** Not equal to. */
  neq?: InputMaybe<Scalars['String']>
  /** Not in. The value can contain a set of comma-separated values. */
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Not null. */
  notnull?: InputMaybe<Scalars['String']>
  /** Is null. */
  null?: InputMaybe<Scalars['String']>
  /** To. Must be used with the `from` field. */
  to?: InputMaybe<Scalars['String']>
}

/** A single FPT that can be applied to a product price. */
export type FixedProductTax = {
  __typename?: 'FixedProductTax'
  /** The amount of the Fixed Product Tax. */
  amount?: Maybe<Money>
  /** The display label assigned to the Fixed Product Tax. */
  label?: Maybe<Scalars['String']>
}

/** Lists display settings for the Fixed Product Tax. */
export const FixedProductTaxDisplaySettings = {
  /** The displayed price does not include the FPT amount. The values of `ProductPrice.fixed_product_taxes` and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price.' */
  ExcludeFptAndIncludeWithDetails: 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS',
  /** The displayed price does not include the FPT amount. The values from `ProductPrice.fixed_product_taxes` are not displayed. This value corresponds to 'Excluding FPT'. */
  ExcludeFptWithoutDetails: 'EXCLUDE_FPT_WITHOUT_DETAILS',
  /** The FPT feature is not enabled. You can omit `ProductPrice.fixed_product_taxes` from your query. */
  FptDisabled: 'FPT_DISABLED',
  /** The displayed price includes the FPT amount without displaying the `ProductPrice.fixed_product_taxes` values. This value corresponds to 'Including FPT only'. */
  IncludeFptWithoutDetails: 'INCLUDE_FPT_WITHOUT_DETAILS',
  /** The displayed price includes the FPT amount while displaying the values of `ProductPrice.fixed_product_taxes` separately. This value corresponds to 'Including FPT and FPT description'. */
  IncludeFptWithDetails: 'INCLUDE_FPT_WITH_DETAILS',
} as const

export type FixedProductTaxDisplaySettings =
  (typeof FixedProductTaxDisplaySettings)[keyof typeof FixedProductTaxDisplaySettings]
/** Identifies which customer requires remote shopping assistance. */
export type GenerateCustomerTokenAsAdminInput = {
  /** The email address of the customer requesting remote shopping assistance. */
  customer_email: Scalars['String']
}

/** Contains the generated customer token. */
export type GenerateCustomerTokenAsAdminOutput = {
  __typename?: 'GenerateCustomerTokenAsAdminOutput'
  /** The generated customer token. */
  customer_token: Scalars['String']
}

export type GenerateFlexJsTokenOutput = {
  __typename?: 'GenerateFlexJsTokenOutput'
  key_id?: Maybe<Scalars['String']>
  key_store?: Maybe<Scalars['String']>
}

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessage = {
  __typename?: 'GiftMessage'
  /** Sender name */
  from: Scalars['String']
  /** Gift message text */
  message: Scalars['String']
  /** Recipient name */
  to: Scalars['String']
}

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessageInput = {
  /** Sender name */
  from: Scalars['String']
  /** Gift message text */
  message: Scalars['String']
  /** Recipient name */
  to: Scalars['String']
}

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProduct = PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'GroupedProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    a_z?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    activity?: Maybe<Scalars['String']>
    /** Advisor Tags based on advisor_tags attribute */
    advisor_tags?: Maybe<Array<Maybe<Scalars['String']>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    allow_credit_range?: Maybe<Scalars['Int']>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    category_gear?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    climate?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    collar?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_public?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_public?: Maybe<Scalars['String']>
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_amount?: Maybe<Scalars['Float']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_rate?: Maybe<Scalars['Float']>
    /** Crosssell Products */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_clinical_trials?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_patient_education?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_tech_sheet?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    eco_collection?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    erin_recommends?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    features_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    format?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['String']>
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    heat_sensitive?: Maybe<Scalars['Int']>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /** An array containing grouped product items. */
    items?: Maybe<Array<Maybe<GroupedProductItem>>>
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    max_credit?: Maybe<Scalars['Float']>
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    min_credit?: Maybe<Scalars['Float']>
    /** Store Credit product attributes */
    mp_store_credit_attributes?: Maybe<Array<Maybe<StoreCreditProductAttributes>>>
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    natural_product_number?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    new?: Maybe<Scalars['Int']>
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    out_of_stock_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pattern?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    performance_fabric?: Maybe<Scalars['Int']>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    price_range: PriceRange
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>
    /**
     * Product Form based on product_form attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    product_form?: Maybe<Scalars['String']>
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** One of simple, virtual, bundle, downloadable, grouped, or configurable. */
    product_type_id?: Maybe<Scalars['String']>
    /**
     * Prop65 Message
     * @deprecated Use the `custom_attributes` field instead.
     */
    prop65_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    prop_sixty_five?: Maybe<Scalars['Int']>
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars['Float']
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int']
    /** An array of products to be displayed in a Related Products block. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>
    /** The total count of all the reviews given to the product. */
    review_count: Scalars['Int']
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    sale?: Maybe<Scalars['Int']>
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars['Int']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sleeve?: Maybe<Scalars['String']>
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>
    /**
     * Specialty based on specialty attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    specialty?: Maybe<Array<Maybe<Scalars['String']>>>
    /** Stock Item Configuration */
    stock_configuration?: Maybe<StockItemConfiguration>
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>
    /** @deprecated Use the `custom_attributes` field instead. */
    strap_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bottom?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_general?: Maybe<Scalars['String']>
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>
    /** Upsell Products */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']>
  }

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

/** Contains information about an individual grouped product item. */
export type GroupedProductItem = {
  __typename?: 'GroupedProductItem'
  /** The relative position of this item compared to the other group items. */
  position?: Maybe<Scalars['Int']>
  /** Details about this product option. */
  product?: Maybe<ProductInterface>
  /** The quantity of this grouped product item. */
  qty?: Maybe<Scalars['Float']>
}

/** A grouped product wish list item. */
export type GroupedProductWishlistItem = WishlistItemInterface & {
  __typename?: 'GroupedProductWishlistItem'
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']
}

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payments Pro Hosted Solution payment method. */
export type HostedProInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. For example, if the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. For example, if the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']
}

/** Contains the secure URL used for the Payments Pro Hosted Solution payment method. */
export type HostedProUrl = {
  __typename?: 'HostedProUrl'
  /** The secure URL generated by PayPal. */
  secure_form_url?: Maybe<Scalars['String']>
}

/** Contains the required input to request the secure URL for Payments Pro Hosted Solution payment. */
export type HostedProUrlInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']
}

/** Contains target path parameters. */
export type HttpQueryParameter = {
  __typename?: 'HttpQueryParameter'
  /** A parameter name. */
  name?: Maybe<Scalars['String']>
  /** A parameter value. */
  value?: Maybe<Scalars['String']>
}

export type ImageSwatchData = SwatchDataInterface & {
  __typename?: 'ImageSwatchData'
  /** The URL assigned to the thumbnail of the swatch image. */
  thumbnail?: Maybe<Scalars['String']>
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>
}

/** Contains an error message when an internal error occurred. */
export type InternalError = ErrorInterface & {
  __typename?: 'InternalError'
  /** The returned error message. */
  message: Scalars['String']
}

/** Contains invoice details. */
export type Invoice = {
  __typename?: 'Invoice'
  /** Comments on the invoice. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>
  /** The unique ID for a `Invoice` object. */
  id: Scalars['ID']
  /** Invoiced product details. */
  items?: Maybe<Array<Maybe<InvoiceItemInterface>>>
  /** Sequential invoice number. */
  number: Scalars['String']
  /** Invoice total amount details. */
  total?: Maybe<InvoiceTotal>
}

export type InvoiceItem = InvoiceItemInterface & {
  __typename?: 'InvoiceItem'
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>
}

/** Contains detailes about invoiced items. */
export type InvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>
}

/** Contains price details from an invoice. */
export type InvoiceTotal = {
  __typename?: 'InvoiceTotal'
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money
  /** The applied discounts to the invoice. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money
  /** Details about the shipping and handling costs for the invoice. */
  shipping_handling?: Maybe<ShippingHandling>
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money
  /** The invoice tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>
  /** The shipping amount for the invoice. */
  total_shipping: Money
  /** The amount of tax applied to the invoice. */
  total_tax: Money
}

/** Contains the result of the `isEmailAvailable` query. */
export type IsEmailAvailableOutput = {
  __typename?: 'IsEmailAvailableOutput'
  /** Indicates whether the specified email address can be used to create a customer. */
  is_email_available?: Maybe<Scalars['Boolean']>
}

/** A list of options of the selected bundle product. */
export type ItemSelectedBundleOption = {
  __typename?: 'ItemSelectedBundleOption'
  /**
   * The unique ID for a `ItemSelectedBundleOption` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID']
  /** The label of the option. */
  label: Scalars['String']
  /** The unique ID for a `ItemSelectedBundleOption` object. */
  uid: Scalars['ID']
  /** A list of products that represent the values of the parent option. */
  values?: Maybe<Array<Maybe<ItemSelectedBundleOptionValue>>>
}

/** A list of values for the selected bundle product. */
export type ItemSelectedBundleOptionValue = {
  __typename?: 'ItemSelectedBundleOptionValue'
  /**
   * The unique ID for a `ItemSelectedBundleOptionValue` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID']
  /** The price of the child bundle product. */
  price: Money
  /** The name of the child bundle product. */
  product_name: Scalars['String']
  /** The SKU of the child bundle product. */
  product_sku: Scalars['String']
  /** The number of this bundle product that were ordered. */
  quantity: Scalars['Float']
  /** The unique ID for a `ItemSelectedBundleOptionValue` object. */
  uid: Scalars['ID']
}

/** Contains a key-value pair. */
export type KeyValue = {
  __typename?: 'KeyValue'
  /** The name part of the key/value pair. */
  name?: Maybe<Scalars['String']>
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars['String']>
}

/** Contains information for rendering layered navigation. */
export type LayerFilter = {
  __typename?: 'LayerFilter'
  /**
   * An array of filter items.
   * @deprecated Use `Aggregation.options` instead.
   */
  filter_items?: Maybe<Array<Maybe<LayerFilterItemInterface>>>
  /**
   * The count of filter items in filter group.
   * @deprecated Use `Aggregation.count` instead.
   */
  filter_items_count?: Maybe<Scalars['Int']>
  /**
   * The name of a layered navigation filter.
   * @deprecated Use `Aggregation.label` instead.
   */
  name?: Maybe<Scalars['String']>
  /**
   * The request variable name for a filter query.
   * @deprecated Use `Aggregation.attribute_code` instead.
   */
  request_var?: Maybe<Scalars['String']>
}

export type LayerFilterItem = LayerFilterItemInterface & {
  __typename?: 'LayerFilterItem'
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']>
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']>
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']>
}

export type LayerFilterItemInterface = {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']>
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']>
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']>
}

/** Defines characteristics about images and videos associated with a specific product. */
export type MediaGalleryEntry = {
  __typename?: 'MediaGalleryEntry'
  /** Details about the content of the media gallery item. */
  content?: Maybe<ProductMediaGalleryEntriesContent>
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>
  /** The path of the image on the server. */
  file?: Maybe<Scalars['String']>
  /**
   * The identifier assigned to the object.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>
  /** The alt text displayed on the storefront when the user points to the image. */
  label?: Maybe<Scalars['String']>
  /** Either `image` or `video`. */
  media_type?: Maybe<Scalars['String']>
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars['String']>>>
  /** The unique ID for a `MediaGalleryEntry` object. */
  uid: Scalars['ID']
  /** Details about the content of a video item. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>
}

/** Contains basic information about a product image or video. */
export type MediaGalleryInterface = {
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>
}

/** Defines a monetary value, including a numeric value and a currency code. */
export type Money = {
  __typename?: 'Money'
  /** A three-letter currency code, such as USD or EUR. */
  currency?: Maybe<CurrencyEnum>
  /** A number expressing a monetary value. */
  value?: Maybe<Scalars['Float']>
}

export type MpFilters = {
  /** Filter From Date. */
  from: Scalars['String']
  /** Period. */
  period_type?: InputMaybe<Scalars['String']>
  /** Show Empty Rows. */
  show_empty_rows?: InputMaybe<Scalars['Boolean']>
  /** Filter Store Id. */
  store_id?: InputMaybe<Scalars['Int']>
  /** Filter To Date. */
  to: Scalars['String']
}

export type MpStoreCreditCustomerTransaction = {
  __typename?: 'MpStoreCreditCustomerTransaction'
  /** Action */
  action?: Maybe<Scalars['String']>
  /** Admin Note */
  admin_note?: Maybe<Scalars['String']>
  /** Amount */
  amount?: Maybe<Scalars['Float']>
  /** Balance */
  balance?: Maybe<Scalars['Float']>
  /** Created At */
  created_at?: Maybe<Scalars['String']>
  /** Customer Id */
  customer_id?: Maybe<Scalars['Int']>
  /** Customer Note */
  customer_note?: Maybe<Scalars['String']>
  /** Order Id */
  order_id?: Maybe<Scalars['Int']>
  /** Status */
  status?: Maybe<Scalars['Int']>
  /** Title */
  title?: Maybe<Scalars['String']>
  /** Transaction Id */
  transaction_id?: Maybe<Scalars['Int']>
}

export type MpStoreCreditCustomerTransactionFilterInput = {
  /** Action */
  action?: InputMaybe<FilterTypeInput>
  /** Admin Note */
  admin_note?: InputMaybe<FilterTypeInput>
  /** Amount */
  amount?: InputMaybe<FilterTypeInput>
  /** Balance */
  balance?: InputMaybe<FilterTypeInput>
  /** Created At */
  created_at?: InputMaybe<FilterTypeInput>
  /** Customer Id */
  customer_id?: InputMaybe<FilterTypeInput>
  /** Customer Note */
  customer_note?: InputMaybe<FilterTypeInput>
  /** Order Id */
  order_id?: InputMaybe<FilterTypeInput>
  /** Status */
  status?: InputMaybe<FilterTypeInput>
  /** Title */
  title?: InputMaybe<FilterTypeInput>
  /** Transaction Id */
  transaction_id?: InputMaybe<FilterTypeInput>
}

export type MpStoreCreditCustomerTransactionListOutput = {
  __typename?: 'MpStoreCreditCustomerTransactionListOutput'
  /** MpStoreCreditCustomerTransaction data is satisfied */
  items?: Maybe<Array<Maybe<MpStoreCreditCustomerTransaction>>>
  /** The total number of results returned when a query is applied */
  total_count?: Maybe<Scalars['Int']>
}

export type MpStoreCreditCustomersOutput = {
  __typename?: 'MpStoreCreditCustomersOutput'
  /** Customer Id */
  customer_id?: Maybe<Scalars['Int']>
  /** Mp Credit Balance */
  mp_credit_balance?: Maybe<Scalars['Float']>
  /** Mp Credit Notification */
  mp_credit_notification?: Maybe<Scalars['Int']>
  /** The query searches for store credit customer. */
  transactions?: Maybe<MpStoreCreditCustomerTransactionListOutput>
}

export type MpStoreCreditCustomersOutputTransactionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  filter?: InputMaybe<MpStoreCreditCustomerTransactionFilterInput>
  pageSize?: InputMaybe<Scalars['Int']>
}

export type MultipleCouponValue = {
  __typename?: 'MultipleCouponValue'
  /** Multiple Coupons Amount */
  amount?: Maybe<Scalars['String']>
  /** Multiple Coupons Code */
  code?: Maybe<Scalars['String']>
  /** Multiple Coupons Label */
  label?: Maybe<Scalars['String']>
}

export type MultipleCouponsData = {
  __typename?: 'MultipleCouponsData'
  /** Multiple Coupons Code */
  code?: Maybe<Scalars['String']>
  /** Multiple Coupons Title */
  title?: Maybe<Scalars['String']>
  /** Multiple Coupons Value */
  value?: Maybe<Array<Maybe<MultipleCouponValue>>>
}

export type MultipleCouponsQuote = {
  __typename?: 'MultipleCouponsQuote'
  /** Multiple Coupons Discount Data */
  mpmultiplecoupons?: Maybe<MultipleCouponsData>
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Spending */
  MpStoreCreditCustomerSpending?: Maybe<Array<Maybe<TotalSegmentsOutput>>>
  /** CreditUpdate */
  MpStoreCreditCustomerUpdate?: Maybe<Scalars['String']>
  /** Add one or more bundle products to the specified cart. We recommend using `addProductsToCart` instead. */
  addBundleProductsToCart?: Maybe<AddBundleProductsToCartOutput>
  /** Add one or more configurable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addConfigurableProductsToCart?: Maybe<AddConfigurableProductsToCartOutput>
  /** Add one or more downloadable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addDownloadableProductsToCart?: Maybe<AddDownloadableProductsToCartOutput>
  /** Add any type of product to the cart. */
  addProductsToCart?: Maybe<AddProductsToCartOutput>
  /** Add products to the specified compare list. */
  addProductsToCompareList?: Maybe<CompareList>
  /** Add one or more products to the specified wish list. This mutation supports all product types. */
  addProductsToWishlist?: Maybe<AddProductsToWishlistOutput>
  /** Add one or more simple products to the specified cart. We recommend using `addProductsToCart` instead. */
  addSimpleProductsToCart?: Maybe<AddSimpleProductsToCartOutput>
  /** Add one or more virtual products to the specified cart. We recommend using `addProductsToCart` instead. */
  addVirtualProductsToCart?: Maybe<AddVirtualProductsToCartOutput>
  /** Add items in the specified wishlist to the customer's cart. */
  addWishlistItemsToCart?: Maybe<AddWishlistItemsToCartOutput>
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponToCart?: Maybe<ApplyCouponToCartOutput>
  /** Assign the specified compare list to the logged in customer. */
  assignCompareListToCustomer?: Maybe<AssignCompareListToCustomerOutput>
  /** Assign a logged-in customer to the specified guest shopping cart. */
  assignCustomerToGuestCart: Cart
  /** Change the password for the logged-in customer. */
  changeCustomerPassword?: Maybe<Customer>
  completeTruemedPaymentSession?: Maybe<PlaceOrderOutput>
  /** Create a new compare list. The compare list is saved for logged in customers. */
  createCompareList?: Maybe<CompareList>
  /** Use `createCustomerV2` instead. */
  createCustomer?: Maybe<CustomerOutput>
  /** Create a billing or shipping address for a customer or guest. */
  createCustomerAddress?: Maybe<CustomerAddress>
  /** Create a customer account. */
  createCustomerV2?: Maybe<CustomerOutput>
  /** Create an empty shopping cart for a guest or logged in user */
  createEmptyCart?: Maybe<Scalars['String']>
  /** Initiate a transaction and receive a token. Use this mutation for Payflow Pro and Payments Pro payment methods */
  createPayflowProToken?: Maybe<CreatePayflowProTokenOutput>
  /** Initiate an Express Checkout transaction and receive a token. Use this mutation for Express Checkout and Payments Standard payment methods. */
  createPaypalExpressToken?: Maybe<PaypalExpressTokenOutput>
  /** Create a product review for the specified product. */
  createProductReview: CreateProductReviewOutput
  /** Create a new stored card */
  createTokenBaseCard?: Maybe<TokenBaseCard>
  /** Delete the specified compare list. */
  deleteCompareList?: Maybe<DeleteCompareListOutput>
  /** Delete customer account */
  deleteCustomer?: Maybe<Scalars['Boolean']>
  /** Delete the billing or shipping address of a customer. */
  deleteCustomerAddress?: Maybe<Scalars['Boolean']>
  /** Delete a customer's payment token. */
  deletePaymentToken?: Maybe<DeletePaymentTokenOutput>
  /** Delete a stored card */
  deleteTokenBaseCard?: Maybe<Scalars['Boolean']>
  /** Generate a token for specified customer. */
  generateCustomerToken?: Maybe<CustomerToken>
  /** Request a customer token so that an administrator can perform remote shopping assistance. */
  generateCustomerTokenAsAdmin?: Maybe<GenerateCustomerTokenAsAdminOutput>
  generateFlexJsToken?: Maybe<GenerateFlexJsTokenOutput>
  /** Handle a payment response and save the payment in Quote. Use this mutation for Payflow Pro and Payments Pro payment methods. */
  handlePayflowProResponse?: Maybe<PayflowProResponseOutput>
  /** Transfer the contents of a guest cart into the cart of a logged-in customer. */
  mergeCarts: Cart
  /** Convert the quote into an order. */
  placeOrder?: Maybe<PlaceOrderOutput>
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponFromCart?: Maybe<RemoveCouponFromCartOutput>
  /** Delete the entire quantity of a specified item from the cart. If you remove all items from the cart, the cart continues to exist. */
  removeItemFromCart?: Maybe<RemoveItemFromCartOutput>
  /** Remove products from the specified compare list. */
  removeProductsFromCompareList?: Maybe<CompareList>
  /** Remove one or more products from the specified wish list. */
  removeProductsFromWishlist?: Maybe<RemoveProductsFromWishlistOutput>
  /** Add all products from a customer's previous order to the cart. */
  reorderItems?: Maybe<ReorderItemsOutput>
  requestApplePaySession?: Maybe<ApplePaymentMerchantSession>
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail?: Maybe<Scalars['Boolean']>
  /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using `requestPasswordResetEmail`. */
  resetPassword?: Maybe<Scalars['Boolean']>
  /** Revoke the customer token. */
  revokeCustomerToken?: Maybe<RevokeCustomerTokenOutput>
  /** Send a message on behalf of a customer to the specified email addresses. */
  sendEmailToFriend?: Maybe<SendEmailToFriendOutput>
  /** Set the billing address on a specific cart. */
  setBillingAddressOnCart?: Maybe<SetBillingAddressOnCartOutput>
  setCartAttributes?: Maybe<SetCartAttributesOnCartOutput>
  setDispensaryPromoCodeOnCart?: Maybe<SetDispensaryPromoCodeOnCartOutput>
  setDropShipOnCart?: Maybe<SetDropShipOnCartOutput>
  setEScriptCampaignOnCart?: Maybe<SetWwOnCartOutput>
  /** Assign the email address of a guest to the cart. */
  setGuestEmailOnCart?: Maybe<SetGuestEmailOnCartOutput>
  setHoldUntilMondayOnCart?: Maybe<SetHoldUntilMondayOnCartOutput>
  setNetSuiteCustomerIdOnCart?: Maybe<SetNetSuiteCustomerIdOnCartOutput>
  /**
   * Set the cart payment method and convert the cart into an order.
   * @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request.
   */
  setPaymentMethodAndPlaceOrder?: Maybe<PlaceOrderOutput>
  /** Apply a payment method to the cart. */
  setPaymentMethodOnCart?: Maybe<SetPaymentMethodOnCartOutput>
  setPractitionerCodeOnCart?: Maybe<SetPractitionerCodeOnCartOutput>
  setReferrerUriOnCart?: Maybe<SetReferrerUriOnCartOutput>
  setShipDateOnCart?: Maybe<SetShipDateOnCartOutput>
  /** Set one or more shipping addresses on a specific cart. */
  setShippingAddressesOnCart?: Maybe<SetShippingAddressesOnCartOutput>
  /** Set one or more delivery methods on a cart. */
  setShippingMethodsOnCart?: Maybe<SetShippingMethodsOnCartOutput>
  setWwIdOnCart?: Maybe<SetWwOnCartOutput>
  setWwPracticeIdOnCart?: Maybe<SetWwOnCartOutput>
  setWwPractitionerIdOnCart?: Maybe<SetWwOnCartOutput>
  setWwStoreIdOnCart?: Maybe<SetWwOnCartOutput>
  /** Rebuild the Shop Pay payment request for a delivery method (DFH-24). */
  shopPaySelectDeliveryMethod?: Maybe<ShopPayPaymentRequestOutput>
  /** Rebuild the Shop Pay payment request for a delivery method type (DFH-24). */
  shopPaySelectDeliveryMethodType?: Maybe<ShopPayPaymentRequestOutput>
  /** Confirm and submit a Shop Pay payment (DesignsForHealth_ShopPay, DFH-28). */
  shopPaySessionConfirm?: Maybe<ShopPaySessionConfirmOutput>
  /** Start a Shop Pay session for the cart (DesignsForHealth_ShopPay, DFH-27). */
  shopPaySessionCreate?: Maybe<ShopPaySessionCreateOutput>
  /** End an Open Shop Pay session when the popup closes; changes nothing in any other state (DFH-29). */
  shopPaySessionEnd?: Maybe<ShopPaySessionEndOutput>
  /** Retire a stuck cart past the minimum duration and hand back a copy to check out with (DFH-119). */
  shopPaySessionStartOver?: Maybe<ShopPaySessionStartOverOutput>
  /** Rebuild the Shop Pay payment request for new discount codes (DFH-24). */
  shopPayUpdateDiscountCode?: Maybe<ShopPayPaymentRequestOutput>
  /** Rebuild the Shop Pay payment request for a new shipping address (DFH-24). */
  shopPayUpdateShippingAddress?: Maybe<ShopPayPaymentRequestOutput>
  startTruemedPaymentSession?: Maybe<StartTruemedPaymentSessionOutput>
  /** Subscribe the specified email to the store's newsletter. */
  subscribeEmailToNewsletter?: Maybe<SubscribeEmailToNewsletterOutput>
  /** Modify items in the cart. */
  updateCartItems?: Maybe<UpdateCartItemsOutput>
  /** Use `updateCustomerV2` instead. */
  updateCustomer?: Maybe<CustomerOutput>
  /** Update the billing or shipping address of a customer or guest. */
  updateCustomerAddress?: Maybe<CustomerAddress>
  /** Change the email address for the logged-in customer. */
  updateCustomerEmail?: Maybe<CustomerOutput>
  /** Update the customer's personal information. */
  updateCustomerV2?: Maybe<CustomerOutput>
  /** Update one or more products in the specified wish list. */
  updateProductsInWishlist?: Maybe<UpdateProductsInWishlistOutput>
  /** Update an existing stored card */
  updateTokenBaseCard?: Maybe<TokenBaseCard>
}

export type MutationMpStoreCreditCustomerSpendingArgs = {
  amount: Scalars['Float']
  cart_id: Scalars['String']
}

export type MutationMpStoreCreditCustomerUpdateArgs = {
  amount: Scalars['Float']
}

export type MutationAddBundleProductsToCartArgs = {
  input?: InputMaybe<AddBundleProductsToCartInput>
}

export type MutationAddConfigurableProductsToCartArgs = {
  input?: InputMaybe<AddConfigurableProductsToCartInput>
}

export type MutationAddDownloadableProductsToCartArgs = {
  input?: InputMaybe<AddDownloadableProductsToCartInput>
}

export type MutationAddProductsToCartArgs = {
  cartId: Scalars['String']
  cartItems: Array<CartItemInput>
}

export type MutationAddProductsToCompareListArgs = {
  input?: InputMaybe<AddProductsToCompareListInput>
}

export type MutationAddProductsToWishlistArgs = {
  wishlistId: Scalars['ID']
  wishlistItems: Array<WishlistItemInput>
}

export type MutationAddSimpleProductsToCartArgs = {
  input?: InputMaybe<AddSimpleProductsToCartInput>
}

export type MutationAddVirtualProductsToCartArgs = {
  input?: InputMaybe<AddVirtualProductsToCartInput>
}

export type MutationAddWishlistItemsToCartArgs = {
  wishlistId: Scalars['ID']
  wishlistItemIds?: InputMaybe<Array<Scalars['ID']>>
}

export type MutationApplyCouponToCartArgs = {
  input?: InputMaybe<ApplyCouponToCartInput>
}

export type MutationAssignCompareListToCustomerArgs = {
  uid: Scalars['ID']
}

export type MutationAssignCustomerToGuestCartArgs = {
  cart_id: Scalars['String']
}

export type MutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars['String']
  newPassword: Scalars['String']
}

export type MutationCompleteTruemedPaymentSessionArgs = {
  input?: InputMaybe<CompleteTruemedPaymentSessionInput>
}

export type MutationCreateCompareListArgs = {
  input?: InputMaybe<CreateCompareListInput>
}

export type MutationCreateCustomerArgs = {
  input: CustomerInput
}

export type MutationCreateCustomerAddressArgs = {
  input: CustomerAddressInput
}

export type MutationCreateCustomerV2Args = {
  input: CustomerCreateInput
}

export type MutationCreateEmptyCartArgs = {
  input?: InputMaybe<CreateEmptyCartInput>
}

export type MutationCreatePayflowProTokenArgs = {
  input: PayflowProTokenInput
}

export type MutationCreatePaypalExpressTokenArgs = {
  input: PaypalExpressTokenInput
}

export type MutationCreateProductReviewArgs = {
  input: CreateProductReviewInput
}

export type MutationCreateTokenBaseCardArgs = {
  input: TokenBaseCardCreateInput
}

export type MutationDeleteCompareListArgs = {
  uid: Scalars['ID']
}

export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['Int']
}

export type MutationDeletePaymentTokenArgs = {
  public_hash: Scalars['String']
}

export type MutationDeleteTokenBaseCardArgs = {
  hash: Scalars['String']
}

export type MutationGenerateCustomerTokenArgs = {
  email: Scalars['String']
  password: Scalars['String']
}

export type MutationGenerateCustomerTokenAsAdminArgs = {
  input: GenerateCustomerTokenAsAdminInput
}

export type MutationHandlePayflowProResponseArgs = {
  input: PayflowProResponseInput
}

export type MutationMergeCartsArgs = {
  destination_cart_id?: InputMaybe<Scalars['String']>
  source_cart_id: Scalars['String']
}

export type MutationPlaceOrderArgs = {
  input?: InputMaybe<PlaceOrderInput>
}

export type MutationRemoveCouponFromCartArgs = {
  input?: InputMaybe<RemoveCouponFromCartInput>
}

export type MutationRemoveItemFromCartArgs = {
  input?: InputMaybe<RemoveItemFromCartInput>
}

export type MutationRemoveProductsFromCompareListArgs = {
  input?: InputMaybe<RemoveProductsFromCompareListInput>
}

export type MutationRemoveProductsFromWishlistArgs = {
  wishlistId: Scalars['ID']
  wishlistItemsIds: Array<Scalars['ID']>
}

export type MutationReorderItemsArgs = {
  orderNumber: Scalars['String']
}

export type MutationRequestApplePaySessionArgs = {
  validationUrl?: InputMaybe<Scalars['String']>
}

export type MutationRequestPasswordResetEmailArgs = {
  email: Scalars['String']
}

export type MutationResetPasswordArgs = {
  email: Scalars['String']
  newPassword: Scalars['String']
  resetPasswordToken: Scalars['String']
}

export type MutationSendEmailToFriendArgs = {
  input?: InputMaybe<SendEmailToFriendInput>
}

export type MutationSetBillingAddressOnCartArgs = {
  input?: InputMaybe<SetBillingAddressOnCartInput>
}

export type MutationSetCartAttributesArgs = {
  input?: InputMaybe<SetCartAttributesOnCartInput>
}

export type MutationSetDispensaryPromoCodeOnCartArgs = {
  input?: InputMaybe<SetDispensaryPromoCodeOnCartInput>
}

export type MutationSetDropShipOnCartArgs = {
  input?: InputMaybe<SetDropShipOnCartInput>
}

export type MutationSetEScriptCampaignOnCartArgs = {
  input?: InputMaybe<SetEScriptCampaignOnCartInput>
}

export type MutationSetGuestEmailOnCartArgs = {
  input?: InputMaybe<SetGuestEmailOnCartInput>
}

export type MutationSetHoldUntilMondayOnCartArgs = {
  input?: InputMaybe<SetHoldUntilMondayOnCartInput>
}

export type MutationSetNetSuiteCustomerIdOnCartArgs = {
  input?: InputMaybe<SetNetSuiteCustomerIdOnCartInput>
}

export type MutationSetPaymentMethodAndPlaceOrderArgs = {
  input?: InputMaybe<SetPaymentMethodAndPlaceOrderInput>
}

export type MutationSetPaymentMethodOnCartArgs = {
  input?: InputMaybe<SetPaymentMethodOnCartInput>
}

export type MutationSetPractitionerCodeOnCartArgs = {
  input?: InputMaybe<SetPractitionerCodeOnCartInput>
}

export type MutationSetReferrerUriOnCartArgs = {
  input?: InputMaybe<SetReferrerUriOnCartInput>
}

export type MutationSetShipDateOnCartArgs = {
  input?: InputMaybe<SetShipDateOnCartInput>
}

export type MutationSetShippingAddressesOnCartArgs = {
  input?: InputMaybe<SetShippingAddressesOnCartInput>
}

export type MutationSetShippingMethodsOnCartArgs = {
  input?: InputMaybe<SetShippingMethodsOnCartInput>
}

export type MutationSetWwIdOnCartArgs = {
  input?: InputMaybe<SetWwIdOnCartInput>
}

export type MutationSetWwPracticeIdOnCartArgs = {
  input?: InputMaybe<SetWwPracticeIdOnCartInput>
}

export type MutationSetWwPractitionerIdOnCartArgs = {
  input?: InputMaybe<SetWwPractitionerIdOnCartInput>
}

export type MutationSetWwStoreIdOnCartArgs = {
  input?: InputMaybe<SetWwStoreIdOnCartInput>
}

export type MutationShopPaySelectDeliveryMethodArgs = {
  input: ShopPaySelectDeliveryMethodInput
}

export type MutationShopPaySelectDeliveryMethodTypeArgs = {
  input: ShopPaySelectDeliveryMethodTypeInput
}

export type MutationShopPaySessionConfirmArgs = {
  input: ShopPaySessionConfirmInput
}

export type MutationShopPaySessionCreateArgs = {
  input: ShopPaySessionCreateInput
}

export type MutationShopPaySessionEndArgs = {
  input: ShopPaySessionEndInput
}

export type MutationShopPaySessionStartOverArgs = {
  input: ShopPaySessionStartOverInput
}

export type MutationShopPayUpdateDiscountCodeArgs = {
  input: ShopPayUpdateDiscountCodeInput
}

export type MutationShopPayUpdateShippingAddressArgs = {
  input: ShopPayUpdateShippingAddressInput
}

export type MutationStartTruemedPaymentSessionArgs = {
  input?: InputMaybe<StartTruemedPaymentSessionInput>
}

export type MutationSubscribeEmailToNewsletterArgs = {
  email: Scalars['String']
}

export type MutationUpdateCartItemsArgs = {
  input?: InputMaybe<UpdateCartItemsInput>
}

export type MutationUpdateCustomerArgs = {
  input: CustomerInput
}

export type MutationUpdateCustomerAddressArgs = {
  id: Scalars['Int']
  input?: InputMaybe<CustomerAddressInput>
}

export type MutationUpdateCustomerEmailArgs = {
  email: Scalars['String']
  password: Scalars['String']
}

export type MutationUpdateCustomerV2Args = {
  input: CustomerUpdateInput
}

export type MutationUpdateProductsInWishlistArgs = {
  wishlistId: Scalars['ID']
  wishlistItems: Array<WishlistItemUpdateInput>
}

export type MutationUpdateTokenBaseCardArgs = {
  input: TokenBaseCardUpdateInput
}

/** Contains an error message when an invalid UID was specified. */
export type NoSuchEntityUidError = ErrorInterface & {
  __typename?: 'NoSuchEntityUidError'
  /** The returned error message. */
  message: Scalars['String']
  /** The specified invalid unique ID of an object. */
  uid: Scalars['ID']
}

/** Contains the order ID. */
export type Order = {
  __typename?: 'Order'
  /** @deprecated Use `order_number` instead. */
  order_id?: Maybe<Scalars['String']>
  /** The unique ID for an `Order` object. */
  order_number: Scalars['String']
  /** A 'Payment Status' code returned by the Truemed API. */
  truemed_payment_status?: Maybe<Scalars['String']>
  /** @deprecated A user-friendly message describing the 'Payment Status' code. */
  truemed_payment_status_summary?: Maybe<Scalars['String']>
}

/** Contains detailed information about an order's billing and shipping addresses. */
export type OrderAddress = {
  __typename?: 'OrderAddress'
  /** The city or town. */
  city: Scalars['String']
  /** The customer's company. */
  company?: Maybe<Scalars['String']>
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>
  /** The fax number. */
  fax?: Maybe<Scalars['String']>
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Scalars['String']
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars['String']
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']>
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>
  /** The state or province name. */
  region?: Maybe<Scalars['String']>
  /** The unique ID for a `Region` object of a pre-defined region. */
  region_id?: Maybe<Scalars['ID']>
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']>>
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>
  /** The telephone number. */
  telephone?: Maybe<Scalars['String']>
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']>
}

export type OrderItem = OrderItemInterface & {
  __typename?: 'OrderItem'
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>
}

/** Order item details. */
export type OrderItemInterface = {
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>
}

/** Represents order item options like selected or entered. */
export type OrderItemOption = {
  __typename?: 'OrderItemOption'
  /** The name of the option. */
  label: Scalars['String']
  /** The value of the option. */
  value: Scalars['String']
}

/** Contains details about the payment method used to pay for the order. */
export type OrderPaymentMethod = {
  __typename?: 'OrderPaymentMethod'
  /** Additional data per payment method type. */
  additional_data?: Maybe<Array<Maybe<KeyValue>>>
  /** The label that describes the payment method. */
  name: Scalars['String']
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars['String']
}

/** Contains order shipment details. */
export type OrderShipment = {
  __typename?: 'OrderShipment'
  /** Comments added to the shipment. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars['ID']
  /** An array of items included in the shipment. */
  items?: Maybe<Array<Maybe<ShipmentItemInterface>>>
  /** The sequential credit shipment number. */
  number: Scalars['String']
  /** An array of shipment tracking details. */
  tracking?: Maybe<Array<Maybe<ShipmentTracking>>>
}

/** Contains details about the sales total amounts used to calculate the final price. */
export type OrderTotal = {
  __typename?: 'OrderTotal'
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money
  /** The applied discounts to the order. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money
  /** Details about the shipping and handling costs for the order. */
  shipping_handling?: Maybe<ShippingHandling>
  /** The subtotal of the order, excluding shipping, discounts, and taxes. */
  subtotal: Money
  /** The order tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>
  /** The shipping amount for the order. */
  total_shipping: Money
  /** The amount of tax applied to the order. */
  total_tax: Money
}

/** Contains required input for Payflow Express Checkout payments. */
export type PayflowExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String']
  /** The token returned by the createPaypalExpressToken mutation. */
  token: Scalars['String']
}

/** A set of relative URLs that PayPal uses in response to various actions during the authorization process. Adobe Commerce prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String']
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']
}

/** Indicates the mode for payment. Applies to the Payflow Link and Payments Advanced payment methods. */
export const PayflowLinkMode = {
  Live: 'LIVE',
  Test: 'TEST',
} as const

export type PayflowLinkMode = (typeof PayflowLinkMode)[keyof typeof PayflowLinkMode]
/** Contains information used to generate PayPal iframe for transaction. Applies to Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkToken = {
  __typename?: 'PayflowLinkToken'
  /** The mode for the Payflow transaction. */
  mode?: Maybe<PayflowLinkMode>
  /** The PayPal URL used for requesting a Payflow form. */
  paypal_url?: Maybe<Scalars['String']>
  /** The secure token generated by PayPal. */
  secure_token?: Maybe<Scalars['String']>
  /** The secure token ID generated by PayPal. */
  secure_token_id?: Maybe<Scalars['String']>
}

/** Contains information required to fetch payment token information for the Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String']
}

/** Contains input for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProInput = {
  /** Required input for credit card related information. */
  cc_details: CreditCardDetailsInput
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the PayPal Payflow Pro payment integration. */
  is_active_payment_token_enabler?: InputMaybe<Scalars['Boolean']>
}

/** Input required to complete payment. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProResponseInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']
  /** The payload returned from PayPal. */
  paypal_payload: Scalars['String']
}

export type PayflowProResponseOutput = {
  __typename?: 'PayflowProResponseOutput'
  /** The cart with the updated selected payment method. */
  cart: Cart
}

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProToken = {
  __typename?: 'PayflowProToken'
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars['String']
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int']
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars['Int']
  /** A secure token generated by PayPal. */
  secure_token: Scalars['String']
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars['String']
}

/** Contains input required to fetch payment token information for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProTokenInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']
  /** A set of relative URLs that PayPal uses for callback. */
  urls: PayflowProUrlInput
}

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for the Payflow Pro and Payment Pro payment methods. */
export type PayflowProUrlInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String']
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']
}

/** Defines the payment method. */
export type PaymentMethodInput = {
  /** The internal name for the payment method. */
  code: Scalars['String']
  /** Required input for PayPal Hosted pro payments. */
  hosted_pro?: InputMaybe<HostedProInput>
  /** Required input for Payflow Express Checkout payments. */
  payflow_express?: InputMaybe<PayflowExpressInput>
  /** Required input for PayPal Payflow Link and Payments Advanced payments. */
  payflow_link?: InputMaybe<PayflowLinkInput>
  /** Required input for PayPal Payflow Pro and Payment Pro payments. */
  payflowpro?: InputMaybe<PayflowProInput>
  /** Required input for PayPal Payflow Pro vault payments. */
  payflowpro_cc_vault?: InputMaybe<VaultTokenInput>
  /** Required input for Express Checkout and Payments Standard payments. */
  paypal_express?: InputMaybe<PaypalExpressInput>
  /** The purchase order number. Optional for most payment methods. */
  purchase_order_number?: InputMaybe<Scalars['String']>
  /** TokenBase payment method input */
  tokenbase_data?: InputMaybe<TokenBaseCardPaymentInput>
}

/** The stored payment method available to the customer. */
export type PaymentToken = {
  __typename?: 'PaymentToken'
  /** A description of the stored account details. */
  details?: Maybe<Scalars['String']>
  /** The payment method code associated with the token. */
  payment_method_code: Scalars['String']
  /** The public hash of the token. */
  public_hash: Scalars['String']
  /** Specifies the payment token type. */
  type: PaymentTokenTypeEnum
}

/** The list of available payment token types. */
export const PaymentTokenTypeEnum = {
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  Account: 'account',
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  Card: 'card',
} as const

export type PaymentTokenTypeEnum = (typeof PaymentTokenTypeEnum)[keyof typeof PaymentTokenTypeEnum]
/** Contains required input for Express Checkout and Payments Standard payments. */
export type PaypalExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String']
  /** The token returned by the `createPaypalExpressToken` mutation. */
  token: Scalars['String']
}

/** Deprecated. Use `PaypalExpressTokenOutput` instead. */
export type PaypalExpressToken = {
  __typename?: 'PaypalExpressToken'
  /**
   * A set of URLs that allow the buyer to authorize payment and adjust checkout details.
   * @deprecated Use `PaypalExpressTokenOutput.paypal_urls` instead.
   */
  paypal_urls?: Maybe<PaypalExpressUrlList>
  /**
   * The token returned by PayPal.
   * @deprecated Use `PaypalExpressTokenOutput.token` instead.
   */
  token?: Maybe<Scalars['String']>
}

/** Defines the attributes required to receive a payment token for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String']
  /** The payment method code. */
  code: Scalars['String']
  /** Indicates whether the buyer selected the quick checkout button. The default value is false. */
  express_button?: InputMaybe<Scalars['Boolean']>
  /** A set of relative URLs that PayPal uses in response to various actions during the authorization process. */
  urls: PaypalExpressUrlsInput
  /** Indicates whether the buyer clicked the PayPal credit button. The default value is false. */
  use_paypal_credit?: InputMaybe<Scalars['Boolean']>
}

/** Contains the token returned by PayPal and a set of URLs that allow the buyer to authorize payment and adjust checkout details. Applies to Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenOutput = {
  __typename?: 'PaypalExpressTokenOutput'
  /** A set of URLs that allow the buyer to authorize payment and adjust checkout details. */
  paypal_urls?: Maybe<PaypalExpressUrlList>
  /** The token returned by PayPal. */
  token?: Maybe<Scalars['String']>
}

/** Contains a set of URLs that allow the buyer to authorize payment and adjust checkout details for Express Checkout and Payments Standard transactions. */
export type PaypalExpressUrlList = {
  __typename?: 'PaypalExpressUrlList'
  /** The PayPal URL that allows the buyer to edit their checkout details. */
  edit?: Maybe<Scalars['String']>
  /** The URL to the PayPal login page. */
  start?: Maybe<Scalars['String']>
}

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressUrlsInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']
  /** The relative URL of the page that PayPal redirects to when the payment has been put on hold for additional review. This condition mostly applies to ACH transactions, and is not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success_pending.html, the relative URL is paypal/action/success_pending.html. */
  pending_url?: InputMaybe<Scalars['String']>
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. Not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success.html, the relative URL is paypal/action/success.html. */
  success_url?: InputMaybe<Scalars['String']>
}

/** Contains attributes specific to tangible products. */
export type PhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>
}

/** Defines Pickup Location information. */
export type PickupLocation = {
  __typename?: 'PickupLocation'
  city?: Maybe<Scalars['String']>
  contact_name?: Maybe<Scalars['String']>
  country_id?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  fax?: Maybe<Scalars['String']>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  name?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  pickup_location_code?: Maybe<Scalars['String']>
  postcode?: Maybe<Scalars['String']>
  region?: Maybe<Scalars['String']>
  region_id?: Maybe<Scalars['Int']>
  street?: Maybe<Scalars['String']>
}

/** PickupLocationFilterInput defines the list of attributes and filters for the search. */
export type PickupLocationFilterInput = {
  /** Filter by city. */
  city?: InputMaybe<FilterTypeInput>
  /** Filter by country. */
  country_id?: InputMaybe<FilterTypeInput>
  /** Filter by pickup location name. */
  name?: InputMaybe<FilterTypeInput>
  /** Filter by pickup location code. */
  pickup_location_code?: InputMaybe<FilterTypeInput>
  /** Filter by postcode. */
  postcode?: InputMaybe<FilterTypeInput>
  /** Filter by region. */
  region?: InputMaybe<FilterTypeInput>
  /** Filter by region id. */
  region_id?: InputMaybe<FilterTypeInput>
  /** Filter by street. */
  street?: InputMaybe<FilterTypeInput>
}

/** PickupLocationSortInput specifies attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type PickupLocationSortInput = {
  /** City where pickup location is placed. */
  city?: InputMaybe<SortEnum>
  /** Name of the contact person. */
  contact_name?: InputMaybe<SortEnum>
  /** Id of the country in two letters. */
  country_id?: InputMaybe<SortEnum>
  /** Description of the pickup location. */
  description?: InputMaybe<SortEnum>
  /** Distance to the address, requested by distance filter. Applicable only with distance filter. If distance sort order is present, all other sort orders will be ignored. */
  distance?: InputMaybe<SortEnum>
  /** Contact email of the pickup location. */
  email?: InputMaybe<SortEnum>
  /** Contact fax of the pickup location. */
  fax?: InputMaybe<SortEnum>
  /** Geographic latitude where pickup location is placed. */
  latitude?: InputMaybe<SortEnum>
  /** Geographic longitude where pickup location is placed. */
  longitude?: InputMaybe<SortEnum>
  /** The pickup location name. Customer use this to identify the pickup location. */
  name?: InputMaybe<SortEnum>
  /** Contact phone number of the pickup location. */
  phone?: InputMaybe<SortEnum>
  /** A code assigned to pickup location to identify the source. */
  pickup_location_code?: InputMaybe<SortEnum>
  /** Postcode where pickup location is placed. */
  postcode?: InputMaybe<SortEnum>
  /** Name of the region. */
  region?: InputMaybe<SortEnum>
  /** Id of the region. */
  region_id?: InputMaybe<SortEnum>
  /** Street where pickup location is placed. */
  street?: InputMaybe<SortEnum>
}

/** Top level object returned in a pickup locations search. */
export type PickupLocations = {
  __typename?: 'PickupLocations'
  /** An array of pickup locations that match the specific search request. */
  items?: Maybe<Array<Maybe<PickupLocation>>>
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>
  /** The number of products returned. */
  total_count?: Maybe<Scalars['Int']>
}

/** Specifies the quote to be converted to an order. */
export type PlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** Referral code provided by the front-end and included in order export. */
  dispensary_slug?: InputMaybe<Scalars['String']>
  /** Marketing consent opt-in for guest customers */
  guest_marketing_opt_in?: InputMaybe<Scalars['Boolean']>
  /** Phone number provided when a guest opted in to SMS communications */
  guest_opted_in_sms_number?: InputMaybe<Scalars['String']>
}

/** Contains the results of the request to place an order. */
export type PlaceOrderOutput = {
  __typename?: 'PlaceOrderOutput'
  /** The ID of the order. */
  order: Order
}

/** Deprecated. Use `ProductPrice` instead. Defines the price of a product as well as any tax-related adjustments. */
export type Price = {
  __typename?: 'Price'
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Use `ProductPrice` instead.
   */
  adjustments?: Maybe<Array<Maybe<PriceAdjustment>>>
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Use `ProductPrice` instead.
   */
  amount?: Maybe<Money>
}

/** Deprecated. Taxes will be included or excluded in the price. Defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type PriceAdjustment = {
  __typename?: 'PriceAdjustment'
  /** The amount of the price adjustment and its currency code. */
  amount?: Maybe<Money>
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  code?: Maybe<PriceAdjustmentCodesEnum>
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  description?: Maybe<PriceAdjustmentDescriptionEnum>
}

/** `PriceAdjustment.code` is deprecated. */
export const PriceAdjustmentCodesEnum = {
  Tax: 'TAX',
  Weee: 'WEEE',
  WeeeTax: 'WEEE_TAX',
} as const

export type PriceAdjustmentCodesEnum =
  (typeof PriceAdjustmentCodesEnum)[keyof typeof PriceAdjustmentCodesEnum]
/** `PriceAdjustmentDescriptionEnum` is deprecated. States whether a price adjustment is included or excluded. */
export const PriceAdjustmentDescriptionEnum = {
  Excluded: 'EXCLUDED',
  Included: 'INCLUDED',
} as const

export type PriceAdjustmentDescriptionEnum =
  (typeof PriceAdjustmentDescriptionEnum)[keyof typeof PriceAdjustmentDescriptionEnum]
/** Contains the price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type PriceRange = {
  __typename?: 'PriceRange'
  /** The highest possible price for the product. */
  maximum_price?: Maybe<ProductPrice>
  /** The lowest possible price for the product. */
  minimum_price: ProductPrice
}

/** Defines the price type. */
export const PriceTypeEnum = {
  Dynamic: 'DYNAMIC',
  Fixed: 'FIXED',
  Percent: 'PERCENT',
} as const

export type PriceTypeEnum = (typeof PriceTypeEnum)[keyof typeof PriceTypeEnum]
/** Defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export const PriceViewEnum = {
  AsLowAs: 'AS_LOW_AS',
  PriceRange: 'PRICE_RANGE',
} as const

export type PriceViewEnum = (typeof PriceViewEnum)[keyof typeof PriceViewEnum]
/** Contains a product attribute code and value. */
export type ProductAttribute = {
  __typename?: 'ProductAttribute'
  /** The unique identifier for a product attribute code. */
  code: Scalars['String']
  /** The display value of the attribute. */
  value: Scalars['String']
}

/** ProductAttributeFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductAttributeFilterInput = {
  /** Attribute label: A-Z */
  a_z?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Activity */
  activity?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Category Gear */
  category_gear?: InputMaybe<FilterEqualTypeInput>
  /** Deprecated: use `category_uid` to filter product by category ID. */
  category_id?: InputMaybe<FilterEqualTypeInput>
  /** Filter product by the unique ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Climate */
  climate?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Collar */
  collar?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Color */
  color?: InputMaybe<FilterEqualTypeInput>
  created_at?: InputMaybe<FilterTypeInput>
  /** Attribute label: Description */
  description?: InputMaybe<FilterMatchTypeInput>
  /** Attribute label: Eco Collection */
  eco_collection?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Erin Recommends */
  erin_recommends?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Features */
  features_bags?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Format */
  format?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Gender */
  gender?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Material */
  material?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Product Name */
  name?: InputMaybe<FilterMatchTypeInput>
  /** Attribute label: New */
  new?: InputMaybe<FilterEqualTypeInput>
  /** Filter product by news_from_date. */
  news_from_date?: InputMaybe<FilterTypeInput>
  /** Filter product by news_to_date. */
  news_to_date?: InputMaybe<FilterTypeInput>
  /** Attribute label: Pattern */
  pattern?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Performance Fabric */
  performance_fabric?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Price */
  price?: InputMaybe<FilterRangeTypeInput>
  /** Attribute label: Product Form */
  product_form?: InputMaybe<FilterEqualTypeInput>
  /** One of simple, virtual, bundle, downloadable, grouped, or configurable. */
  product_type_id?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Prop65 Message */
  prop65_message?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Sale */
  sale?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Short Description */
  short_description?: InputMaybe<FilterMatchTypeInput>
  /** Attribute label: Size */
  size?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: SKU */
  sku?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Sleeve */
  sleeve?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Specialty */
  specialty?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Strap/Handle */
  strap_bags?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Style Bags */
  style_bags?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Style Bottom */
  style_bottom?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Style General */
  style_general?: InputMaybe<FilterEqualTypeInput>
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterEqualTypeInput>
}

/** Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. It's possible to sort products using searchable attributes with enabled 'Use in Filter Options' option */
export type ProductAttributeSortInput = {
  /** Attribute label: Product Name */
  name?: InputMaybe<SortEnum>
  /** Sort by the position assigned to each product. */
  position?: InputMaybe<SortEnum>
  /** Attribute label: Price */
  price?: InputMaybe<SortEnum>
  /** Sort by the search relevance score (default). */
  relevance?: InputMaybe<SortEnum>
}

/** Contains the discount applied to a product price. */
export type ProductDiscount = {
  __typename?: 'ProductDiscount'
  /** The actual value of the discount. */
  amount_off?: Maybe<Scalars['Float']>
  /** The discount expressed a percentage. */
  percent_off?: Maybe<Scalars['Float']>
}

/** ProductFilterInput is deprecated, use @ProductAttributeFilterInput instead. ProductFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductFilterInput = {
  /** The category ID the product belongs to. */
  category_id?: InputMaybe<FilterTypeInput>
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<FilterTypeInput>
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<FilterTypeInput>
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<FilterTypeInput>
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<FilterTypeInput>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<FilterTypeInput>
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<FilterTypeInput>
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<FilterTypeInput>
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<FilterTypeInput>
  /** The label assigned to a product image. */
  image_label?: InputMaybe<FilterTypeInput>
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<FilterTypeInput>
  /** The numeric maximal price of the product. Do not include the currency code. */
  max_price?: InputMaybe<FilterTypeInput>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<FilterTypeInput>
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<FilterTypeInput>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<FilterTypeInput>
  /** The numeric minimal price of the product. Do not include the currency code. */
  min_price?: InputMaybe<FilterTypeInput>
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<FilterTypeInput>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<FilterTypeInput>
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<FilterTypeInput>
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<FilterTypeInput>
  /** The keyword required to perform a logical OR comparison. */
  or?: InputMaybe<ProductFilterInput>
  /** The price of an item. */
  price?: InputMaybe<FilterTypeInput>
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<FilterTypeInput>
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<FilterTypeInput>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<FilterTypeInput>
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<FilterTypeInput>
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<FilterTypeInput>
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<FilterTypeInput>
  /** The discounted price of the product. Do not include the currency code. */
  special_price?: InputMaybe<FilterTypeInput>
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<FilterTypeInput>
  /** The file name of a swatch image. */
  swatch_image?: InputMaybe<FilterTypeInput>
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<FilterTypeInput>
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<FilterTypeInput>
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<FilterTypeInput>
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<FilterTypeInput>
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterTypeInput>
  url_path?: InputMaybe<FilterTypeInput>
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<FilterTypeInput>
}

/** Contains product image information, including the image URL and label. */
export type ProductImage = MediaGalleryInterface & {
  __typename?: 'ProductImage'
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>
}

/** Product Information used for Pickup Locations search. */
export type ProductInfoInput = {
  /** Product SKU. */
  sku: Scalars['String']
}

/** Contains fields that are common to all types of products. */
export type ProductInterface = {
  /** @deprecated Use the `custom_attributes` field instead. */
  a_z?: Maybe<Scalars['Int']>
  /** @deprecated Use the `custom_attributes` field instead. */
  activity?: Maybe<Scalars['String']>
  /** Advisor Tags based on advisor_tags attribute */
  advisor_tags?: Maybe<Array<Maybe<Scalars['String']>>>
  /** @deprecated Use the `custom_attributes` field instead. */
  allow_credit_range?: Maybe<Scalars['Int']>
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>
  /** @deprecated Use the `custom_attributes` field instead. */
  category_gear?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  climate?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  collar?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']>
  /** @deprecated Use the `custom_attributes` field instead. */
  content_left_both?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  content_left_patient?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  content_left_professional?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  content_left_public?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  content_right_both?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  content_right_patient?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  content_right_professional?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  content_right_public?: Maybe<Scalars['String']>
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  credit_amount?: Maybe<Scalars['Float']>
  /** @deprecated Use the `custom_attributes` field instead. */
  credit_rate?: Maybe<Scalars['Float']>
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>
  /** @deprecated Use the `custom_attributes` field instead. */
  doc_clinical_trials?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  doc_patient_education?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  doc_tech_sheet?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  eco_collection?: Maybe<Scalars['Int']>
  /** @deprecated Use the `custom_attributes` field instead. */
  erin_recommends?: Maybe<Scalars['Int']>
  /** @deprecated Use the `custom_attributes` field instead. */
  features_bags?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  format?: Maybe<Scalars['Int']>
  /** @deprecated Use the `custom_attributes` field instead. */
  gender?: Maybe<Scalars['String']>
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  heat_sensitive?: Maybe<Scalars['Int']>
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']>
  /** @deprecated Use the `custom_attributes` field instead. */
  material?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  max_credit?: Maybe<Scalars['Float']>
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  min_credit?: Maybe<Scalars['Float']>
  /** Store Credit product attributes */
  mp_store_credit_attributes?: Maybe<Array<Maybe<StoreCreditProductAttributes>>>
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  natural_product_number?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  new?: Maybe<Scalars['Int']>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']>
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  out_of_stock_message?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  pattern?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  performance_fabric?: Maybe<Scalars['Int']>
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>
  /** The range of prices for the product */
  price_range: PriceRange
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>
  /**
   * Product Form based on product_form attribute
   * @deprecated Use the `custom_attributes` field instead.
   */
  product_form?: Maybe<Scalars['String']>
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>
  /** One of simple, virtual, bundle, downloadable, grouped, or configurable. */
  product_type_id?: Maybe<Scalars['String']>
  /**
   * Prop65 Message
   * @deprecated Use the `custom_attributes` field instead.
   */
  prop65_message?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  prop_sixty_five?: Maybe<Scalars['Int']>
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']
  /** The list of products reviews. */
  reviews: ProductReviews
  /** @deprecated Use the `custom_attributes` field instead. */
  sale?: Maybe<Scalars['Int']>
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>
  /** @deprecated Use the `custom_attributes` field instead. */
  size?: Maybe<Scalars['Int']>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  sleeve?: Maybe<Scalars['String']>
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>
  /**
   * Specialty based on specialty attribute
   * @deprecated Use the `custom_attributes` field instead.
   */
  specialty?: Maybe<Array<Maybe<Scalars['String']>>>
  /** Stock Item Configuration */
  stock_configuration?: Maybe<StockItemConfiguration>
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>
  /** @deprecated Use the `custom_attributes` field instead. */
  strap_bags?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  style_bags?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  style_bottom?: Maybe<Scalars['String']>
  /** @deprecated Use the `custom_attributes` field instead. */
  style_general?: Maybe<Scalars['String']>
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>
}

/** Contains fields that are common to all types of products. */
export type ProductInterfaceReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

/** An implementation of `ProductLinksInterface`. */
export type ProductLinks = ProductLinksInterface & {
  __typename?: 'ProductLinks'
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']>
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']>
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']>
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']>
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']>
}

/** Contains information about linked products, including the link type and product type of each item. */
export type ProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']>
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']>
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']>
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']>
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']>
}

/** Contains an image in base64 format and basic information about the image. */
export type ProductMediaGalleryEntriesContent = {
  __typename?: 'ProductMediaGalleryEntriesContent'
  /** The image in base64 format. */
  base64_encoded_data?: Maybe<Scalars['String']>
  /** The file name of the image. */
  name?: Maybe<Scalars['String']>
  /** The MIME type of the file, such as image/png. */
  type?: Maybe<Scalars['String']>
}

/** Contains a link to a video file and basic information about the video. */
export type ProductMediaGalleryEntriesVideoContent = {
  __typename?: 'ProductMediaGalleryEntriesVideoContent'
  /** Must be external-video. */
  media_type?: Maybe<Scalars['String']>
  /** A description of the video. */
  video_description?: Maybe<Scalars['String']>
  /** Optional data about the video. */
  video_metadata?: Maybe<Scalars['String']>
  /** Describes the video source. */
  video_provider?: Maybe<Scalars['String']>
  /** The title of the video. */
  video_title?: Maybe<Scalars['String']>
  /** The URL to the video. */
  video_url?: Maybe<Scalars['String']>
}

/** Represents a product price. */
export type ProductPrice = {
  __typename?: 'ProductPrice'
  /** The price discount. Represents the difference between the regular and final price. */
  discount?: Maybe<ProductDiscount>
  /** The final price of the product after applying discounts. */
  final_price: Money
  /** An array of the multiple Fixed Product Taxes that can be applied to a product price. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>
  /** The regular price of the product. */
  regular_price: Money
}

/** Deprecated. Use `PriceRange` instead. Contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type ProductPrices = {
  __typename?: 'ProductPrices'
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `to` value.
   * @deprecated Use `PriceRange.maximum_price` instead.
   */
  maximalPrice?: Maybe<Price>
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `from` value.
   * @deprecated Use `PriceRange.minimum_price` instead.
   */
  minimalPrice?: Maybe<Price>
  /**
   * The base price of a product.
   * @deprecated Use `regular_price` from `PriceRange.minimum_price` or `PriceRange.maximum_price` instead.
   */
  regularPrice?: Maybe<Price>
}

/** Contains details of a product review. */
export type ProductReview = {
  __typename?: 'ProductReview'
  /** The average of all ratings for this product. */
  average_rating: Scalars['Float']
  /** The date the review was created. */
  created_at: Scalars['String']
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String']
  /** The reviewed product. */
  product: ProductInterface
  /** An array of ratings by rating category, such as quality, price, and value. */
  ratings_breakdown: Array<Maybe<ProductReviewRating>>
  /** The summary (title) of the review. */
  summary: Scalars['String']
  /** The review text. */
  text: Scalars['String']
}

/** Contains data about a single aspect of a product review. */
export type ProductReviewRating = {
  __typename?: 'ProductReviewRating'
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String']
  /** The rating value given by customer. By default, possible values range from 1 to 5. */
  value: Scalars['String']
}

/** Contains the reviewer's rating for a single aspect of a review. */
export type ProductReviewRatingInput = {
  /** An encoded rating ID. */
  id: Scalars['String']
  /** An encoded rating value ID. */
  value_id: Scalars['String']
}

/** Contains details about a single aspect of a product review. */
export type ProductReviewRatingMetadata = {
  __typename?: 'ProductReviewRatingMetadata'
  /** An encoded rating ID. */
  id: Scalars['String']
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String']
  /** List of product review ratings sorted by position. */
  values: Array<Maybe<ProductReviewRatingValueMetadata>>
}

/** Contains details about a single value in a product review. */
export type ProductReviewRatingValueMetadata = {
  __typename?: 'ProductReviewRatingValueMetadata'
  /** A ratings scale, such as the number of stars awarded. */
  value: Scalars['String']
  /** An encoded rating value ID. */
  value_id: Scalars['String']
}

/** Contains an array of metadata about each aspect of a product review. */
export type ProductReviewRatingsMetadata = {
  __typename?: 'ProductReviewRatingsMetadata'
  /** An array of product reviews sorted by position. */
  items: Array<Maybe<ProductReviewRatingMetadata>>
}

/** Contains an array of product reviews. */
export type ProductReviews = {
  __typename?: 'ProductReviews'
  /** An array of product reviews. */
  items: Array<Maybe<ProductReview>>
  /** Metadata for pagination rendering. */
  page_info: SearchResultPageInfo
}

/** Deprecated. Use `ProductAttributeSortInput` instead. Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type ProductSortInput = {
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<SortEnum>
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<SortEnum>
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<SortEnum>
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<SortEnum>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<SortEnum>
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<SortEnum>
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<SortEnum>
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<SortEnum>
  /** The label assigned to a product image. */
  image_label?: InputMaybe<SortEnum>
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<SortEnum>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<SortEnum>
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<SortEnum>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<SortEnum>
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<SortEnum>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<SortEnum>
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<SortEnum>
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<SortEnum>
  /** The price of the item. */
  price?: InputMaybe<SortEnum>
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<SortEnum>
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<SortEnum>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<SortEnum>
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<SortEnum>
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<SortEnum>
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<SortEnum>
  /** The discounted price of the product. */
  special_price?: InputMaybe<SortEnum>
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<SortEnum>
  /** Indicates the criteria to sort swatches. */
  swatch_image?: InputMaybe<SortEnum>
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<SortEnum>
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<SortEnum>
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<SortEnum>
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<SortEnum>
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<SortEnum>
  url_path?: InputMaybe<SortEnum>
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<SortEnum>
}

/** This enumeration states whether a product stock status is in stock or out of stock */
export const ProductStockStatus = {
  Backorder: 'BACKORDER',
  InStock: 'IN_STOCK',
  OutOfStock: 'OUT_OF_STOCK',
} as const

export type ProductStockStatus = (typeof ProductStockStatus)[keyof typeof ProductStockStatus]
/** Deprecated. Use `TierPrice` instead. Defines a tier price, which is a quantity discount offered to a specific customer group. */
export type ProductTierPrices = {
  __typename?: 'ProductTierPrices'
  /**
   * The ID of the customer group.
   * @deprecated Not relevant for the storefront.
   */
  customer_group_id?: Maybe<Scalars['String']>
  /**
   * The percentage discount of the item.
   * @deprecated Use `TierPrice.discount` instead.
   */
  percentage_value?: Maybe<Scalars['Float']>
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated Use `TierPrice.quantity` instead.
   */
  qty?: Maybe<Scalars['Float']>
  /**
   * The price of the fixed price item.
   * @deprecated Use `TierPrice.final_price` instead.
   */
  value?: Maybe<Scalars['Float']>
  /**
   * The ID assigned to the website.
   * @deprecated Not relevant for the storefront.
   */
  website_id?: Maybe<Scalars['Float']>
}

/** Contains information about a product video. */
export type ProductVideo = MediaGalleryInterface & {
  __typename?: 'ProductVideo'
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>
  /** Contains a `ProductMediaGalleryEntriesVideoContent` object. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>
}

/** Contains the results of a `products` query. */
export type Products = {
  __typename?: 'Products'
  /** A bucket that contains the attribute code and label for each filterable option. */
  aggregations?: Maybe<Array<Maybe<Aggregation>>>
  /**
   * Layered navigation filters array.
   * @deprecated Use `aggregations` instead.
   */
  filters?: Maybe<Array<Maybe<LayerFilter>>>
  /** An array of products that match the specified search criteria. */
  items?: Maybe<Array<Maybe<ProductInterface>>>
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>
  /** An object that includes the default sort field and all available sort fields. */
  sort_fields?: Maybe<SortFields>
  /** An array of search suggestions for case when search query have no results. */
  suggestions?: Maybe<Array<Maybe<SearchSuggestion>>>
  /** The number of products that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']>
}

/** Contains the results of a `products` query. */
export type ProductsAggregationsArgs = {
  filter?: InputMaybe<AggregationsFilterInput>
}

export type Query = {
  __typename?: 'Query'
  /** Get a list of available store views and their config information. */
  availableStores?: Maybe<Array<Maybe<StoreConfig>>>
  /** Return information about the specified shopping cart. */
  cart?: Maybe<Cart>
  /** Return a list of categories that match the specified filter. */
  categories?: Maybe<CategoryResult>
  /**
   * Search for categories that match the criteria specified in the `search` and `filter` attributes.
   * @deprecated Use `categories` instead.
   */
  category?: Maybe<CategoryTree>
  /**
   * Return an array of categories based on the specified filters.
   * @deprecated Use `categories` instead.
   */
  categoryList?: Maybe<Array<Maybe<CategoryTree>>>
  /** Return Terms and Conditions configuration information. */
  checkoutAgreements?: Maybe<Array<Maybe<CheckoutAgreement>>>
  /** Return information about CMS blocks. */
  cmsBlocks?: Maybe<CmsBlocks>
  /** Return details about a CMS page. */
  cmsPage?: Maybe<CmsPage>
  /** Return products that have been added to the specified compare list. */
  compareList?: Maybe<CompareList>
  /** The countries query provides information for all countries. */
  countries?: Maybe<Array<Maybe<Country>>>
  /** The countries query provides information for a single country. */
  country?: Maybe<Country>
  /** Return information about the store's currency. */
  currency?: Maybe<Currency>
  /** Return the attribute type, given an attribute code and entity type. */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>
  /** Return detailed information about a customer account. */
  customer?: Maybe<Customer>
  /** Return information about the customer's shopping cart. */
  customerCart: Cart
  /** Return a list of downloadable products the customer has purchased. */
  customerDownloadableProducts?: Maybe<CustomerDownloadableProducts>
  /** @deprecated Use the `customer` query instead. */
  customerOrders?: Maybe<CustomerOrders>
  /** Return a list of customer payment tokens stored in the vault. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>
  /** Get CyberSource Cardinal Cruise parameters for completing payer authentication. */
  cyberSourceCardinalCruiseAuthPayload?: Maybe<TokenBaseCyberSourceCardinalCruiseParams>
  /** Get CyberSource Secure Acceptance form URL and parameters for collecting payment data. */
  cyberSourceSecureAcceptParams?: Maybe<TokenBaseCyberSourceSecureAcceptParams>
  /** Retrieve the secure PayPal URL for a Payments Pro Hosted Solution transaction. */
  getHostedProUrl?: Maybe<HostedProUrl>
  /** Retrieve payment credentials for a transaction. Use this query for Payflow Link and Payments Advanced payment methods. */
  getPayflowLinkToken?: Maybe<PayflowLinkToken>
  /** Check whether the specified email has already been used to create a customer account. */
  isEmailAvailable?: Maybe<IsEmailAvailableOutput>
  /** Searches for Best Sellers information matches the filter. */
  mpSmtpBestsellers?: Maybe<SmtpBestsellersOutput>
  /** The pickup locations query searches for locations that match the search request requirements. */
  pickupLocations?: Maybe<PickupLocations>
  /** Return the active ratings attributes and the values each rating can have. */
  productReviewRatingsMetadata: ProductReviewRatingsMetadata
  /** Search for products that match the criteria specified in the `search` and `filter` attributes. */
  products?: Maybe<Products>
  /** Return the full details for a specified product, category, or CMS page. */
  route?: Maybe<RoutableInterface>
  shopPayConfirmation?: Maybe<ShopPayConfirmationOutput>
  /** Return details about the store's configuration. */
  storeConfig?: Maybe<StoreConfig>
  /** Get the current customer's stored card(s), if any. Takes optional hash for a specific card. */
  tokenBaseCards?: Maybe<Array<Maybe<TokenBaseCard>>>
  /** Get checkout configuration for the given TokenBase payment method. */
  tokenBaseCheckoutConfig?: Maybe<TokenBaseCheckoutConfig>
  /**
   * Return the relative URL for a specified product, category or CMS page.
   * @deprecated Use the `route` query instead.
   */
  urlResolver?: Maybe<EntityUrl>
  /**
   * Return the contents of a customer's wish list.
   * @deprecated Moved under `Customer.wishlist`.
   */
  wishlist?: Maybe<WishlistOutput>
}

export type QueryAvailableStoresArgs = {
  useCurrentGroup?: InputMaybe<Scalars['Boolean']>
}

export type QueryCartArgs = {
  cart_id: Scalars['String']
}

export type QueryCategoriesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  filters?: InputMaybe<CategoryFilterInput>
  pageSize?: InputMaybe<Scalars['Int']>
}

export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['Int']>
}

export type QueryCategoryListArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  filters?: InputMaybe<CategoryFilterInput>
  pageSize?: InputMaybe<Scalars['Int']>
}

export type QueryCmsBlocksArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QueryCmsPageArgs = {
  id?: InputMaybe<Scalars['Int']>
  identifier?: InputMaybe<Scalars['String']>
}

export type QueryCompareListArgs = {
  uid: Scalars['ID']
}

export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['String']>
}

export type QueryCustomAttributeMetadataArgs = {
  attributes: Array<AttributeInput>
}

export type QueryCyberSourceCardinalCruiseAuthPayloadArgs = {
  input: TokenBaseCyberSourceCardinalCruiseAuthInput
}

export type QueryCyberSourceSecureAcceptParamsArgs = {
  input: TokenBaseCyberSourceSecureAcceptInput
}

export type QueryGetHostedProUrlArgs = {
  input: HostedProUrlInput
}

export type QueryGetPayflowLinkTokenArgs = {
  input: PayflowLinkTokenInput
}

export type QueryIsEmailAvailableArgs = {
  email: Scalars['String']
}

export type QueryMpSmtpBestsellersArgs = {
  app_id: Scalars['String']
  filters?: InputMaybe<MpFilters>
  secret_key: Scalars['String']
}

export type QueryPickupLocationsArgs = {
  area?: InputMaybe<AreaInput>
  currentPage?: InputMaybe<Scalars['Int']>
  filters?: InputMaybe<PickupLocationFilterInput>
  pageSize?: InputMaybe<Scalars['Int']>
  productsInfo?: InputMaybe<Array<InputMaybe<ProductInfoInput>>>
  sort?: InputMaybe<PickupLocationSortInput>
}

export type QueryProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  filter?: InputMaybe<ProductAttributeFilterInput>
  pageSize?: InputMaybe<Scalars['Int']>
  search?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<ProductAttributeSortInput>
}

export type QueryRouteArgs = {
  url: Scalars['String']
}

export type QueryShopPayConfirmationArgs = {
  source_identifier: Scalars['String']
}

export type QueryTokenBaseCardsArgs = {
  hash?: InputMaybe<Scalars['String']>
}

export type QueryTokenBaseCheckoutConfigArgs = {
  method: Scalars['String']
}

export type QueryUrlResolverArgs = {
  url: Scalars['String']
}

export type Region = {
  __typename?: 'Region'
  /** The two-letter code for the region, such as TX for Texas. */
  code?: Maybe<Scalars['String']>
  /** The unique ID for a `Region` object. */
  id?: Maybe<Scalars['Int']>
  /** The name of the region, such as Texas. */
  name?: Maybe<Scalars['String']>
}

/** Specifies the cart from which to remove a coupon. */
export type RemoveCouponFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  coupon_code?: InputMaybe<Scalars['String']>
}

/** Contains details about the cart after removing a coupon. */
export type RemoveCouponFromCartOutput = {
  __typename?: 'RemoveCouponFromCartOutput'
  /** The cart after removing a coupon. */
  cart?: Maybe<Cart>
}

/** Specifies which items to remove from the cart. */
export type RemoveItemFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']>
  /** Required field. The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']>
}

/** Contains details about the cart after removing an item. */
export type RemoveItemFromCartOutput = {
  __typename?: 'RemoveItemFromCartOutput'
  /** The cart after removing an item. */
  cart: Cart
}

/** Defines which products to remove from a compare list. */
export type RemoveProductsFromCompareListInput = {
  /** An array of product IDs to remove from the compare list. */
  products: Array<InputMaybe<Scalars['ID']>>
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID']
}

/** Contains the customer's wish list and any errors encountered. */
export type RemoveProductsFromWishlistOutput = {
  __typename?: 'RemoveProductsFromWishlistOutput'
  /** An array of errors encountered while deleting products from a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>
  /** Contains the wish list with after items were successfully deleted. */
  wishlist: Wishlist
}

/** Contains the cart and any errors after adding products. */
export type ReorderItemsOutput = {
  __typename?: 'ReorderItemsOutput'
  /** Detailed information about the customer's cart. */
  cart: Cart
  /** An array of reordering errors. */
  userInputErrors: Array<Maybe<CheckoutUserInputError>>
}

/** Contains the result of a request to revoke a customer token. */
export type RevokeCustomerTokenOutput = {
  __typename?: 'RevokeCustomerTokenOutput'
  /** The result of a request to revoke a customer token. */
  result: Scalars['Boolean']
}

/** Routable entities serve as the model for a rendered page. */
export type RoutableInterface = {
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>
}

/** Contains details about a comment. */
export type SalesCommentItem = {
  __typename?: 'SalesCommentItem'
  /** The text of the message. */
  message: Scalars['String']
  /** The timestamp of the comment. */
  timestamp: Scalars['String']
}

export type SalesItemInterface = {
  __typename?: 'SalesItemInterface'
  /** The entered gift message for the order item */
  gift_message?: Maybe<GiftMessage>
}

/** This enumeration defines the scope type for customer orders. */
export const ScopeTypeEnum = {
  Global: 'GLOBAL',
  Store: 'STORE',
  Website: 'WEBSITE',
} as const

export type ScopeTypeEnum = (typeof ScopeTypeEnum)[keyof typeof ScopeTypeEnum]
/** Provides navigation for the query response. */
export type SearchResultPageInfo = {
  __typename?: 'SearchResultPageInfo'
  /** The specific page to return. */
  current_page?: Maybe<Scalars['Int']>
  /** The maximum number of items to return per page of results. */
  page_size?: Maybe<Scalars['Int']>
  /** The total number of pages in the response. */
  total_pages?: Maybe<Scalars['Int']>
}

/** A string that contains search suggestion */
export type SearchSuggestion = {
  __typename?: 'SearchSuggestion'
  /** The search suggestion of existing product. */
  search: Scalars['String']
}

/** Contains details about a selected bundle option. */
export type SelectedBundleOption = {
  __typename?: 'SelectedBundleOption'
  /** @deprecated Use `uid` instead */
  id: Scalars['Int']
  /** The display name of the selected bundle product option. */
  label: Scalars['String']
  /** The type of selected bundle product option. */
  type: Scalars['String']
  /** The unique ID for a `SelectedBundleOption` object */
  uid: Scalars['ID']
  /** An array of selected bundle option values. */
  values: Array<Maybe<SelectedBundleOptionValue>>
}

/** Contains details about a value for a selected bundle option. */
export type SelectedBundleOptionValue = {
  __typename?: 'SelectedBundleOptionValue'
  /** Use `uid` instead */
  id: Scalars['Int']
  /** The display name of the value for the selected bundle product option. */
  label: Scalars['String']
  /** The price of the value for the selected bundle product option. */
  price: Scalars['Float']
  /** The quantity of the value for the selected bundle product option. */
  quantity: Scalars['Float']
  /** The unique ID for a `SelectedBundleOptionValue` object */
  uid: Scalars['ID']
}

/** Contains details about a selected configurable option. */
export type SelectedConfigurableOption = {
  __typename?: 'SelectedConfigurableOption'
  /** The unique ID for a `ConfigurableProductOptions` object. */
  configurable_product_option_uid: Scalars['ID']
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  configurable_product_option_value_uid: Scalars['ID']
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_uid` instead. */
  id: Scalars['Int']
  /** The display text for the option. */
  option_label: Scalars['String']
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_value_uid` instead. */
  value_id: Scalars['Int']
  /** The display name of the selected configurable option. */
  value_label: Scalars['String']
}

/** Identifies a customized product that has been placed in a cart. */
export type SelectedCustomizableOption = {
  __typename?: 'SelectedCustomizableOption'
  /** The unique ID for a specific `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  customizable_option_uid: Scalars['ID']
  /** @deprecated Use `SelectedCustomizableOption.customizable_option_uid` instead. */
  id: Scalars['Int']
  /** Indicates whether the customizable option is required. */
  is_required: Scalars['Boolean']
  /** The display name of the selected customizable option. */
  label: Scalars['String']
  /** A value indicating the order to display this option. */
  sort_order: Scalars['Int']
  /** The type of `CustomizableOptionInterface` object. */
  type: Scalars['String']
  /** An array of selectable values. */
  values: Array<Maybe<SelectedCustomizableOptionValue>>
}

/** Identifies the value of the selected customized option. */
export type SelectedCustomizableOptionValue = {
  __typename?: 'SelectedCustomizableOptionValue'
  /** The unique ID for a value object that corresponds to the object represented by the `customizable_option_uid` attribute. */
  customizable_option_value_uid: Scalars['ID']
  /** @deprecated Use `SelectedCustomizableOptionValue.customizable_option_value_uid` instead. */
  id: Scalars['Int']
  /** The display name of the selected value. */
  label: Scalars['String']
  /** The price of the selected customizable value. */
  price: CartItemSelectedOptionValuePrice
  /** The text identifying the selected value. */
  value: Scalars['String']
}

/** Describes the payment method the shopper selected. */
export type SelectedPaymentMethod = {
  __typename?: 'SelectedPaymentMethod'
  /** The payment method code. */
  code: Scalars['String']
  /** The purchase order number. */
  purchase_order_number?: Maybe<Scalars['String']>
  /** The payment method title. */
  title: Scalars['String']
  /** Selected card ID (TokenBase methods only) */
  tokenbase_card_id?: Maybe<Scalars['String']>
  /** Payment info (TokenBase methods only) */
  tokenbase_data?: Maybe<TokenBaseCardAdditional>
  /** Card is being saved for future use (TokenBase methods only) */
  tokenbase_save?: Maybe<Scalars['Boolean']>
}

/** Contains details about the selected shipping method and carrier. */
export type SelectedShippingMethod = {
  __typename?: 'SelectedShippingMethod'
  /** The cost of shipping using this shipping method. */
  amount: Money
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String']
  /** The label for the carrier code. */
  carrier_title: Scalars['String']
  /** A shipping method code associated with a carrier. */
  method_code: Scalars['String']
  /** The label for the method code. */
  method_title: Scalars['String']
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money
}

/** Defines the referenced product and the email sender and recipients. */
export type SendEmailToFriendInput = {
  /** The ID of the product that the sender is referencing. */
  product_id: Scalars['Int']
  /** An array containing information about each recipient. */
  recipients: Array<InputMaybe<SendEmailToFriendRecipientInput>>
  /** Information about the customer and the content of the message. */
  sender: SendEmailToFriendSenderInput
}

/** Contains information about the sender and recipients. */
export type SendEmailToFriendOutput = {
  __typename?: 'SendEmailToFriendOutput'
  /** An array containing information about each recipient. */
  recipients?: Maybe<Array<Maybe<SendEmailToFriendRecipient>>>
  /** Information about the customer and the content of the message. */
  sender?: Maybe<SendEmailToFriendSender>
}

/** An output object that contains information about the recipient. */
export type SendEmailToFriendRecipient = {
  __typename?: 'SendEmailToFriendRecipient'
  /** The email address of the recipient. */
  email: Scalars['String']
  /** The name of the recipient. */
  name: Scalars['String']
}

/** Contains details about a recipient. */
export type SendEmailToFriendRecipientInput = {
  /** The email address of the recipient. */
  email: Scalars['String']
  /** The name of the recipient. */
  name: Scalars['String']
}

/** An output object that contains information about the sender. */
export type SendEmailToFriendSender = {
  __typename?: 'SendEmailToFriendSender'
  /** The email address of the sender. */
  email: Scalars['String']
  /** The text of the message to be sent. */
  message: Scalars['String']
  /** The name of the sender. */
  name: Scalars['String']
}

/** Contains details about the sender. */
export type SendEmailToFriendSenderInput = {
  /** The email address of the sender. */
  email: Scalars['String']
  /** The text of the message to be sent. */
  message: Scalars['String']
  /** The name of the sender. */
  name: Scalars['String']
}

/** Contains details about the configuration of the Email to a Friend feature. */
export type SendFriendConfiguration = {
  __typename?: 'SendFriendConfiguration'
  /** Indicates whether the Email to a Friend feature is enabled. */
  enabled_for_customers: Scalars['Boolean']
  /** Indicates whether the Email to a Friend feature is enabled for guests. */
  enabled_for_guests: Scalars['Boolean']
}

/** Sets the billing address. */
export type SetBillingAddressOnCartInput = {
  /** The billing address. */
  billing_address: BillingAddressInput
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
}

/** Contains details about the cart after setting the billing address. */
export type SetBillingAddressOnCartOutput = {
  __typename?: 'SetBillingAddressOnCartOutput'
  /** The cart after setting the billing address. */
  cart: Cart
}

export type SetCartAttributesOnCartInput = {
  cart_id: Scalars['String']
  dispensary_promo_code?: InputMaybe<Scalars['String']>
  e_script_campaign?: InputMaybe<Scalars['String']>
  practitioner_code?: InputMaybe<Scalars['String']>
  ww_id?: InputMaybe<Scalars['String']>
  ww_practice_id?: InputMaybe<Scalars['String']>
  ww_practitioner_id?: InputMaybe<Scalars['String']>
  ww_store_id?: InputMaybe<Scalars['String']>
}

export type SetCartAttributesOnCartOutput = {
  __typename?: 'SetCartAttributesOnCartOutput'
  cart: Cart
}

export type SetDispensaryPromoCodeOnCartInput = {
  cart_id: Scalars['String']
  dispensary_promo_code: Scalars['String']
}

export type SetDispensaryPromoCodeOnCartOutput = {
  __typename?: 'SetDispensaryPromoCodeOnCartOutput'
  cart: Cart
}

export type SetDropShipOnCartInput = {
  cart_id: Scalars['String']
  drop_ship: Scalars['String']
}

export type SetDropShipOnCartOutput = {
  __typename?: 'SetDropShipOnCartOutput'
  cart: Cart
}

export type SetEScriptCampaignOnCartInput = {
  cart_id: Scalars['String']
  e_script_campaign: Scalars['String']
}

/** Defines the guest email and cart. */
export type SetGuestEmailOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** The email address of the guest. */
  email: Scalars['String']
}

/** Contains details about the cart after setting the email of a guest. */
export type SetGuestEmailOnCartOutput = {
  __typename?: 'SetGuestEmailOnCartOutput'
  /** The cart after setting the guest email. */
  cart: Cart
}

export type SetHoldUntilMondayOnCartInput = {
  cart_id: Scalars['String']
  hold_until_monday: Scalars['String']
}

export type SetHoldUntilMondayOnCartOutput = {
  __typename?: 'SetHoldUntilMondayOnCartOutput'
  cart: Cart
}

export type SetNetSuiteCustomerIdOnCartInput = {
  cart_id: Scalars['String']
  ns_customer_id: Scalars['String']
}

export type SetNetSuiteCustomerIdOnCartOutput = {
  __typename?: 'SetNetSuiteCustomerIdOnCartOutput'
  cart: Cart
}

/** Applies a payment method to the quote. */
export type SetPaymentMethodAndPlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput
}

/** Applies a payment method to the cart. */
export type SetPaymentMethodOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput
}

/** Contains details about the cart after setting the payment method. */
export type SetPaymentMethodOnCartOutput = {
  __typename?: 'SetPaymentMethodOnCartOutput'
  /** The cart after setting the payment method. */
  cart: Cart
}

export type SetPractitionerCodeOnCartInput = {
  cart_id: Scalars['String']
  practitioner_code: Scalars['String']
}

export type SetPractitionerCodeOnCartOutput = {
  __typename?: 'SetPractitionerCodeOnCartOutput'
  cart: Cart
}

export type SetReferrerUriOnCartInput = {
  cart_id: Scalars['String']
  referrer_uri: Scalars['String']
}

export type SetReferrerUriOnCartOutput = {
  __typename?: 'SetReferrerUriOnCartOutput'
  cart: Cart
}

export type SetShipDateOnCartInput = {
  cart_id: Scalars['String']
  ship_date: Scalars['String']
}

export type SetShipDateOnCartOutput = {
  __typename?: 'SetShipDateOnCartOutput'
  cart: Cart
}

/** Specifies an array of addresses to use for shipping. */
export type SetShippingAddressesOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  hold_until_monday?: InputMaybe<Scalars['String']>
  /** An array of shipping addresses. */
  shipping_addresses: Array<InputMaybe<ShippingAddressInput>>
}

/** Contains details about the cart after setting the shipping addresses. */
export type SetShippingAddressesOnCartOutput = {
  __typename?: 'SetShippingAddressesOnCartOutput'
  /** The cart after setting the shipping addresses. */
  cart: Cart
}

/** Applies one or shipping methods to the cart. */
export type SetShippingMethodsOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** An array of shipping methods. */
  shipping_methods: Array<InputMaybe<ShippingMethodInput>>
}

/** Contains details about the cart after setting the shipping methods. */
export type SetShippingMethodsOnCartOutput = {
  __typename?: 'SetShippingMethodsOnCartOutput'
  /** The cart after setting the shipping methods. */
  cart: Cart
}

export type SetWwIdOnCartInput = {
  cart_id: Scalars['String']
  ww_id: Scalars['String']
}

export type SetWwOnCartOutput = {
  __typename?: 'SetWwOnCartOutput'
  cart: Cart
}

export type SetWwPracticeIdOnCartInput = {
  cart_id: Scalars['String']
  ww_practice_id: Scalars['String']
}

export type SetWwPractitionerIdOnCartInput = {
  cart_id: Scalars['String']
  ww_practitioner_id: Scalars['String']
}

export type SetWwStoreIdOnCartInput = {
  cart_id: Scalars['String']
  ww_store_id: Scalars['String']
}

/** Defines whether bundle items must be shipped together. */
export const ShipBundleItemsEnum = {
  Separately: 'SEPARATELY',
  Together: 'TOGETHER',
} as const

export type ShipBundleItemsEnum = (typeof ShipBundleItemsEnum)[keyof typeof ShipBundleItemsEnum]
export type ShipmentItem = ShipmentItemInterface & {
  __typename?: 'ShipmentItem'
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']
}

/** Order shipment item details. */
export type ShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>
  /** The sale price for the base product. */
  product_sale_price: Money
  /** The SKU of the base product. */
  product_sku: Scalars['String']
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']
}

/** Contains order shipment tracking details. */
export type ShipmentTracking = {
  __typename?: 'ShipmentTracking'
  /** The shipping carrier for the order delivery. */
  carrier: Scalars['String']
  /** The tracking number of the order shipment. */
  number?: Maybe<Scalars['String']>
  /** The shipment tracking title. */
  title: Scalars['String']
}

/** Defines a single shipping address. */
export type ShippingAddressInput = {
  /** Defines a shipping address. */
  address?: InputMaybe<CartAddressInput>
  /** An ID from the customer's address book that uniquely identifies the address to be used for shipping. */
  customer_address_id?: InputMaybe<Scalars['Int']>
  /** Text provided by the shopper. */
  customer_notes?: InputMaybe<Scalars['String']>
  /** The code of Pickup Location which will be used for In-Store Pickup. */
  pickup_location_code?: InputMaybe<Scalars['String']>
}

/** Contains shipping addresses and methods. */
export type ShippingCartAddress = CartAddressInterface & {
  __typename?: 'ShippingCartAddress'
  /** An array that lists the shipping methods that can be applied to the cart. */
  available_shipping_methods?: Maybe<Array<Maybe<AvailableShippingMethod>>>
  /** @deprecated Use `cart_items_v2` instead. */
  cart_items?: Maybe<Array<Maybe<CartItemQuantity>>>
  /** An array that lists the items in the cart. */
  cart_items_v2?: Maybe<Array<Maybe<CartItemInterface>>>
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>
  /** An object containing the country label and code. */
  country: CartAddressCountry
  /** Text provided by the shopper. */
  customer_notes?: Maybe<Scalars['String']>
  /** The first name of the customer or guest. */
  firstname: Scalars['String']
  /** @deprecated This information should not be exposed on the frontend. */
  items_weight?: Maybe<Scalars['Float']>
  /** The last name of the customer or guest. */
  lastname: Scalars['String']
  pickup_location_code?: Maybe<Scalars['String']>
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>
  /** An object that describes the selected shipping method. */
  selected_shipping_method?: Maybe<SelectedShippingMethod>
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>
  /** The unique id of the customer address. */
  uid: Scalars['String']
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>
}

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type ShippingDiscount = {
  __typename?: 'ShippingDiscount'
  /** The amount of the discount. */
  amount: Money
}

/** Contains details about shipping and handling costs. */
export type ShippingHandling = {
  __typename?: 'ShippingHandling'
  /** The shipping amount, excluding tax. */
  amount_excluding_tax?: Maybe<Money>
  /** The shipping amount, including tax. */
  amount_including_tax?: Maybe<Money>
  /** The applied discounts to the shipping. */
  discounts?: Maybe<Array<Maybe<ShippingDiscount>>>
  /** Details about taxes applied for shipping. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>
  /** The total amount for shipping. */
  total_amount: Money
}

/** Defines the shipping carrier and method. */
export type ShippingMethodInput = {
  /** A string that identifies a commercial carrier or an offline delivery method. */
  carrier_code: Scalars['String']
  /** A string that indicates which service a commercial carrier will use to ship items. For offline delivery methods, this value is similar to the label displayed on the checkout page. */
  method_code: Scalars['String']
}

export const ShopPayConfirmStatus = {
  Accepted: 'ACCEPTED',
  Corrected: 'CORRECTED',
  GeneralError: 'GENERAL_ERROR',
  Lost: 'LOST',
  Refused: 'REFUSED',
} as const

export type ShopPayConfirmStatus = (typeof ShopPayConfirmStatus)[keyof typeof ShopPayConfirmStatus]
export type ShopPayConfirmationOrder = {
  __typename?: 'ShopPayConfirmationOrder'
  order_number: Scalars['String']
}

export type ShopPayConfirmationOutput = {
  __typename?: 'ShopPayConfirmationOutput'
  copy_cart_id?: Maybe<Scalars['String']>
  order?: Maybe<ShopPayConfirmationOrder>
  status: ShopPayConfirmationStatus
}

export const ShopPayConfirmationStatus = {
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
  HeldForReview: 'HELD_FOR_REVIEW',
  NotFound: 'NOT_FOUND',
  NoPayment: 'NO_PAYMENT',
  Pending: 'PENDING',
  Placed: 'PLACED',
} as const

export type ShopPayConfirmationStatus =
  (typeof ShopPayConfirmationStatus)[keyof typeof ShopPayConfirmationStatus]
export type ShopPayContactInput = {
  address1?: InputMaybe<Scalars['String']>
  address2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  countryCode?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  phone?: InputMaybe<Scalars['String']>
  provinceCode?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

export type ShopPayDeliveryMethod = {
  __typename?: 'ShopPayDeliveryMethod'
  amount: ShopPayMoney
  code: Scalars['String']
  label: Scalars['String']
  maxDeliveryDate?: Maybe<Scalars['String']>
  minDeliveryDate?: Maybe<Scalars['String']>
}

export type ShopPayDeliveryMethodInput = {
  amount: ShopPayMoneyInput
  code: Scalars['String']
  detail?: InputMaybe<Scalars['String']>
  label: Scalars['String']
  maxDeliveryDate?: InputMaybe<Scalars['String']>
  minDeliveryDate?: InputMaybe<Scalars['String']>
}

export type ShopPayDiscount = {
  __typename?: 'ShopPayDiscount'
  amount: ShopPayMoney
  label: Scalars['String']
}

export type ShopPayDiscountInput = {
  amount: ShopPayMoneyInput
  label: Scalars['String']
}

export type ShopPayLineItem = {
  __typename?: 'ShopPayLineItem'
  finalItemPrice: ShopPayMoney
  finalLinePrice: ShopPayMoney
  label: Scalars['String']
  originalItemPrice: ShopPayMoney
  originalLinePrice: ShopPayMoney
  quantity: Scalars['Int']
  requiresShipping?: Maybe<Scalars['Boolean']>
  sku?: Maybe<Scalars['String']>
}

export type ShopPayLineItemInput = {
  finalItemPrice?: InputMaybe<ShopPayMoneyInput>
  finalLinePrice: ShopPayMoneyInput
  label: Scalars['String']
  originalItemPrice?: InputMaybe<ShopPayMoneyInput>
  originalLinePrice?: InputMaybe<ShopPayMoneyInput>
  quantity: Scalars['Int']
  requiresShipping?: InputMaybe<Scalars['Boolean']>
  sku?: InputMaybe<Scalars['String']>
}

export type ShopPayMoney = {
  __typename?: 'ShopPayMoney'
  amount: Scalars['Float']
  currencyCode: Scalars['String']
}

export type ShopPayMoneyInput = {
  amount: Scalars['Float']
  currencyCode: Scalars['String']
}

export type ShopPayPaymentInFlight = {
  __typename?: 'ShopPayPaymentInFlight'
  minimum_duration_end: Scalars['String']
  source_identifier: Scalars['String']
}

export type ShopPayPaymentRequest = {
  __typename?: 'ShopPayPaymentRequest'
  deliveryMethods?: Maybe<Array<ShopPayDeliveryMethod>>
  discountCodes?: Maybe<Array<Scalars['String']>>
  discounts?: Maybe<Array<ShopPayDiscount>>
  lineItems?: Maybe<Array<ShopPayLineItem>>
  locale?: Maybe<Scalars['String']>
  presentmentCurrency?: Maybe<Scalars['String']>
  shippingLines?: Maybe<Array<ShopPayShippingLine>>
  subtotal?: Maybe<ShopPayMoney>
  total?: Maybe<ShopPayMoney>
  totalShippingPrice?: Maybe<ShopPayTotalShippingPrice>
  totalTax?: Maybe<ShopPayMoney>
}

export type ShopPayPaymentRequestInput = {
  deliveryMethods?: InputMaybe<Array<ShopPayDeliveryMethodInput>>
  discountCodes?: InputMaybe<Array<Scalars['String']>>
  discounts?: InputMaybe<Array<ShopPayDiscountInput>>
  lineItems: Array<ShopPayLineItemInput>
  locale?: InputMaybe<Scalars['String']>
  paymentMethod?: InputMaybe<Scalars['String']>
  presentmentCurrency?: InputMaybe<Scalars['String']>
  shippingLines?: InputMaybe<Array<ShopPayShippingLineInput>>
  subtotal: ShopPayMoneyInput
  total: ShopPayMoneyInput
  totalShippingPrice?: InputMaybe<ShopPayTotalShippingPriceInput>
  totalTax: ShopPayMoneyInput
}

export type ShopPayPaymentRequestOutput = {
  __typename?: 'ShopPayPaymentRequestOutput'
  errors?: Maybe<Array<ShopPayUserError>>
  paymentRequest?: Maybe<ShopPayPaymentRequest>
}

export type ShopPaySelectDeliveryMethodInput = {
  cart_id: Scalars['String']
  code: Scalars['String']
  token: Scalars['String']
}

export type ShopPaySelectDeliveryMethodTypeInput = {
  cart_id: Scalars['String']
  token: Scalars['String']
  type: Scalars['String']
}

export type ShopPaySessionConfirmInput = {
  billing_address: ShopPayContactInput
  cart_id: Scalars['String']
  dispensary_slug?: InputMaybe<Scalars['String']>
  marketing_opt_in?: InputMaybe<Scalars['Boolean']>
  payment_method: Scalars['String']
  payment_request: ShopPayPaymentRequestInput
  sms_number?: InputMaybe<Scalars['String']>
  token: Scalars['String']
}

export type ShopPaySessionConfirmOutput = {
  __typename?: 'ShopPaySessionConfirmOutput'
  errors?: Maybe<Array<ShopPayUserError>>
  increment_id?: Maybe<Scalars['String']>
  source_identifier?: Maybe<Scalars['String']>
  status: ShopPayConfirmStatus
  updated_payment_request?: Maybe<ShopPayPaymentRequest>
}

export type ShopPaySessionCreateInput = {
  cart_id: Scalars['String']
}

export type ShopPaySessionCreateOutput = {
  __typename?: 'ShopPaySessionCreateOutput'
  checkout_url: Scalars['String']
  copy_cart_id?: Maybe<Scalars['String']>
  source_identifier: Scalars['String']
  token: Scalars['String']
}

export type ShopPaySessionEndInput = {
  cart_id: Scalars['String']
  token: Scalars['String']
}

export type ShopPaySessionEndOutput = {
  __typename?: 'ShopPaySessionEndOutput'
  ok: Scalars['Boolean']
}

export type ShopPaySessionStartOverInput = {
  cart_id: Scalars['String']
}

export type ShopPaySessionStartOverOutput = {
  __typename?: 'ShopPaySessionStartOverOutput'
  copy_cart_id?: Maybe<Scalars['String']>
}

export type ShopPayShippingLine = {
  __typename?: 'ShopPayShippingLine'
  amount: ShopPayMoney
  code: Scalars['String']
  label: Scalars['String']
}

export type ShopPayShippingLineInput = {
  amount: ShopPayMoneyInput
  code: Scalars['String']
  label: Scalars['String']
}

export type ShopPayTotalShippingPrice = {
  __typename?: 'ShopPayTotalShippingPrice'
  finalTotal: ShopPayMoney
  originalTotal?: Maybe<ShopPayMoney>
}

export type ShopPayTotalShippingPriceInput = {
  finalTotal: ShopPayMoneyInput
  originalTotal?: InputMaybe<ShopPayMoneyInput>
}

export type ShopPayUpdateDiscountCodeInput = {
  cart_id: Scalars['String']
  discountCodes?: InputMaybe<Array<Scalars['String']>>
  token: Scalars['String']
}

export type ShopPayUpdateShippingAddressInput = {
  address?: InputMaybe<ShopPayContactInput>
  cart_id: Scalars['String']
  token: Scalars['String']
}

export type ShopPayUserError = {
  __typename?: 'ShopPayUserError'
  message: Scalars['String']
  type: ShopPayUserErrorType
}

export const ShopPayUserErrorType = {
  DiscountCodeError: 'DISCOUNT_CODE_ERROR',
  GeneralError: 'GENERAL_ERROR',
  ShippingAddressError: 'SHIPPING_ADDRESS_ERROR',
} as const

export type ShopPayUserErrorType = (typeof ShopPayUserErrorType)[keyof typeof ShopPayUserErrorType]
/** An implementation for simple product cart items. */
export type SimpleCartItem = CartItemInterface & {
  __typename?: 'SimpleCartItem'
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']
  /** Cart item attributes */
  item_attributes?: Maybe<CartItemAttributes>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']
}

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProduct = CustomizableProductInterface &
  PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'SimpleProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    a_z?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    activity?: Maybe<Scalars['String']>
    /** Advisor Tags based on advisor_tags attribute */
    advisor_tags?: Maybe<Array<Maybe<Scalars['String']>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    allow_credit_range?: Maybe<Scalars['Int']>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    category_gear?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    climate?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    collar?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_public?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_public?: Maybe<Scalars['String']>
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_amount?: Maybe<Scalars['Float']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_rate?: Maybe<Scalars['Float']>
    /** Crosssell Products */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_clinical_trials?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_patient_education?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_tech_sheet?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    eco_collection?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    erin_recommends?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    features_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    format?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['String']>
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    heat_sensitive?: Maybe<Scalars['Int']>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    max_credit?: Maybe<Scalars['Float']>
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    min_credit?: Maybe<Scalars['Float']>
    /** Store Credit product attributes */
    mp_store_credit_attributes?: Maybe<Array<Maybe<StoreCreditProductAttributes>>>
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    natural_product_number?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    new?: Maybe<Scalars['Int']>
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    out_of_stock_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pattern?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    performance_fabric?: Maybe<Scalars['Int']>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    price_range: PriceRange
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>
    /**
     * Product Form based on product_form attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    product_form?: Maybe<Scalars['String']>
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** One of simple, virtual, bundle, downloadable, grouped, or configurable. */
    product_type_id?: Maybe<Scalars['String']>
    /**
     * Prop65 Message
     * @deprecated Use the `custom_attributes` field instead.
     */
    prop65_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    prop_sixty_five?: Maybe<Scalars['Int']>
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars['Float']
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int']
    /** An array of products to be displayed in a Related Products block. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>
    /** The total count of all the reviews given to the product. */
    review_count: Scalars['Int']
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    sale?: Maybe<Scalars['Int']>
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars['Int']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sleeve?: Maybe<Scalars['String']>
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>
    /**
     * Specialty based on specialty attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    specialty?: Maybe<Array<Maybe<Scalars['String']>>>
    /** Stock Item Configuration */
    stock_configuration?: Maybe<StockItemConfiguration>
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>
    /** @deprecated Use the `custom_attributes` field instead. */
    strap_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bottom?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_general?: Maybe<Scalars['String']>
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>
    /** Upsell Products */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>
    /** An index of a product variant */
    variant_index?: Maybe<SimpleVariantIndex>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']>
  }

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

/** Defines a single product to add to the cart. */
export type SimpleProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput
}

/** An index containing information for a simple product variant */
export type SimpleVariantIndex = {
  __typename?: 'SimpleVariantIndex'
  /** An array of used attribute values */
  attribute_values?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  /** Parent configurable product */
  parent?: Maybe<SimpleVariantParent>
  short_description?: Maybe<Scalars['String']>
  thumbnail?: Maybe<Scalars['String']>
  /** An array of used product attributes of a simple product */
  used_attributes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type SimpleVariantParent = {
  __typename?: 'SimpleVariantParent'
  product?: Maybe<ProductInterface>
  sku?: Maybe<Scalars['String']>
}

/** Contains a simple product wish list item. */
export type SimpleWishlistItem = WishlistItemInterface & {
  __typename?: 'SimpleWishlistItem'
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']
}

export type SmtpBestsellersOutput = {
  __typename?: 'SmtpBestsellersOutput'
  /** Bestsellers Product Information. */
  mpBestsellers?: Maybe<Array<Maybe<BestsellersProductOutput>>>
}

/** Indicates whether to return results in ascending or descending order. */
export const SortEnum = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const

export type SortEnum = (typeof SortEnum)[keyof typeof SortEnum]
/** Defines a possible sort field. */
export type SortField = {
  __typename?: 'SortField'
  /** The label of the sort field. */
  label?: Maybe<Scalars['String']>
  /** The attribute code of the sort field. */
  value?: Maybe<Scalars['String']>
}

/** Contains a default value for sort fields and all available sort fields. */
export type SortFields = {
  __typename?: 'SortFields'
  /** The default sort field value. */
  default?: Maybe<Scalars['String']>
  /** An array of possible sort fields. */
  options?: Maybe<Array<Maybe<SortField>>>
}

/** Calls the Truemed API to create a payment session and returns a redirect URL. */
export type StartTruemedPaymentSessionInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** The URL to redirect a customer to after payment failure. */
  failure_url: Scalars['String']
  /** The URL to redirect a customer to after payment success. */
  success_url: Scalars['String']
}

export type StartTruemedPaymentSessionOutput = {
  __typename?: 'StartTruemedPaymentSessionOutput'
  /** The unique ID of a `Truemed Payment Session`. */
  payment_session_id: Scalars['String']
  /** The external Truemed Payment Session URL. */
  redirect_url: Scalars['String']
  /** Base64 encoded application state to be included in the 'completeTruemedPaymentSession' input. */
  state: Scalars['String']
}

/** Stock Item Configuration */
export type StockItemConfiguration = {
  __typename?: 'StockItemConfiguration'
  /** Maximum Salable Quantity */
  max_sale_qty?: Maybe<Scalars['String']>
  /** Minimum Salable Quantity */
  min_sale_qty?: Maybe<Scalars['String']>
  /** Quantity Increments */
  qty_increments?: Maybe<Scalars['String']>
}

/** Contains information about a store's configuration. */
export type StoreConfig = {
  __typename?: 'StoreConfig'
  /** Contains scripts that must be included in the HTML before the closing `<body>` tag. */
  absolute_footer?: Maybe<Scalars['String']>
  /** Indicates whether guest users can write product reviews. Possible values: 1 (Yes) and 0 (No). */
  allow_guests_to_write_product_reviews?: Maybe<Scalars['String']>
  /** The value of the Allow Gift Messages for Order Items option */
  allow_items?: Maybe<Scalars['String']>
  /** The value of the Allow Gift Messages on Order Level option */
  allow_order?: Maybe<Scalars['String']>
  /** Indicates whether to enable autocomplete on login and forgot password forms. */
  autocomplete_on_storefront?: Maybe<Scalars['Boolean']>
  /** The base currency code. */
  base_currency_code?: Maybe<Scalars['String']>
  /** A fully-qualified URL that is used to create relative links to the `base_url`. */
  base_link_url?: Maybe<Scalars['String']>
  /** The fully-qualified URL that specifies the location of media files. */
  base_media_url?: Maybe<Scalars['String']>
  /** The fully-qualified URL that specifies the location of static view files. */
  base_static_url?: Maybe<Scalars['String']>
  /** The store’s fully-qualified base URL. */
  base_url?: Maybe<Scalars['String']>
  /** The default sort order of the search results list. */
  catalog_default_sort_by?: Maybe<Scalars['String']>
  /** Corresponds to the 'Display Prices In Product Lists' field in the Admin. It indicates how FPT information is displayed on category pages. */
  category_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>
  /** The suffix applied to category pages, such as `.htm` or `.html`. */
  category_url_suffix?: Maybe<Scalars['String']>
  /** Indicates whether only specific countries can use this payment method. */
  check_money_order_enable_for_specific_countries?: Maybe<Scalars['Boolean']>
  /** Indicates whether the Check/Money Order payment method is enabled. */
  check_money_order_enabled?: Maybe<Scalars['Boolean']>
  /** The name of the party to whom the check must be payable. */
  check_money_order_make_check_payable_to?: Maybe<Scalars['String']>
  /** The maximum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_max_order_total?: Maybe<Scalars['String']>
  /** The minimum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_min_order_total?: Maybe<Scalars['String']>
  /** The status of new orders placed using the Check/Money Order payment method. */
  check_money_order_new_order_status?: Maybe<Scalars['String']>
  /** A comma-separated list of specific countries allowed to use the Check/Money Order payment method. */
  check_money_order_payment_from_specific_countries?: Maybe<Scalars['String']>
  /** The full street address or PO Box where the checks are mailed. */
  check_money_order_send_check_to?: Maybe<Scalars['String']>
  /** A number indicating the position of the Check/Money Order payment method in the list of available payment methods during checkout. */
  check_money_order_sort_order?: Maybe<Scalars['Int']>
  /** The title of the Check/Money Order payment method displayed on the storefront. */
  check_money_order_title?: Maybe<Scalars['String']>
  /** The name of the CMS page that identifies the home page for the store. */
  cms_home_page?: Maybe<Scalars['String']>
  /** A specific CMS page that displays when cookies are not enabled for the browser. */
  cms_no_cookies?: Maybe<Scalars['String']>
  /** A specific CMS page that displays when a 404 'Page Not Found' error occurs. */
  cms_no_route?: Maybe<Scalars['String']>
  /**
   * A code assigned to the store to identify it.
   * @deprecated Use `store_code` instead.
   */
  code?: Maybe<Scalars['String']>
  /** Indicates whether the `parent` or child (`itself`) thumbnail should be used in the cart for configurable products. */
  configurable_thumbnail_source?: Maybe<Scalars['String']>
  /** The copyright statement that appears at the bottom of each page. */
  copyright?: Maybe<Scalars['String']>
  /** The description that provides a summary of your site for search engine listings. It should not be more than 160 characters in length. */
  default_description?: Maybe<Scalars['String']>
  /** The default display currency code. */
  default_display_currency_code?: Maybe<Scalars['String']>
  /** A series of keywords that describe your store, each separated by a comma. */
  default_keywords?: Maybe<Scalars['String']>
  /** The title that appears at the title bar of each page when viewed in a browser. */
  default_title?: Maybe<Scalars['String']>
  /** Controls the display of the demo store notice at the top of the page. Options: 0 (No) or 1 (Yes). */
  demonotice?: Maybe<Scalars['Int']>
  /** The landing page that is associated with the base URL. */
  front?: Maybe<Scalars['String']>
  /** The default number of products per page in Grid View. */
  grid_per_page?: Maybe<Scalars['Int']>
  /** A list of numbers that define how many products can be displayed in Grid View. */
  grid_per_page_values?: Maybe<Scalars['String']>
  /** Scripts that must be included in the HTML before the closing `<head>` tag. */
  head_includes?: Maybe<Scalars['String']>
  /** The small graphic image (favicon) that appears in the address bar and tab of the browser. */
  head_shortcut_icon?: Maybe<Scalars['String']>
  /** The path to the logo that appears in the header. */
  header_logo_src?: Maybe<Scalars['String']>
  /**
   * The ID number assigned to the store.
   * @deprecated Use `store_code` instead.
   */
  id?: Maybe<Scalars['Int']>
  /** Indicates whether the store view has been designated as the default within the store group. */
  is_default_store?: Maybe<Scalars['Boolean']>
  /** Indicates whether the store group has been designated as the default within the website. */
  is_default_store_group?: Maybe<Scalars['Boolean']>
  /** The format of the search results list. */
  list_mode?: Maybe<Scalars['String']>
  /** The default number of products per page in List View. */
  list_per_page?: Maybe<Scalars['Int']>
  /** A list of numbers that define how many products can be displayed in List View. */
  list_per_page_values?: Maybe<Scalars['String']>
  /** The store locale. */
  locale?: Maybe<Scalars['String']>
  /** The Alt text that is associated with the logo. */
  logo_alt?: Maybe<Scalars['String']>
  /** The height of the logo image, in pixels. */
  logo_height?: Maybe<Scalars['Int']>
  /** The width of the logo image, in pixels. */
  logo_width?: Maybe<Scalars['Int']>
  /** Indicates whether wishlists are enabled (1) or disabled (0). */
  magento_wishlist_general_is_enabled?: Maybe<Scalars['String']>
  /** The minimum number of characters required for a valid password. */
  minimum_password_length?: Maybe<Scalars['String']>
  /** The default page that displays when a 404 'Page not Found' error occurs. */
  no_route?: Maybe<Scalars['String']>
  /** Payflow Pro vault status. */
  payment_payflowpro_cc_vault_active?: Maybe<Scalars['String']>
  /** Corresponds to the 'Display Prices On Product View Page' field in the Admin. It indicates how FPT information is displayed on product pages. */
  product_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>
  /** Indicates whether product reviews are enabled. Possible values: 1 (Yes) and 0 (No). */
  product_reviews_enabled?: Maybe<Scalars['String']>
  /** The suffix applied to product pages, such as `.htm` or `.html`. */
  product_url_suffix?: Maybe<Scalars['String']>
  /** The number of different character classes (lowercase, uppercase, digits, special characters) required in a password. */
  required_character_classes_number?: Maybe<Scalars['String']>
  /**
   * The ID of the root category.
   * @deprecated Use `root_category_uid` instead.
   */
  root_category_id?: Maybe<Scalars['Int']>
  /** The unique ID for a `CategoryInterface` object. */
  root_category_uid?: Maybe<Scalars['ID']>
  /** Corresponds to the 'Display Prices In Sales Modules' field in the Admin. It indicates how FPT information is displayed on cart, checkout, and order pages. */
  sales_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>
  /** A secure fully-qualified URL that is used to create relative links to the `base_url`. */
  secure_base_link_url?: Maybe<Scalars['String']>
  /** The secure fully-qualified URL that specifies the location of media files. */
  secure_base_media_url?: Maybe<Scalars['String']>
  /** The secure fully-qualified URL that specifies the location of static view files. */
  secure_base_static_url?: Maybe<Scalars['String']>
  /** The store’s fully-qualified secure base URL. */
  secure_base_url?: Maybe<Scalars['String']>
  /** Email to a Friend configuration. */
  send_friend?: Maybe<SendFriendConfiguration>
  /** Indicates whether a breadcrumb trail appears on all CMS pages in the catalog. 0 (No) or 1 (Yes). */
  show_cms_breadcrumbs?: Maybe<Scalars['Int']>
  /** The unique ID of the store view. In the Admin, this is called the Store View Code. When making a GraphQL call, assign this value to the `Store` header to provide the scope. */
  store_code?: Maybe<Scalars['ID']>
  /** The unique ID assigned to the store group. In the Admin, this is called the Store Name. */
  store_group_code?: Maybe<Scalars['ID']>
  /** The label assigned to the store group. */
  store_group_name?: Maybe<Scalars['String']>
  /** The label assigned to the store view. */
  store_name?: Maybe<Scalars['String']>
  /** The store view sort order. */
  store_sort_order?: Maybe<Scalars['Int']>
  /** The time zone of the store. */
  timezone?: Maybe<Scalars['String']>
  /** A prefix that appears before the title to create a two- or three-part title. */
  title_prefix?: Maybe<Scalars['String']>
  /** The character that separates the category name and subcategory in the browser title bar. */
  title_separator?: Maybe<Scalars['String']>
  /** A suffix that appears after the title to create a two- or three-part title. */
  title_suffix?: Maybe<Scalars['String']>
  /** Indicates whether the store code should be used in the URL. */
  use_store_in_url?: Maybe<Scalars['Boolean']>
  /** The unique ID for the website. */
  website_code?: Maybe<Scalars['ID']>
  /**
   * The ID number assigned to the website store.
   * @deprecated The field should not be used on the storefront.
   */
  website_id?: Maybe<Scalars['Int']>
  /** The label assigned to the website. */
  website_name?: Maybe<Scalars['String']>
  /** The unit of weight. */
  weight_unit?: Maybe<Scalars['String']>
  /** Text that appears in the header of the page and includes the name of the logged in customer. */
  welcome?: Maybe<Scalars['String']>
  /** Indicates whether only specific countries can use this payment method. */
  zero_subtotal_enable_for_specific_countries?: Maybe<Scalars['Boolean']>
  /** Indicates whether the Zero Subtotal payment method is enabled. */
  zero_subtotal_enabled?: Maybe<Scalars['Boolean']>
  /** The status of new orders placed using the Zero Subtotal payment method. */
  zero_subtotal_new_order_status?: Maybe<Scalars['String']>
  /** When the new order status is 'Processing', this can be set to `authorize_capture` to automatically invoice all items that have a zero balance. */
  zero_subtotal_payment_action?: Maybe<Scalars['String']>
  /** A comma-separated list of specific countries allowed to use the Zero Subtotal payment method. */
  zero_subtotal_payment_from_specific_countries?: Maybe<Scalars['String']>
  /** A number indicating the position of the Zero Subtotal payment method in the list of available payment methods during checkout. */
  zero_subtotal_sort_order?: Maybe<Scalars['Int']>
  /** The title of the Zero Subtotal payment method displayed on the storefront. */
  zero_subtotal_title?: Maybe<Scalars['String']>
}

/** Store Credit defines basic features of a bundle product and contains multiple BundleItems. */
export type StoreCreditProduct = CustomizableProductInterface &
  ProductInterface & {
    __typename?: 'StoreCreditProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    a_z?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    activity?: Maybe<Scalars['String']>
    /** Advisor Tags based on advisor_tags attribute */
    advisor_tags?: Maybe<Array<Maybe<Scalars['String']>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    allow_credit_range?: Maybe<Scalars['Int']>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    category_gear?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    climate?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    collar?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_public?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_public?: Maybe<Scalars['String']>
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_amount?: Maybe<Scalars['Float']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_rate?: Maybe<Scalars['Float']>
    /** Crosssell Products */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_clinical_trials?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_patient_education?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_tech_sheet?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    eco_collection?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    erin_recommends?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    features_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    format?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['String']>
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    heat_sensitive?: Maybe<Scalars['Int']>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    max_credit?: Maybe<Scalars['Float']>
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    min_credit?: Maybe<Scalars['Float']>
    /** Store Credit product attributes */
    mp_store_credit_attributes?: Maybe<Array<Maybe<StoreCreditProductAttributes>>>
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    natural_product_number?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    new?: Maybe<Scalars['Int']>
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    out_of_stock_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pattern?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    performance_fabric?: Maybe<Scalars['Int']>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    price_range: PriceRange
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>
    /**
     * Product Form based on product_form attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    product_form?: Maybe<Scalars['String']>
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** One of simple, virtual, bundle, downloadable, grouped, or configurable. */
    product_type_id?: Maybe<Scalars['String']>
    /**
     * Prop65 Message
     * @deprecated Use the `custom_attributes` field instead.
     */
    prop65_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    prop_sixty_five?: Maybe<Scalars['Int']>
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars['Float']
    /** An array of products to be displayed in a Related Products block. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The total count of all the reviews given to the product. */
    review_count: Scalars['Int']
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    sale?: Maybe<Scalars['Int']>
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars['Int']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sleeve?: Maybe<Scalars['String']>
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>
    /**
     * Specialty based on specialty attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    specialty?: Maybe<Array<Maybe<Scalars['String']>>>
    /** Stock Item Configuration */
    stock_configuration?: Maybe<StockItemConfiguration>
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>
    /** @deprecated Use the `custom_attributes` field instead. */
    strap_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bottom?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_general?: Maybe<Scalars['String']>
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>
    /** Upsell Products */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
  }

/** Store Credit defines basic features of a bundle product and contains multiple BundleItems. */
export type StoreCreditProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

export type StoreCreditProductAttributes = {
  __typename?: 'StoreCreditProductAttributes'
  /** Attribute code */
  attribute_code?: Maybe<Scalars['String']>
  /** Attribute value */
  value?: Maybe<Scalars['String']>
}

/** Indicates where an attribute can be displayed. */
export type StorefrontProperties = {
  __typename?: 'StorefrontProperties'
  /** The relative position of the attribute in the layered navigation block. */
  position?: Maybe<Scalars['Int']>
  /** Indicates whether the attribute is filterable with results, without results, or not at all. */
  use_in_layered_navigation?: Maybe<UseInLayeredNavigationOptions>
  /** Indicates whether the attribute is displayed in product listings. */
  use_in_product_listing?: Maybe<Scalars['Boolean']>
  /** Indicates whether the attribute can be used in layered navigation on search results pages. */
  use_in_search_results_layered_navigation?: Maybe<Scalars['Boolean']>
  /** Indicates whether the attribute is displayed on product pages. */
  visible_on_catalog_pages?: Maybe<Scalars['Boolean']>
}

/** Contains the result of the `subscribeEmailToNewsletter` operation. */
export type SubscribeEmailToNewsletterOutput = {
  __typename?: 'SubscribeEmailToNewsletterOutput'
  /** The status of the subscription request. */
  status?: Maybe<SubscriptionStatusesEnum>
}

/** Indicates the status of the request. */
export const SubscriptionStatusesEnum = {
  NotActive: 'NOT_ACTIVE',
  Subscribed: 'SUBSCRIBED',
  Unconfirmed: 'UNCONFIRMED',
  Unsubscribed: 'UNSUBSCRIBED',
} as const

export type SubscriptionStatusesEnum =
  (typeof SubscriptionStatusesEnum)[keyof typeof SubscriptionStatusesEnum]
/** Describes the swatch type and a value. */
export type SwatchData = {
  __typename?: 'SwatchData'
  /** The type of swatch filter item: 1 - text; 2 - image. */
  type?: Maybe<Scalars['String']>
  /** The value for the swatch item. It could be text or an image link. */
  value?: Maybe<Scalars['String']>
}

export type SwatchDataInterface = {
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>
}

export type SwatchLayerFilterItem = LayerFilterItemInterface &
  SwatchLayerFilterItemInterface & {
    __typename?: 'SwatchLayerFilterItem'
    /**
     * The count of items per filter.
     * @deprecated Use `AggregationOption.count` instead.
     */
    items_count?: Maybe<Scalars['Int']>
    /**
     * The label for a filter.
     * @deprecated Use `AggregationOption.label` instead.
     */
    label?: Maybe<Scalars['String']>
    /** Data required to render a swatch filter item. */
    swatch_data?: Maybe<SwatchData>
    /**
     * The value of a filter request variable to be used in query.
     * @deprecated Use `AggregationOption.value` instead.
     */
    value_string?: Maybe<Scalars['String']>
  }

export type SwatchLayerFilterItemInterface = {
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<SwatchData>
}

/** Contains tax item details. */
export type TaxItem = {
  __typename?: 'TaxItem'
  /** The amount of tax applied to the item. */
  amount: Money
  /** The rate used to calculate the tax. */
  rate: Scalars['Float']
  /** A title that describes the tax. */
  title: Scalars['String']
}

export type TextSwatchData = SwatchDataInterface & {
  __typename?: 'TextSwatchData'
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>
}

/** Defines a price based on the quantity purchased. */
export type TierPrice = {
  __typename?: 'TierPrice'
  /** The price discount that this tier represents. */
  discount?: Maybe<ProductDiscount>
  /** The price of the product at this tier. */
  final_price?: Maybe<Money>
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity?: Maybe<Scalars['Float']>
}

/** A stored payment account/credit card. */
export type TokenBaseCard = {
  __typename?: 'TokenBaseCard'
  /** Is card active */
  active?: Maybe<Scalars['Boolean']>
  /** Card payment data */
  additional?: Maybe<TokenBaseCardAdditional>
  /** Card billing address */
  address?: Maybe<CustomerAddress>
  /** Created-at date */
  created_at?: Maybe<Scalars['String']>
  /** Customer email */
  customer_email?: Maybe<Scalars['String']>
  /** Customer ID */
  customer_id?: Maybe<Scalars['Int']>
  /** Created-by IP */
  customer_ip?: Maybe<Scalars['String']>
  /** Expiration date */
  expires?: Maybe<Scalars['String']>
  /** Card identifier hash */
  hash?: Maybe<Scalars['String']>
  /** Card label */
  label?: Maybe<Scalars['String']>
  /** Last used date */
  last_use?: Maybe<Scalars['String']>
  /** Payment method code */
  method?: Maybe<Scalars['String']>
  /** Card gateway payment ID */
  payment_id?: Maybe<Scalars['String']>
  /** Card gateway profile ID */
  profile_id?: Maybe<Scalars['String']>
  /** Last updated date */
  updated_at?: Maybe<Scalars['String']>
}

/** Details and metadata for a stored CC/ACH. */
export type TokenBaseCardAdditional = {
  __typename?: 'TokenBaseCardAdditional'
  /** CC Bin (First-6) */
  cc_bin?: Maybe<Scalars['String']>
  /** CC Expiration Month */
  cc_exp_month?: Maybe<Scalars['String']>
  /** CC Expiration Year */
  cc_exp_year?: Maybe<Scalars['String']>
  /** CC Last-4 */
  cc_last4?: Maybe<Scalars['String']>
  /** CC Owner */
  cc_owner?: Maybe<Scalars['String']>
  /** CC Type */
  cc_type?: Maybe<Scalars['String']>
  /** ACH Account Name */
  echeck_account_name?: Maybe<Scalars['String']>
  /** ACH Account Number */
  echeck_account_no?: Maybe<Scalars['String']>
  /** ACH Account Number Last-4 */
  echeck_account_number_last4?: Maybe<Scalars['String']>
  /** ACH Account Type */
  echeck_account_type?: Maybe<TokenBaseEcheckAccountType>
  /** ACH Bank Name */
  echeck_bank_name?: Maybe<Scalars['String']>
  /** ACH Routing Number */
  echeck_routing_no?: Maybe<Scalars['String']>
  /** ACH Routing Number Last-4 */
  echeck_routing_number_last4?: Maybe<Scalars['String']>
  /** ACH Transaction Type */
  echeck_type?: Maybe<Scalars['String']>
  /** Payment Type */
  payment_type?: Maybe<Scalars['String']>
}

/** Input for creating a stored card. */
export type TokenBaseCardCreateInput = {
  /** Is card active */
  active?: InputMaybe<Scalars['Boolean']>
  /** Card payment data */
  additional?: InputMaybe<TokenBaseCardPaymentInput>
  /** Card billing address */
  address?: InputMaybe<CustomerAddressInput>
  /** Customer email (required) */
  customer_email: Scalars['String']
  /** Created-by IP */
  customer_ip?: InputMaybe<Scalars['String']>
  /** Card expiration date (YYYY-MM-DD 23:59:59) */
  expires?: InputMaybe<Scalars['String']>
  /** Payment method code (required) */
  method: Scalars['String']
  /** Card gateway payment ID */
  payment_id?: InputMaybe<Scalars['String']>
  /** Card gateway profile ID */
  profile_id?: InputMaybe<Scalars['String']>
}

/** Payment data for a stored card. Note, the specific fields that are relevant depend on the payment method. */
export type TokenBaseCardPaymentInput = {
  /** TokenBase Card Hash (used only during checkout) */
  card_id?: InputMaybe<Scalars['String']>
  /** CC Bin (First-6) */
  cc_bin?: InputMaybe<Scalars['String']>
  /** CC CVV */
  cc_cid?: InputMaybe<Scalars['String']>
  /** CC Expiration Month */
  cc_exp_month?: InputMaybe<Scalars['String']>
  /** The full CC Expiration Year, ex: 2022 */
  cc_exp_year?: InputMaybe<Scalars['String']>
  /** CC Last-4 */
  cc_last4?: InputMaybe<Scalars['String']>
  /** CC Number */
  cc_number?: InputMaybe<Scalars['String']>
  /** CC Owner */
  cc_owner?: InputMaybe<Scalars['String']>
  /** CC Type */
  cc_type?: InputMaybe<Scalars['String']>
  /** ACH Account Name */
  echeck_account_name?: InputMaybe<Scalars['String']>
  /** ACH Account Number */
  echeck_account_no?: InputMaybe<Scalars['String']>
  /** ACH Account Type */
  echeck_account_type?: InputMaybe<TokenBaseEcheckAccountType>
  /** ACH Bank Name */
  echeck_bank_name?: InputMaybe<Scalars['String']>
  /** ACH Routing Number */
  echeck_routing_no?: InputMaybe<Scalars['String']>
  /** ACH Transaction Type */
  echeck_type?: InputMaybe<Scalars['String']>
  payerauth_session_id?: InputMaybe<Scalars['String']>
  /** Payment Type */
  payment_type?: InputMaybe<Scalars['String']>
  response_jwt?: InputMaybe<Scalars['String']>
  /** Save card (used only during checkout) */
  save?: InputMaybe<Scalars['Boolean']>
}

/** Input for updating a stored card. */
export type TokenBaseCardUpdateInput = {
  /** Is card active */
  active?: InputMaybe<Scalars['Boolean']>
  /** Card payment data */
  additional?: InputMaybe<TokenBaseCardPaymentInput>
  /** Card billing address */
  address?: InputMaybe<CustomerAddressInput>
  /** Customer email */
  customer_email?: InputMaybe<Scalars['String']>
  /** Created-by IP */
  customer_ip?: InputMaybe<Scalars['String']>
  /** Card expiration date (YYYY-MM-DD 23:59:59) */
  expires?: InputMaybe<Scalars['String']>
  /** Card identifier hash to update (required) */
  hash: Scalars['String']
  /** Payment method code */
  method?: InputMaybe<Scalars['String']>
}

/** Checkout configuration for a TokenBase payment method. */
export type TokenBaseCheckoutConfig = {
  __typename?: 'TokenBaseCheckoutConfig'
  /** Available CC types */
  availableTypes?: Maybe<Array<Maybe<TokenBaseKeyValue>>>
  /** Can cards be saved? */
  canSaveCard?: Maybe<Scalars['Boolean']>
  /** Is CC BIN (first6) storage enabled? */
  canStoreBin?: Maybe<Scalars['Boolean']>
  cardinalAuthUrl?: Maybe<Scalars['String']>
  cardinalJWT?: Maybe<Scalars['String']>
  cardinalScript?: Maybe<Scalars['String']>
  /** CVV helper image URL */
  cvvImageUrl?: Maybe<Scalars['String']>
  /** Hash of the default card to select */
  defaultSaveCard?: Maybe<Scalars['Boolean']>
  fingerprintUrl?: Maybe<Scalars['String']>
  /** Is card saving forced? */
  forceSaveCard?: Maybe<Scalars['Boolean']>
  /** Is CVV enabled? */
  hasVerification?: Maybe<Scalars['Boolean']>
  /** Is CC type detection enabled? */
  isCcDetectionEnabled?: Maybe<Scalars['Boolean']>
  /** Payment logo image URL (if enabled) */
  logoImage?: Maybe<Scalars['String']>
  /** Payment method code */
  method?: Maybe<Scalars['String']>
  /** Available CC Exp Months */
  months?: Maybe<Array<Maybe<TokenBaseKeyValue>>>
  paramUrl?: Maybe<Scalars['String']>
  /** Is CVV required for stored cards? */
  requireCcv?: Maybe<Scalars['Boolean']>
  /** Is the payment gateway in sandbox mode? */
  sandbox?: Maybe<Scalars['Boolean']>
  /** Are stored cards enabled? */
  useVault?: Maybe<Scalars['Boolean']>
  /** Available CC Exp Years */
  years?: Maybe<Array<Maybe<TokenBaseKeyValue>>>
}

export type TokenBaseCyberSourceCardinalCruiseAuthInput = {
  cardId?: InputMaybe<Scalars['String']>
  cartId: Scalars['String']
  guestEmail?: InputMaybe<Scalars['String']>
}

export type TokenBaseCyberSourceCardinalCruiseParams = {
  __typename?: 'TokenBaseCyberSourceCardinalCruiseParams'
  JWT?: Maybe<Scalars['String']>
  authPayload?: Maybe<Scalars['String']>
  orderPayload?: Maybe<Scalars['String']>
}

export type TokenBaseCyberSourceSecureAcceptInput = {
  billingAddress?: InputMaybe<CustomerAddressInput>
  cardId?: InputMaybe<Scalars['String']>
  cartId?: InputMaybe<Scalars['String']>
  guestEmail?: InputMaybe<Scalars['String']>
  source: TokenBaseCyberSourceSecureAcceptSource
}

export type TokenBaseCyberSourceSecureAcceptParams = {
  __typename?: 'TokenBaseCyberSourceSecureAcceptParams'
  iframeAction?: Maybe<Scalars['String']>
  iframeParams?: Maybe<Scalars['String']>
}

export const TokenBaseCyberSourceSecureAcceptSource = {
  Checkout: 'checkout',
  Paymentinfo: 'paymentinfo',
} as const

export type TokenBaseCyberSourceSecureAcceptSource =
  (typeof TokenBaseCyberSourceSecureAcceptSource)[keyof typeof TokenBaseCyberSourceSecureAcceptSource]
export const TokenBaseEcheckAccountType = {
  BusinessChecking: 'businessChecking',
  Checking: 'checking',
  Savings: 'savings',
} as const

export type TokenBaseEcheckAccountType =
  (typeof TokenBaseEcheckAccountType)[keyof typeof TokenBaseEcheckAccountType]
/** Container for generic key/value data. */
export type TokenBaseKeyValue = {
  __typename?: 'TokenBaseKeyValue'
  /** Generic key */
  key?: Maybe<Scalars['String']>
  /** Generic value */
  value?: Maybe<Scalars['String']>
}

export type TotalSegmentsOutput = {
  __typename?: 'TotalSegmentsOutput'
  code?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
}

/** Modifies the specified items in the cart. */
export type UpdateCartItemsInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']
  /** An array of items to be updated. */
  cart_items: Array<InputMaybe<CartItemUpdateInput>>
}

/** Contains details about the cart after updating items. */
export type UpdateCartItemsOutput = {
  __typename?: 'UpdateCartItemsOutput'
  /** The cart after updating products. */
  cart: Cart
}

/** Contains the customer's wish list and any errors encountered. */
export type UpdateProductsInWishlistOutput = {
  __typename?: 'UpdateProductsInWishlistOutput'
  /** An array of errors encountered while updating products in a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>
  /** Contains the wish list with all items that were successfully updated. */
  wishlist: Wishlist
}

/** Contains URL rewrite details. */
export type UrlRewrite = {
  __typename?: 'UrlRewrite'
  /** An array of request parameters. */
  parameters?: Maybe<Array<Maybe<HttpQueryParameter>>>
  /** The request URL. */
  url?: Maybe<Scalars['String']>
}

/** This enumeration defines the entity type. */
export const UrlRewriteEntityTypeEnum = {
  Category: 'CATEGORY',
  CmsPage: 'CMS_PAGE',
  Product: 'PRODUCT',
} as const

export type UrlRewriteEntityTypeEnum =
  (typeof UrlRewriteEntityTypeEnum)[keyof typeof UrlRewriteEntityTypeEnum]
/** Defines whether the attribute is filterable in layered navigation. */
export const UseInLayeredNavigationOptions = {
  FilterableNoResult: 'FILTERABLE_NO_RESULT',
  FilterableWithResults: 'FILTERABLE_WITH_RESULTS',
  No: 'NO',
} as const

export type UseInLayeredNavigationOptions =
  (typeof UseInLayeredNavigationOptions)[keyof typeof UseInLayeredNavigationOptions]
/** Contains required input for payment methods with Vault support. */
export type VaultTokenInput = {
  /** The public hash of the payment token. */
  public_hash: Scalars['String']
}

/** An implementation for virtual product cart items. */
export type VirtualCartItem = CartItemInterface & {
  __typename?: 'VirtualCartItem'
  /** An array containing customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']
  /** Cart item attributes */
  item_attributes?: Maybe<CartItemAttributes>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']
}

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProduct = CustomizableProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'VirtualProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    a_z?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    activity?: Maybe<Scalars['String']>
    /** Advisor Tags based on advisor_tags attribute */
    advisor_tags?: Maybe<Array<Maybe<Scalars['String']>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    allow_credit_range?: Maybe<Scalars['Int']>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    category_gear?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    climate?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    collar?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_left_public?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_both?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_patient?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_professional?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    content_right_public?: Maybe<Scalars['String']>
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_amount?: Maybe<Scalars['Float']>
    /** @deprecated Use the `custom_attributes` field instead. */
    credit_rate?: Maybe<Scalars['Float']>
    /** Crosssell Products */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_clinical_trials?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_patient_education?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    doc_tech_sheet?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    eco_collection?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    erin_recommends?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    features_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    format?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['String']>
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    heat_sensitive?: Maybe<Scalars['Int']>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars['Int']>
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    max_credit?: Maybe<Scalars['Float']>
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    min_credit?: Maybe<Scalars['Float']>
    /** Store Credit product attributes */
    mp_store_credit_attributes?: Maybe<Array<Maybe<StoreCreditProductAttributes>>>
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    natural_product_number?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    new?: Maybe<Scalars['Int']>
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    out_of_stock_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pattern?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    performance_fabric?: Maybe<Scalars['Int']>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    price_range: PriceRange
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>
    /**
     * Product Form based on product_form attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    product_form?: Maybe<Scalars['String']>
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** One of simple, virtual, bundle, downloadable, grouped, or configurable. */
    product_type_id?: Maybe<Scalars['String']>
    /**
     * Prop65 Message
     * @deprecated Use the `custom_attributes` field instead.
     */
    prop65_message?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    prop_sixty_five?: Maybe<Scalars['Int']>
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars['Float']
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int']
    /** An array of products to be displayed in a Related Products block. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>
    /** The total count of all the reviews given to the product. */
    review_count: Scalars['Int']
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    sale?: Maybe<Scalars['Int']>
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars['Int']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sleeve?: Maybe<Scalars['String']>
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>
    /**
     * Specialty based on specialty attribute
     * @deprecated Use the `custom_attributes` field instead.
     */
    specialty?: Maybe<Array<Maybe<Scalars['String']>>>
    /** Stock Item Configuration */
    stock_configuration?: Maybe<StockItemConfiguration>
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>
    /** @deprecated Use the `custom_attributes` field instead. */
    strap_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bags?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_bottom?: Maybe<Scalars['String']>
    /** @deprecated Use the `custom_attributes` field instead. */
    style_general?: Maybe<Scalars['String']>
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>
    /** Upsell Products */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
  }

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

/** Defines a single product to add to the cart. */
export type VirtualProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput
}

/** Contains a virtual product wish list item. */
export type VirtualWishlistItem = WishlistItemInterface & {
  __typename?: 'VirtualWishlistItem'
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']
}

/** Deprecated. It should not be used on the storefront. Contains information about a website. */
export type Website = {
  __typename?: 'Website'
  /**
   * A code assigned to the website to identify it.
   * @deprecated The field should not be used on the storefront.
   */
  code?: Maybe<Scalars['String']>
  /**
   * The default group ID of the website.
   * @deprecated The field should not be used on the storefront.
   */
  default_group_id?: Maybe<Scalars['String']>
  /**
   * The ID number assigned to the website.
   * @deprecated The field should not be used on the storefront.
   */
  id?: Maybe<Scalars['Int']>
  /**
   * Indicates whether this is the default website.
   * @deprecated The field should not be used on the storefront.
   */
  is_default?: Maybe<Scalars['Boolean']>
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name?: Maybe<Scalars['String']>
  /**
   * The attribute to use for sorting websites.
   * @deprecated The field should not be used on the storefront.
   */
  sort_order?: Maybe<Scalars['Int']>
}

/** An error encountered while performing operations with WishList. */
export type WishListUserInputError = {
  __typename?: 'WishListUserInputError'
  /** A wish list-specific error code. */
  code: WishListUserInputErrorType
  /** A localized error message. */
  message: Scalars['String']
}

/** A list of possible error types. */
export const WishListUserInputErrorType = {
  ProductNotFound: 'PRODUCT_NOT_FOUND',
  Undefined: 'UNDEFINED',
} as const

export type WishListUserInputErrorType =
  (typeof WishListUserInputErrorType)[keyof typeof WishListUserInputErrorType]
/** Contains a customer wish list. */
export type Wishlist = {
  __typename?: 'Wishlist'
  /** The unique ID for a `Wishlist` object. */
  id?: Maybe<Scalars['ID']>
  /** @deprecated Use the `items_v2` field instead. */
  items?: Maybe<Array<Maybe<WishlistItem>>>
  /** The number of items in the wish list. */
  items_count?: Maybe<Scalars['Int']>
  /** An array of items in the customer's wish list. */
  items_v2?: Maybe<WishlistItems>
  /** An encrypted code that Magento uses to link to the wish list. */
  sharing_code?: Maybe<Scalars['String']>
  /** The time of the last modification to the wish list. */
  updated_at?: Maybe<Scalars['String']>
}

/** Contains a customer wish list. */
export type WishlistItems_V2Args = {
  currentPage?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

/** Contains details about errors encountered when a customer added wish list items to the cart. */
export type WishlistCartUserInputError = {
  __typename?: 'WishlistCartUserInputError'
  /** An error code that describes the error encountered. */
  code: WishlistCartUserInputErrorType
  /** A localized error message. */
  message: Scalars['String']
  /** The unique ID of the `Wishlist` object containing an error. */
  wishlistId: Scalars['ID']
  /** The unique ID of the wish list item containing an error. */
  wishlistItemId: Scalars['ID']
}

/** A list of possible error types. */
export const WishlistCartUserInputErrorType = {
  InsufficientStock: 'INSUFFICIENT_STOCK',
  NotSalable: 'NOT_SALABLE',
  ProductNotFound: 'PRODUCT_NOT_FOUND',
  Undefined: 'UNDEFINED',
} as const

export type WishlistCartUserInputErrorType =
  (typeof WishlistCartUserInputErrorType)[keyof typeof WishlistCartUserInputErrorType]
/** Contains details about a wish list item. */
export type WishlistItem = {
  __typename?: 'WishlistItem'
  /** The time when the customer added the item to the wish list. */
  added_at?: Maybe<Scalars['String']>
  /** The customer's comment about this item. */
  description?: Maybe<Scalars['String']>
  /** The unique ID for a `WishlistItem` object. */
  id?: Maybe<Scalars['Int']>
  /** Details about the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item */
  qty?: Maybe<Scalars['Float']>
}

/** Defines the items to add to a wish list. */
export type WishlistItemInput = {
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>
  /** For complex product types, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars['String']>
  /** The amount or number of items to add. */
  quantity: Scalars['Float']
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  /** The SKU of the product to add. For complex product types, specify the child product SKU. */
  sku: Scalars['String']
}

/** The interface for wish list items. */
export type WishlistItemInterface = {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']
}

/** Defines updates to items in a wish list. */
export type WishlistItemUpdateInput = {
  /** Customer-entered comments about the item. */
  description?: InputMaybe<Scalars['String']>
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>
  /** The new amount or number of this item. */
  quantity?: InputMaybe<Scalars['Float']>
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  /** The unique ID for a `WishlistItemInterface` object. */
  wishlist_item_id: Scalars['ID']
}

/** Contains an array of items in a wish list. */
export type WishlistItems = {
  __typename?: 'WishlistItems'
  /** A list of items in the wish list. */
  items: Array<Maybe<WishlistItemInterface>>
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>
}

/** Deprecated: Use the `Wishlist` type instead. */
export type WishlistOutput = {
  __typename?: 'WishlistOutput'
  /**
   * An array of items in the customer's wish list
   * @deprecated Use the `Wishlist.items` field instead.
   */
  items?: Maybe<Array<Maybe<WishlistItem>>>
  /**
   * The number of items in the wish list.
   * @deprecated Use the `Wishlist.items_count` field instead.
   */
  items_count?: Maybe<Scalars['Int']>
  /**
   * When multiple wish lists are enabled, the name the customer assigns to the wishlist.
   * @deprecated This field is related to Commerce functionality and is always `null` in Open Source.
   */
  name?: Maybe<Scalars['String']>
  /**
   * An encrypted code that links to the wish list.
   * @deprecated Use the `Wishlist.sharing_code` field instead.
   */
  sharing_code?: Maybe<Scalars['String']>
  /**
   * The time of the last modification to the wish list.
   * @deprecated Use the `Wishlist.updated_at` field instead.
   */
  updated_at?: Maybe<Scalars['String']>
}

/** Assigns a specific `cart_id` to the empty cart. */
export type CreateEmptyCartInput = {
  /** The ID to assign to the cart. */
  cart_id?: InputMaybe<Scalars['String']>
}

export type GetCountriesQueryVariables = Exact<{ [key: string]: never }>

export type GetCountriesQuery = {
  __typename?: 'Query'
  countries?: Array<{
    __typename?: 'Country'
    id?: string | null
    two_letter_abbreviation?: string | null
    three_letter_abbreviation?: string | null
    full_name_locale?: string | null
    full_name_english?: string | null
    available_regions?: Array<{
      __typename?: 'Region'
      id?: number | null
      code?: string | null
      name?: string | null
    } | null> | null
  } | null> | null
}

export type CreateCustomerAddressMutationVariables = Exact<{
  input: CustomerAddressInput
}>

export type CreateCustomerAddressMutation = {
  __typename?: 'Mutation'
  createCustomerAddress?: {
    __typename?: 'CustomerAddress'
    id?: number | null
    country_code?: CountryCodeEnum | null
    street?: Array<string | null> | null
    telephone?: string | null
    postcode?: string | null
    company?: string | null
    city?: string | null
    firstname?: string | null
    lastname?: string | null
    default_shipping?: boolean | null
    default_billing?: boolean | null
    region?: {
      __typename?: 'CustomerAddressRegion'
      region?: string | null
      region_code?: string | null
      region_id?: number | null
    } | null
  } | null
}

export type DeleteCustomerAddressMutationVariables = Exact<{
  id: Scalars['Int']
}>

export type DeleteCustomerAddressMutation = {
  __typename?: 'Mutation'
  deleteCustomerAddress?: boolean | null
}

export type UpdateCustomerAddressMutationVariables = Exact<{
  id: Scalars['Int']
  input?: InputMaybe<CustomerAddressInput>
}>

export type UpdateCustomerAddressMutation = {
  __typename?: 'Mutation'
  updateCustomerAddress?: {
    __typename?: 'CustomerAddress'
    id?: number | null
    country_code?: CountryCodeEnum | null
    street?: Array<string | null> | null
    telephone?: string | null
    postcode?: string | null
    company?: string | null
    city?: string | null
    firstname?: string | null
    lastname?: string | null
    default_shipping?: boolean | null
    default_billing?: boolean | null
    region?: {
      __typename?: 'CustomerAddressRegion'
      region?: string | null
      region_code?: string | null
      region_id?: number | null
    } | null
  } | null
}

export type CustomerAddressFragment = {
  __typename?: 'CustomerAddress'
  id?: number | null
  country_code?: CountryCodeEnum | null
  street?: Array<string | null> | null
  telephone?: string | null
  postcode?: string | null
  company?: string | null
  city?: string | null
  firstname?: string | null
  lastname?: string | null
  default_shipping?: boolean | null
  default_billing?: boolean | null
  region?: {
    __typename?: 'CustomerAddressRegion'
    region?: string | null
    region_code?: string | null
    region_id?: number | null
  } | null
}

export type GetCustomerAddressesQueryVariables = Exact<{ [key: string]: never }>

export type GetCustomerAddressesQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    default_billing?: string | null
    default_shipping?: string | null
    email?: string | null
    addresses?: Array<{
      __typename?: 'CustomerAddress'
      id?: number | null
      country_code?: CountryCodeEnum | null
      street?: Array<string | null> | null
      telephone?: string | null
      postcode?: string | null
      company?: string | null
      city?: string | null
      firstname?: string | null
      lastname?: string | null
      default_shipping?: boolean | null
      default_billing?: boolean | null
      region?: {
        __typename?: 'CustomerAddressRegion'
        region?: string | null
        region_code?: string | null
        region_id?: number | null
      } | null
    } | null> | null
    latestOrderAddress?: {
      __typename?: 'CustomerOrders'
      items: Array<{
        __typename?: 'CustomerOrder'
        id: string
        order_date: string
        billing_address?: {
          __typename?: 'OrderAddress'
          city: string
          company?: string | null
          country_code?: CountryCodeEnum | null
          firstname: string
          lastname: string
          postcode?: string | null
          region?: string | null
          region_id?: string | null
          street: Array<string | null>
          telephone?: string | null
        } | null
        shipping_address?: {
          __typename?: 'OrderAddress'
          city: string
          company?: string | null
          country_code?: CountryCodeEnum | null
          firstname: string
          lastname: string
          postcode?: string | null
          region?: string | null
          region_id?: string | null
          street: Array<string | null>
          telephone?: string | null
        } | null
      } | null>
    } | null
  } | null
}

export type RequestApplePaySessionMutationVariables = Exact<{
  validationUrl?: InputMaybe<Scalars['String']>
}>

export type RequestApplePaySessionMutation = {
  __typename?: 'Mutation'
  requestApplePaySession?: {
    __typename?: 'ApplePaymentMerchantSession'
    session?: string | null
  } | null
}

export type CreateCustomerCardMutationVariables = Exact<{
  input: TokenBaseCardCreateInput
}>

export type CreateCustomerCardMutation = {
  __typename?: 'Mutation'
  createTokenBaseCard?: {
    __typename?: 'TokenBaseCard'
    active?: boolean | null
    hash?: string | null
    label?: string | null
    last_use?: string | null
    updated_at?: string | null
    additional?: {
      __typename?: 'TokenBaseCardAdditional'
      cc_bin?: string | null
      cc_exp_month?: string | null
      cc_exp_year?: string | null
      cc_last4?: string | null
      cc_owner?: string | null
      cc_type?: string | null
    } | null
    address?: {
      __typename?: 'CustomerAddress'
      city?: string | null
      company?: string | null
      country_code?: CountryCodeEnum | null
      country_id?: string | null
      firstname?: string | null
      lastname?: string | null
      postcode?: string | null
      street?: Array<string | null> | null
      telephone?: string | null
      region?: {
        __typename?: 'CustomerAddressRegion'
        region?: string | null
        region_code?: string | null
        region_id?: number | null
      } | null
    } | null
  } | null
}

export type DeleteCustomerCardMutationVariables = Exact<{
  hash: Scalars['String']
}>

export type DeleteCustomerCardMutation = {
  __typename?: 'Mutation'
  deleteTokenBaseCard?: boolean | null
}

export type AddSimpleAndVirtualProductsToCartMutationVariables = Exact<{
  cartId: Scalars['String']
  simpleCartItems:
    | Array<InputMaybe<SimpleProductCartItemInput>>
    | InputMaybe<SimpleProductCartItemInput>
  virtualCartItems:
    | Array<InputMaybe<VirtualProductCartItemInput>>
    | InputMaybe<VirtualProductCartItemInput>
}>

export type AddSimpleAndVirtualProductsToCartMutation = {
  __typename?: 'Mutation'
  addSimpleProductsToCart?: {
    __typename?: 'AddSimpleProductsToCartOutput'
    cart: { __typename?: 'Cart'; id: string }
  } | null
  addVirtualProductsToCart?: {
    __typename?: 'AddVirtualProductsToCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type AddSimpleProductsToCartMutationVariables = Exact<{
  cartId: Scalars['String']
  cartItems: Array<InputMaybe<SimpleProductCartItemInput>> | InputMaybe<SimpleProductCartItemInput>
}>

export type AddSimpleProductsToCartMutation = {
  __typename?: 'Mutation'
  addSimpleProductsToCart?: {
    __typename?: 'AddSimpleProductsToCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type ApplyCouponToCartMutationVariables = Exact<{
  cartId: Scalars['String']
  couponCode: Scalars['String']
}>

export type ApplyCouponToCartMutation = {
  __typename?: 'Mutation'
  applyCouponToCart?: {
    __typename?: 'ApplyCouponToCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type SetBillingAddressAndPaymentMethodOnCartMutationVariables = Exact<{
  cartId: Scalars['String']
  billingAddress: BillingAddressInput
  paymentMethod: PaymentMethodInput
}>

export type SetBillingAddressAndPaymentMethodOnCartMutation = {
  __typename?: 'Mutation'
  setBillingAddressOnCart?: {
    __typename?: 'SetBillingAddressOnCartOutput'
    cart: { __typename?: 'Cart'; id: string }
  } | null
  setPaymentMethodOnCart?: {
    __typename?: 'SetPaymentMethodOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type SetBillingAddressOnCartMutationVariables = Exact<{
  cartId: Scalars['String']
  billingAddress: BillingAddressInput
}>

export type SetBillingAddressOnCartMutation = {
  __typename?: 'Mutation'
  setBillingAddressOnCart?: {
    __typename?: 'SetBillingAddressOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type CreateEmptyCartMutationVariables = Exact<{ [key: string]: never }>

export type CreateEmptyCartMutation = { __typename?: 'Mutation'; createEmptyCart?: string | null }

export type SetDropShipOnCartMutationVariables = Exact<{
  cartId: Scalars['String']
  dropShip: Scalars['String']
}>

export type SetDropShipOnCartMutation = {
  __typename?: 'Mutation'
  setDropShipOnCart?: {
    __typename?: 'SetDropShipOnCartOutput'
    cart: { __typename?: 'Cart'; id: string; drop_ship?: string | null }
  } | null
}

export type SetGuestEmailOnCartMinimalMutationVariables = Exact<{
  cartId: Scalars['String']
  email: Scalars['String']
}>

export type SetGuestEmailOnCartMinimalMutation = {
  __typename?: 'Mutation'
  setGuestEmailOnCart?: {
    __typename?: 'SetGuestEmailOnCartOutput'
    cart: { __typename?: 'Cart'; id: string; email?: string | null }
  } | null
}

export type SetGuestEmailAndShippingAddressesOnCartMutationVariables = Exact<{
  cartId: Scalars['String']
  email: Scalars['String']
  shippingAddress: Array<InputMaybe<ShippingAddressInput>> | InputMaybe<ShippingAddressInput>
}>

export type SetGuestEmailAndShippingAddressesOnCartMutation = {
  __typename?: 'Mutation'
  setGuestEmailOnCart?: {
    __typename?: 'SetGuestEmailOnCartOutput'
    cart: { __typename?: 'Cart'; id: string; email?: string | null }
  } | null
  setShippingAddressesOnCart?: {
    __typename?: 'SetShippingAddressesOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type SetGuestEmailOnCartMutationVariables = Exact<{
  cartId: Scalars['String']
  email: Scalars['String']
}>

export type SetGuestEmailOnCartMutation = {
  __typename?: 'Mutation'
  setGuestEmailOnCart?: {
    __typename?: 'SetGuestEmailOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type GetGuestCartQueryVariables = Exact<{
  cartId: Scalars['String']
}>

export type GetGuestCartQuery = {
  __typename?: 'Query'
  cart?: {
    __typename?: 'Cart'
    id: string
    email?: string | null
    hold_until_monday?: string | null
    drop_ship?: string | null
    total_quantity: number
    dispensary_promo_code?: string | null
    practitioner_code?: string | null
    ww_id?: string | null
    ww_store_id?: string | null
    ww_practice_id?: string | null
    ww_practitioner_id?: string | null
    e_script_campaign?: string | null
    prices?: {
      __typename?: 'CartPrices'
      applied_taxes?: Array<{
        __typename?: 'CartTaxItem'
        label: string
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null> | null
      colorado_retail_delivery_fee?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      discounts?: Array<{
        __typename?: 'Discount'
        label: string
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null> | null
      grand_total?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      subtotal_excluding_tax?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      subtotal_including_tax?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      subtotal_with_discount_excluding_tax?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
    } | null
    available_payment_methods?: Array<{
      __typename?: 'AvailablePaymentMethod'
      code: string
      title: string
    } | null> | null
    billing_address?: {
      __typename?: 'BillingCartAddress'
      city: string
      firstname: string
      lastname: string
      postcode?: string | null
      street: Array<string | null>
      telephone?: string | null
      country: { __typename?: 'CartAddressCountry'; code: string; label: string }
      region?: {
        __typename?: 'CartAddressRegion'
        code?: string | null
        label?: string | null
        region_id?: number | null
      } | null
    } | null
    items?: Array<
      | {
          __typename?: 'BundleCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'ConfigurableCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'DownloadableCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'SimpleCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'VirtualCartItem'
          id: string
          quantity: number
          customizable_options: Array<{
            __typename?: 'SelectedCustomizableOption'
            id: number
            label: string
            sort_order: number
            values: Array<{
              __typename?: 'SelectedCustomizableOptionValue'
              id: number
              label: string
              value: string
            } | null>
          } | null>
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | null
    > | null
    applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
    rebate?: { __typename?: 'Money'; value?: number | null } | null
    shipping_addresses: Array<{
      __typename?: 'ShippingCartAddress'
      city: string
      firstname: string
      lastname: string
      postcode?: string | null
      street: Array<string | null>
      telephone?: string | null
      country: { __typename?: 'CartAddressCountry'; code: string; label: string }
      region?: {
        __typename?: 'CartAddressRegion'
        code?: string | null
        label?: string | null
        region_id?: number | null
      } | null
      available_shipping_methods?: Array<{
        __typename?: 'AvailableShippingMethod'
        available: boolean
        carrier_code: string
        carrier_title: string
        error_message?: string | null
        method_code?: string | null
        method_title?: string | null
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null> | null
      selected_shipping_method?: {
        __typename?: 'SelectedShippingMethod'
        carrier_code: string
        carrier_title: string
        method_code: string
        method_title: string
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null
    } | null>
    selected_payment_method?: {
      __typename?: 'SelectedPaymentMethod'
      code: string
      purchase_order_number?: string | null
      title: string
      tokenbase_card_id?: string | null
      tokenbase_data?: {
        __typename?: 'TokenBaseCardAdditional'
        cc_last4?: string | null
        cc_exp_year?: string | null
        cc_exp_month?: string | null
        cc_type?: string | null
      } | null
    } | null
  } | null
}

export type SetHoldUntilMondayOnCartMutationVariables = Exact<{
  cartId: Scalars['String']
  holdUntilMonday: Scalars['String']
}>

export type SetHoldUntilMondayOnCartMutation = {
  __typename?: 'Mutation'
  setHoldUntilMondayOnCart?: {
    __typename?: 'SetHoldUntilMondayOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type MergeCartsMutationVariables = Exact<{
  sourceCartId: Scalars['String']
  destinationCartId: Scalars['String']
}>

export type MergeCartsMutation = {
  __typename?: 'Mutation'
  mergeCarts: {
    __typename?: 'Cart'
    id: string
    email?: string | null
    hold_until_monday?: string | null
    drop_ship?: string | null
    total_quantity: number
    dispensary_promo_code?: string | null
    practitioner_code?: string | null
    ww_id?: string | null
    ww_store_id?: string | null
    ww_practice_id?: string | null
    ww_practitioner_id?: string | null
    e_script_campaign?: string | null
    prices?: {
      __typename?: 'CartPrices'
      applied_taxes?: Array<{
        __typename?: 'CartTaxItem'
        label: string
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null> | null
      colorado_retail_delivery_fee?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      discounts?: Array<{
        __typename?: 'Discount'
        label: string
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null> | null
      grand_total?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      subtotal_excluding_tax?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      subtotal_including_tax?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      subtotal_with_discount_excluding_tax?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
    } | null
    available_payment_methods?: Array<{
      __typename?: 'AvailablePaymentMethod'
      code: string
      title: string
    } | null> | null
    billing_address?: {
      __typename?: 'BillingCartAddress'
      city: string
      firstname: string
      lastname: string
      postcode?: string | null
      street: Array<string | null>
      telephone?: string | null
      country: { __typename?: 'CartAddressCountry'; code: string; label: string }
      region?: {
        __typename?: 'CartAddressRegion'
        code?: string | null
        label?: string | null
        region_id?: number | null
      } | null
    } | null
    items?: Array<
      | {
          __typename?: 'BundleCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'ConfigurableCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'DownloadableCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'SimpleCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'VirtualCartItem'
          id: string
          quantity: number
          customizable_options: Array<{
            __typename?: 'SelectedCustomizableOption'
            id: number
            label: string
            sort_order: number
            values: Array<{
              __typename?: 'SelectedCustomizableOptionValue'
              id: number
              label: string
              value: string
            } | null>
          } | null>
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | null
    > | null
    applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
    rebate?: { __typename?: 'Money'; value?: number | null } | null
    shipping_addresses: Array<{
      __typename?: 'ShippingCartAddress'
      city: string
      firstname: string
      lastname: string
      postcode?: string | null
      street: Array<string | null>
      telephone?: string | null
      country: { __typename?: 'CartAddressCountry'; code: string; label: string }
      region?: {
        __typename?: 'CartAddressRegion'
        code?: string | null
        label?: string | null
        region_id?: number | null
      } | null
      available_shipping_methods?: Array<{
        __typename?: 'AvailableShippingMethod'
        available: boolean
        carrier_code: string
        carrier_title: string
        error_message?: string | null
        method_code?: string | null
        method_title?: string | null
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null> | null
      selected_shipping_method?: {
        __typename?: 'SelectedShippingMethod'
        carrier_code: string
        carrier_title: string
        method_code: string
        method_title: string
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null
    } | null>
    selected_payment_method?: {
      __typename?: 'SelectedPaymentMethod'
      code: string
      purchase_order_number?: string | null
      title: string
      tokenbase_card_id?: string | null
      tokenbase_data?: {
        __typename?: 'TokenBaseCardAdditional'
        cc_last4?: string | null
        cc_exp_year?: string | null
        cc_exp_month?: string | null
        cc_type?: string | null
      } | null
    } | null
  }
}

export type SetPaymentMethodOnCartMutationVariables = Exact<{
  cartId: Scalars['String']
  paymentMethod: PaymentMethodInput
}>

export type SetPaymentMethodOnCartMutation = {
  __typename?: 'Mutation'
  setPaymentMethodOnCart?: {
    __typename?: 'SetPaymentMethodOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type RemoveAndAddSimpleProductsToCartMutationVariables = Exact<{
  cartId: Scalars['String']
  itemId: Scalars['Int']
  cartItems: Array<InputMaybe<SimpleProductCartItemInput>> | InputMaybe<SimpleProductCartItemInput>
}>

export type RemoveAndAddSimpleProductsToCartMutation = {
  __typename?: 'Mutation'
  removeItemFromCart?: {
    __typename?: 'RemoveItemFromCartOutput'
    cart: { __typename?: 'Cart'; id: string }
  } | null
  addSimpleProductsToCart?: {
    __typename?: 'AddSimpleProductsToCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type RemoveCouponFromCartMutationVariables = Exact<{
  cartId: Scalars['String']
  couponCode?: InputMaybe<Scalars['String']>
}>

export type RemoveCouponFromCartMutation = {
  __typename?: 'Mutation'
  removeCouponFromCart?: {
    __typename?: 'RemoveCouponFromCartOutput'
    cart?: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    } | null
  } | null
}

export type RemoveItemFromCartLiteMutationVariables = Exact<{
  cartId: Scalars['String']
  itemId: Scalars['Int']
}>

export type RemoveItemFromCartLiteMutation = {
  __typename?: 'Mutation'
  removeItemFromCart?: { __typename: 'RemoveItemFromCartOutput' } | null
}

export type RemoveItemFromCartMutationVariables = Exact<{
  cartId: Scalars['String']
  itemId: Scalars['Int']
}>

export type RemoveItemFromCartMutation = {
  __typename?: 'Mutation'
  removeItemFromCart?: {
    __typename?: 'RemoveItemFromCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type SetCartAttributesMutationVariables = Exact<{
  cartId: Scalars['String']
  practitionerCode?: InputMaybe<Scalars['String']>
  wellWorldId?: InputMaybe<Scalars['String']>
  wellWorldPracticeId?: InputMaybe<Scalars['String']>
  wellWorldPractitionerId?: InputMaybe<Scalars['String']>
  wellWorldStoreId?: InputMaybe<Scalars['String']>
  dispensaryPromoCode?: InputMaybe<Scalars['String']>
  eScriptCampaign?: InputMaybe<Scalars['String']>
}>

export type SetCartAttributesMutation = {
  __typename?: 'Mutation'
  setCartAttributes?: {
    __typename?: 'SetCartAttributesOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type SetDispensaryPromoCodeOnCartMutationVariables = Exact<{
  cartId: Scalars['String']
  dispensaryPromoCode: Scalars['String']
}>

export type SetDispensaryPromoCodeOnCartMutation = {
  __typename?: 'Mutation'
  setDispensaryPromoCodeOnCart?: {
    __typename?: 'SetDispensaryPromoCodeOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type SetShippingAddressesOnCartMutationVariables = Exact<{
  cartId: Scalars['String']
  shippingAddress: Array<InputMaybe<ShippingAddressInput>> | InputMaybe<ShippingAddressInput>
}>

export type SetShippingAddressesOnCartMutation = {
  __typename?: 'Mutation'
  setShippingAddressesOnCart?: {
    __typename?: 'SetShippingAddressesOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type SetShippingMethodsOnCartMutationVariables = Exact<{
  cartId: Scalars['String']
  shippingMethods: Array<InputMaybe<ShippingMethodInput>> | InputMaybe<ShippingMethodInput>
}>

export type SetShippingMethodsOnCartMutation = {
  __typename?: 'Mutation'
  setShippingMethodsOnCart?: {
    __typename?: 'SetShippingMethodsOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type UpdateCartItemsMutationVariables = Exact<{
  cartId: Scalars['String']
  cartItems: Array<InputMaybe<CartItemUpdateInput>> | InputMaybe<CartItemUpdateInput>
}>

export type UpdateCartItemsMutation = {
  __typename?: 'Mutation'
  updateCartItems?: {
    __typename?: 'UpdateCartItemsOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type CartFragment = {
  __typename?: 'Cart'
  id: string
  email?: string | null
  hold_until_monday?: string | null
  drop_ship?: string | null
  total_quantity: number
  dispensary_promo_code?: string | null
  practitioner_code?: string | null
  ww_id?: string | null
  ww_store_id?: string | null
  ww_practice_id?: string | null
  ww_practitioner_id?: string | null
  e_script_campaign?: string | null
  prices?: {
    __typename?: 'CartPrices'
    applied_taxes?: Array<{
      __typename?: 'CartTaxItem'
      label: string
      amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
    } | null> | null
    colorado_retail_delivery_fee?: {
      __typename?: 'Money'
      currency?: CurrencyEnum | null
      value?: number | null
    } | null
    discounts?: Array<{
      __typename?: 'Discount'
      label: string
      amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
    } | null> | null
    grand_total?: {
      __typename?: 'Money'
      currency?: CurrencyEnum | null
      value?: number | null
    } | null
    subtotal_excluding_tax?: {
      __typename?: 'Money'
      currency?: CurrencyEnum | null
      value?: number | null
    } | null
    subtotal_including_tax?: {
      __typename?: 'Money'
      currency?: CurrencyEnum | null
      value?: number | null
    } | null
    subtotal_with_discount_excluding_tax?: {
      __typename?: 'Money'
      currency?: CurrencyEnum | null
      value?: number | null
    } | null
  } | null
  available_payment_methods?: Array<{
    __typename?: 'AvailablePaymentMethod'
    code: string
    title: string
  } | null> | null
  billing_address?: {
    __typename?: 'BillingCartAddress'
    city: string
    firstname: string
    lastname: string
    postcode?: string | null
    street: Array<string | null>
    telephone?: string | null
    country: { __typename?: 'CartAddressCountry'; code: string; label: string }
    region?: {
      __typename?: 'CartAddressRegion'
      code?: string | null
      label?: string | null
      region_id?: number | null
    } | null
  } | null
  items?: Array<
    | {
        __typename?: 'BundleCartItem'
        id: string
        quantity: number
        prices?: {
          __typename?: 'CartItemPrices'
          price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
          row_total: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
          total_item_discount?: {
            __typename?: 'Money'
            currency?: CurrencyEnum | null
            value?: number | null
          } | null
        } | null
        item_attributes?: {
          __typename?: 'CartItemAttributes'
          size?: string | null
          thumbnail?: string | null
          dfh_autoship_interval?: number | null
          dfh_order_type?: number | null
          description?: string | null
          dosage?: string | null
          flavor?: string | null
          flavor_size?: string | null
          heat_sensitive?: number | null
          prop_sixty_five?: number | null
          short_description?: string | null
          prop65_message?: string | null
        } | null
        product:
          | {
              __typename?: 'BundleProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'ConfigurableProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'DownloadableProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'GroupedProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'SimpleProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'StoreCreditProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'VirtualProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
      }
    | {
        __typename?: 'ConfigurableCartItem'
        id: string
        quantity: number
        prices?: {
          __typename?: 'CartItemPrices'
          price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
          row_total: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
          total_item_discount?: {
            __typename?: 'Money'
            currency?: CurrencyEnum | null
            value?: number | null
          } | null
        } | null
        item_attributes?: {
          __typename?: 'CartItemAttributes'
          size?: string | null
          thumbnail?: string | null
          dfh_autoship_interval?: number | null
          dfh_order_type?: number | null
          description?: string | null
          dosage?: string | null
          flavor?: string | null
          flavor_size?: string | null
          heat_sensitive?: number | null
          prop_sixty_five?: number | null
          short_description?: string | null
          prop65_message?: string | null
        } | null
        product:
          | {
              __typename?: 'BundleProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'ConfigurableProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'DownloadableProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'GroupedProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'SimpleProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'StoreCreditProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'VirtualProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
      }
    | {
        __typename?: 'DownloadableCartItem'
        id: string
        quantity: number
        prices?: {
          __typename?: 'CartItemPrices'
          price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
          row_total: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
          total_item_discount?: {
            __typename?: 'Money'
            currency?: CurrencyEnum | null
            value?: number | null
          } | null
        } | null
        item_attributes?: {
          __typename?: 'CartItemAttributes'
          size?: string | null
          thumbnail?: string | null
          dfh_autoship_interval?: number | null
          dfh_order_type?: number | null
          description?: string | null
          dosage?: string | null
          flavor?: string | null
          flavor_size?: string | null
          heat_sensitive?: number | null
          prop_sixty_five?: number | null
          short_description?: string | null
          prop65_message?: string | null
        } | null
        product:
          | {
              __typename?: 'BundleProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'ConfigurableProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'DownloadableProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'GroupedProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'SimpleProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'StoreCreditProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'VirtualProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
      }
    | {
        __typename?: 'SimpleCartItem'
        id: string
        quantity: number
        prices?: {
          __typename?: 'CartItemPrices'
          price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
          row_total: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
          total_item_discount?: {
            __typename?: 'Money'
            currency?: CurrencyEnum | null
            value?: number | null
          } | null
        } | null
        item_attributes?: {
          __typename?: 'CartItemAttributes'
          size?: string | null
          thumbnail?: string | null
          dfh_autoship_interval?: number | null
          dfh_order_type?: number | null
          description?: string | null
          dosage?: string | null
          flavor?: string | null
          flavor_size?: string | null
          heat_sensitive?: number | null
          prop_sixty_five?: number | null
          short_description?: string | null
          prop65_message?: string | null
        } | null
        product:
          | {
              __typename?: 'BundleProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'ConfigurableProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'DownloadableProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'GroupedProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'SimpleProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'StoreCreditProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'VirtualProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
      }
    | {
        __typename?: 'VirtualCartItem'
        id: string
        quantity: number
        customizable_options: Array<{
          __typename?: 'SelectedCustomizableOption'
          id: number
          label: string
          sort_order: number
          values: Array<{
            __typename?: 'SelectedCustomizableOptionValue'
            id: number
            label: string
            value: string
          } | null>
        } | null>
        prices?: {
          __typename?: 'CartItemPrices'
          price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
          row_total: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
          total_item_discount?: {
            __typename?: 'Money'
            currency?: CurrencyEnum | null
            value?: number | null
          } | null
        } | null
        item_attributes?: {
          __typename?: 'CartItemAttributes'
          size?: string | null
          thumbnail?: string | null
          dfh_autoship_interval?: number | null
          dfh_order_type?: number | null
          description?: string | null
          dosage?: string | null
          flavor?: string | null
          flavor_size?: string | null
          heat_sensitive?: number | null
          prop_sixty_five?: number | null
          short_description?: string | null
          prop65_message?: string | null
        } | null
        product:
          | {
              __typename?: 'BundleProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'ConfigurableProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'DownloadableProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'GroupedProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'SimpleProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'StoreCreditProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
          | {
              __typename?: 'VirtualProduct'
              name?: string | null
              sku?: string | null
              url_key?: string | null
              natural_product_number?: string | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
            }
      }
    | null
  > | null
  applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
  rebate?: { __typename?: 'Money'; value?: number | null } | null
  shipping_addresses: Array<{
    __typename?: 'ShippingCartAddress'
    city: string
    firstname: string
    lastname: string
    postcode?: string | null
    street: Array<string | null>
    telephone?: string | null
    country: { __typename?: 'CartAddressCountry'; code: string; label: string }
    region?: {
      __typename?: 'CartAddressRegion'
      code?: string | null
      label?: string | null
      region_id?: number | null
    } | null
    available_shipping_methods?: Array<{
      __typename?: 'AvailableShippingMethod'
      available: boolean
      carrier_code: string
      carrier_title: string
      error_message?: string | null
      method_code?: string | null
      method_title?: string | null
      amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
    } | null> | null
    selected_shipping_method?: {
      __typename?: 'SelectedShippingMethod'
      carrier_code: string
      carrier_title: string
      method_code: string
      method_title: string
      amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
    } | null
  } | null>
  selected_payment_method?: {
    __typename?: 'SelectedPaymentMethod'
    code: string
    purchase_order_number?: string | null
    title: string
    tokenbase_card_id?: string | null
    tokenbase_data?: {
      __typename?: 'TokenBaseCardAdditional'
      cc_last4?: string | null
      cc_exp_year?: string | null
      cc_exp_month?: string | null
      cc_type?: string | null
    } | null
  } | null
}

export type GetCustomerCartQueryVariables = Exact<{ [key: string]: never }>

export type GetCustomerCartQuery = {
  __typename?: 'Query'
  customerCart: {
    __typename?: 'Cart'
    id: string
    email?: string | null
    hold_until_monday?: string | null
    drop_ship?: string | null
    total_quantity: number
    dispensary_promo_code?: string | null
    practitioner_code?: string | null
    ww_id?: string | null
    ww_store_id?: string | null
    ww_practice_id?: string | null
    ww_practitioner_id?: string | null
    e_script_campaign?: string | null
    prices?: {
      __typename?: 'CartPrices'
      applied_taxes?: Array<{
        __typename?: 'CartTaxItem'
        label: string
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null> | null
      colorado_retail_delivery_fee?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      discounts?: Array<{
        __typename?: 'Discount'
        label: string
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null> | null
      grand_total?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      subtotal_excluding_tax?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      subtotal_including_tax?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
      subtotal_with_discount_excluding_tax?: {
        __typename?: 'Money'
        currency?: CurrencyEnum | null
        value?: number | null
      } | null
    } | null
    available_payment_methods?: Array<{
      __typename?: 'AvailablePaymentMethod'
      code: string
      title: string
    } | null> | null
    billing_address?: {
      __typename?: 'BillingCartAddress'
      city: string
      firstname: string
      lastname: string
      postcode?: string | null
      street: Array<string | null>
      telephone?: string | null
      country: { __typename?: 'CartAddressCountry'; code: string; label: string }
      region?: {
        __typename?: 'CartAddressRegion'
        code?: string | null
        label?: string | null
        region_id?: number | null
      } | null
    } | null
    items?: Array<
      | {
          __typename?: 'BundleCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'ConfigurableCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'DownloadableCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'SimpleCartItem'
          id: string
          quantity: number
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | {
          __typename?: 'VirtualCartItem'
          id: string
          quantity: number
          customizable_options: Array<{
            __typename?: 'SelectedCustomizableOption'
            id: number
            label: string
            sort_order: number
            values: Array<{
              __typename?: 'SelectedCustomizableOptionValue'
              id: number
              label: string
              value: string
            } | null>
          } | null>
          prices?: {
            __typename?: 'CartItemPrices'
            price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
            row_total: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            }
            total_item_discount?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null
          item_attributes?: {
            __typename?: 'CartItemAttributes'
            size?: string | null
            thumbnail?: string | null
            dfh_autoship_interval?: number | null
            dfh_order_type?: number | null
            description?: string | null
            dosage?: string | null
            flavor?: string | null
            flavor_size?: string | null
            heat_sensitive?: number | null
            prop_sixty_five?: number | null
            short_description?: string | null
            prop65_message?: string | null
          } | null
          product:
            | {
                __typename?: 'BundleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'ConfigurableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'DownloadableProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'GroupedProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'SimpleProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'StoreCreditProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
            | {
                __typename?: 'VirtualProduct'
                name?: string | null
                sku?: string | null
                url_key?: string | null
                natural_product_number?: string | null
                stock_status?: ProductStockStatus | null
                out_of_stock_message?: string | null
                stock_configuration?: {
                  __typename?: 'StockItemConfiguration'
                  min_sale_qty?: string | null
                  max_sale_qty?: string | null
                  qty_increments?: string | null
                } | null
              }
        }
      | null
    > | null
    applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
    rebate?: { __typename?: 'Money'; value?: number | null } | null
    shipping_addresses: Array<{
      __typename?: 'ShippingCartAddress'
      city: string
      firstname: string
      lastname: string
      postcode?: string | null
      street: Array<string | null>
      telephone?: string | null
      country: { __typename?: 'CartAddressCountry'; code: string; label: string }
      region?: {
        __typename?: 'CartAddressRegion'
        code?: string | null
        label?: string | null
        region_id?: number | null
      } | null
      available_shipping_methods?: Array<{
        __typename?: 'AvailableShippingMethod'
        available: boolean
        carrier_code: string
        carrier_title: string
        error_message?: string | null
        method_code?: string | null
        method_title?: string | null
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null> | null
      selected_shipping_method?: {
        __typename?: 'SelectedShippingMethod'
        carrier_code: string
        carrier_title: string
        method_code: string
        method_title: string
        amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
      } | null
    } | null>
    selected_payment_method?: {
      __typename?: 'SelectedPaymentMethod'
      code: string
      purchase_order_number?: string | null
      title: string
      tokenbase_card_id?: string | null
      tokenbase_data?: {
        __typename?: 'TokenBaseCardAdditional'
        cc_last4?: string | null
        cc_exp_year?: string | null
        cc_exp_month?: string | null
        cc_type?: string | null
      } | null
    } | null
  }
}

export type CybersourceCardListQueryVariables = Exact<{ [key: string]: never }>

export type CybersourceCardListQuery = {
  __typename?: 'Query'
  tokenBaseCards?: Array<{
    __typename?: 'TokenBaseCard'
    hash?: string | null
    label?: string | null
    additional?: {
      __typename?: 'TokenBaseCardAdditional'
      cc_exp_month?: string | null
      cc_exp_year?: string | null
      cc_last4?: string | null
      cc_type?: string | null
    } | null
    address?: {
      __typename?: 'CustomerAddress'
      city?: string | null
      company?: string | null
      country_code?: CountryCodeEnum | null
      country_id?: string | null
      firstname?: string | null
      lastname?: string | null
      postcode?: string | null
      street?: Array<string | null> | null
      telephone?: string | null
      region?: {
        __typename?: 'CustomerAddressRegion'
        region?: string | null
        region_code?: string | null
        region_id?: number | null
      } | null
    } | null
  } | null> | null
}

export type ExpressSetShippingMutationVariables = Exact<{
  cartId: Scalars['String']
  setEmail: Scalars['Boolean']
  email: Scalars['String']
  setAddress: Scalars['Boolean']
  shippingAddress: Array<InputMaybe<ShippingAddressInput>> | InputMaybe<ShippingAddressInput>
  setHold: Scalars['Boolean']
  holdUntilMonday: Scalars['String']
  shippingMethods: Array<InputMaybe<ShippingMethodInput>> | InputMaybe<ShippingMethodInput>
}>

export type ExpressSetShippingMutation = {
  __typename?: 'Mutation'
  setGuestEmailOnCart?: {
    __typename?: 'SetGuestEmailOnCartOutput'
    cart: { __typename?: 'Cart'; id: string }
  } | null
  setShippingAddressesOnCart?: {
    __typename?: 'SetShippingAddressesOnCartOutput'
    cart: { __typename?: 'Cart'; id: string }
  } | null
  setHoldUntilMondayOnCart?: {
    __typename?: 'SetHoldUntilMondayOnCartOutput'
    cart: { __typename?: 'Cart'; id: string }
  } | null
  setShippingMethodsOnCart?: {
    __typename?: 'SetShippingMethodsOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      email?: string | null
      hold_until_monday?: string | null
      drop_ship?: string | null
      total_quantity: number
      dispensary_promo_code?: string | null
      practitioner_code?: string | null
      ww_id?: string | null
      ww_store_id?: string | null
      ww_practice_id?: string | null
      ww_practitioner_id?: string | null
      e_script_campaign?: string | null
      prices?: {
        __typename?: 'CartPrices'
        applied_taxes?: Array<{
          __typename?: 'CartTaxItem'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        colorado_retail_delivery_fee?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        discounts?: Array<{
          __typename?: 'Discount'
          label: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        grand_total?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_including_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
        subtotal_with_discount_excluding_tax?: {
          __typename?: 'Money'
          currency?: CurrencyEnum | null
          value?: number | null
        } | null
      } | null
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod'
        code: string
        title: string
      } | null> | null
      billing_address?: {
        __typename?: 'BillingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
      } | null
      items?: Array<
        | {
            __typename?: 'BundleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'ConfigurableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'DownloadableCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'SimpleCartItem'
            id: string
            quantity: number
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | {
            __typename?: 'VirtualCartItem'
            id: string
            quantity: number
            customizable_options: Array<{
              __typename?: 'SelectedCustomizableOption'
              id: number
              label: string
              sort_order: number
              values: Array<{
                __typename?: 'SelectedCustomizableOptionValue'
                id: number
                label: string
                value: string
              } | null>
            } | null>
            prices?: {
              __typename?: 'CartItemPrices'
              price: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
              row_total: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              }
              total_item_discount?: {
                __typename?: 'Money'
                currency?: CurrencyEnum | null
                value?: number | null
              } | null
            } | null
            item_attributes?: {
              __typename?: 'CartItemAttributes'
              size?: string | null
              thumbnail?: string | null
              dfh_autoship_interval?: number | null
              dfh_order_type?: number | null
              description?: string | null
              dosage?: string | null
              flavor?: string | null
              flavor_size?: string | null
              heat_sensitive?: number | null
              prop_sixty_five?: number | null
              short_description?: string | null
              prop65_message?: string | null
            } | null
            product:
              | {
                  __typename?: 'BundleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'ConfigurableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'DownloadableProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'GroupedProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'SimpleProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'StoreCreditProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
              | {
                  __typename?: 'VirtualProduct'
                  name?: string | null
                  sku?: string | null
                  url_key?: string | null
                  natural_product_number?: string | null
                  stock_status?: ProductStockStatus | null
                  out_of_stock_message?: string | null
                  stock_configuration?: {
                    __typename?: 'StockItemConfiguration'
                    min_sale_qty?: string | null
                    max_sale_qty?: string | null
                    qty_increments?: string | null
                  } | null
                }
          }
        | null
      > | null
      applied_coupons?: Array<{ __typename?: 'AppliedCoupon'; code: string } | null> | null
      rebate?: { __typename?: 'Money'; value?: number | null } | null
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress'
        city: string
        firstname: string
        lastname: string
        postcode?: string | null
        street: Array<string | null>
        telephone?: string | null
        country: { __typename?: 'CartAddressCountry'; code: string; label: string }
        region?: {
          __typename?: 'CartAddressRegion'
          code?: string | null
          label?: string | null
          region_id?: number | null
        } | null
        available_shipping_methods?: Array<{
          __typename?: 'AvailableShippingMethod'
          available: boolean
          carrier_code: string
          carrier_title: string
          error_message?: string | null
          method_code?: string | null
          method_title?: string | null
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null> | null
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod'
          carrier_code: string
          carrier_title: string
          method_code: string
          method_title: string
          amount: { __typename?: 'Money'; currency?: CurrencyEnum | null; value?: number | null }
        } | null
      } | null>
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
}

export type OrderAddressFragment = {
  __typename?: 'OrderAddress'
  city: string
  company?: string | null
  country_code?: CountryCodeEnum | null
  firstname: string
  lastname: string
  postcode?: string | null
  region?: string | null
  region_id?: string | null
  street: Array<string | null>
  telephone?: string | null
}

export type PlaceOrderWithPaymentMethodMutationVariables = Exact<{
  cartId: Scalars['String']
  paymentMethod: PaymentMethodInput
  input: PlaceOrderInput
}>

export type PlaceOrderWithPaymentMethodMutation = {
  __typename?: 'Mutation'
  setPaymentMethodOnCart?: {
    __typename?: 'SetPaymentMethodOnCartOutput'
    cart: {
      __typename?: 'Cart'
      id: string
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod'
        code: string
        purchase_order_number?: string | null
        title: string
        tokenbase_card_id?: string | null
        tokenbase_data?: {
          __typename?: 'TokenBaseCardAdditional'
          cc_last4?: string | null
          cc_exp_year?: string | null
          cc_exp_month?: string | null
          cc_type?: string | null
        } | null
      } | null
    }
  } | null
  placeOrder?: {
    __typename?: 'PlaceOrderOutput'
    order: { __typename?: 'Order'; order_number: string }
  } | null
}

export type PlaceOrderMutationVariables = Exact<{
  input: PlaceOrderInput
}>

export type PlaceOrderMutation = {
  __typename?: 'Mutation'
  placeOrder?: {
    __typename?: 'PlaceOrderOutput'
    order: { __typename?: 'Order'; order_number: string }
  } | null
}

export type ShopPayMoneyFragment = {
  __typename?: 'ShopPayMoney'
  amount: number
  currencyCode: string
}

export type ShopPayPaymentRequestFragment = {
  __typename?: 'ShopPayPaymentRequest'
  discountCodes?: Array<string> | null
  locale?: string | null
  presentmentCurrency?: string | null
  lineItems?: Array<{
    __typename?: 'ShopPayLineItem'
    label: string
    sku?: string | null
    quantity: number
    requiresShipping?: boolean | null
    originalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
    finalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
    originalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
    finalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
  }> | null
  shippingLines?: Array<{
    __typename?: 'ShopPayShippingLine'
    label: string
    code: string
    amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
  }> | null
  deliveryMethods?: Array<{
    __typename?: 'ShopPayDeliveryMethod'
    label: string
    code: string
    minDeliveryDate?: string | null
    maxDeliveryDate?: string | null
    amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
  }> | null
  discounts?: Array<{
    __typename?: 'ShopPayDiscount'
    label: string
    amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
  }> | null
  subtotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
  totalTax?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
  totalShippingPrice?: {
    __typename?: 'ShopPayTotalShippingPrice'
    finalTotal: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
    originalTotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
  } | null
  total?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
}

export type ShopPayPaymentRequestOutputFragment = {
  __typename?: 'ShopPayPaymentRequestOutput'
  paymentRequest?: {
    __typename?: 'ShopPayPaymentRequest'
    discountCodes?: Array<string> | null
    locale?: string | null
    presentmentCurrency?: string | null
    lineItems?: Array<{
      __typename?: 'ShopPayLineItem'
      label: string
      sku?: string | null
      quantity: number
      requiresShipping?: boolean | null
      originalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      finalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      originalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      finalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
    }> | null
    shippingLines?: Array<{
      __typename?: 'ShopPayShippingLine'
      label: string
      code: string
      amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
    }> | null
    deliveryMethods?: Array<{
      __typename?: 'ShopPayDeliveryMethod'
      label: string
      code: string
      minDeliveryDate?: string | null
      maxDeliveryDate?: string | null
      amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
    }> | null
    discounts?: Array<{
      __typename?: 'ShopPayDiscount'
      label: string
      amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
    }> | null
    subtotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
    totalTax?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
    totalShippingPrice?: {
      __typename?: 'ShopPayTotalShippingPrice'
      finalTotal: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      originalTotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
    } | null
    total?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
  } | null
  errors?: Array<{
    __typename?: 'ShopPayUserError'
    type: ShopPayUserErrorType
    message: string
  }> | null
}

export type ShopPaySessionCreateMutationVariables = Exact<{
  cartId: Scalars['String']
}>

export type ShopPaySessionCreateMutation = {
  __typename?: 'Mutation'
  shopPaySessionCreate?: {
    __typename?: 'ShopPaySessionCreateOutput'
    token: string
    checkout_url: string
    source_identifier: string
    copy_cart_id?: string | null
  } | null
}

export type ShopPayUpdateShippingAddressMutationVariables = Exact<{
  cartId: Scalars['String']
  token: Scalars['String']
  address?: InputMaybe<ShopPayContactInput>
}>

export type ShopPayUpdateShippingAddressMutation = {
  __typename?: 'Mutation'
  shopPayUpdateShippingAddress?: {
    __typename?: 'ShopPayPaymentRequestOutput'
    paymentRequest?: {
      __typename?: 'ShopPayPaymentRequest'
      discountCodes?: Array<string> | null
      locale?: string | null
      presentmentCurrency?: string | null
      lineItems?: Array<{
        __typename?: 'ShopPayLineItem'
        label: string
        sku?: string | null
        quantity: number
        requiresShipping?: boolean | null
        originalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        finalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        originalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        finalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      shippingLines?: Array<{
        __typename?: 'ShopPayShippingLine'
        label: string
        code: string
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      deliveryMethods?: Array<{
        __typename?: 'ShopPayDeliveryMethod'
        label: string
        code: string
        minDeliveryDate?: string | null
        maxDeliveryDate?: string | null
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      discounts?: Array<{
        __typename?: 'ShopPayDiscount'
        label: string
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      subtotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      totalTax?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      totalShippingPrice?: {
        __typename?: 'ShopPayTotalShippingPrice'
        finalTotal: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        originalTotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      } | null
      total?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
    } | null
    errors?: Array<{
      __typename?: 'ShopPayUserError'
      type: ShopPayUserErrorType
      message: string
    }> | null
  } | null
}

export type ShopPaySelectDeliveryMethodMutationVariables = Exact<{
  cartId: Scalars['String']
  token: Scalars['String']
  code: Scalars['String']
}>

export type ShopPaySelectDeliveryMethodMutation = {
  __typename?: 'Mutation'
  shopPaySelectDeliveryMethod?: {
    __typename?: 'ShopPayPaymentRequestOutput'
    paymentRequest?: {
      __typename?: 'ShopPayPaymentRequest'
      discountCodes?: Array<string> | null
      locale?: string | null
      presentmentCurrency?: string | null
      lineItems?: Array<{
        __typename?: 'ShopPayLineItem'
        label: string
        sku?: string | null
        quantity: number
        requiresShipping?: boolean | null
        originalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        finalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        originalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        finalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      shippingLines?: Array<{
        __typename?: 'ShopPayShippingLine'
        label: string
        code: string
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      deliveryMethods?: Array<{
        __typename?: 'ShopPayDeliveryMethod'
        label: string
        code: string
        minDeliveryDate?: string | null
        maxDeliveryDate?: string | null
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      discounts?: Array<{
        __typename?: 'ShopPayDiscount'
        label: string
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      subtotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      totalTax?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      totalShippingPrice?: {
        __typename?: 'ShopPayTotalShippingPrice'
        finalTotal: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        originalTotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      } | null
      total?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
    } | null
    errors?: Array<{
      __typename?: 'ShopPayUserError'
      type: ShopPayUserErrorType
      message: string
    }> | null
  } | null
}

export type ShopPaySelectDeliveryMethodTypeMutationVariables = Exact<{
  cartId: Scalars['String']
  token: Scalars['String']
  type: Scalars['String']
}>

export type ShopPaySelectDeliveryMethodTypeMutation = {
  __typename?: 'Mutation'
  shopPaySelectDeliveryMethodType?: {
    __typename?: 'ShopPayPaymentRequestOutput'
    paymentRequest?: {
      __typename?: 'ShopPayPaymentRequest'
      discountCodes?: Array<string> | null
      locale?: string | null
      presentmentCurrency?: string | null
      lineItems?: Array<{
        __typename?: 'ShopPayLineItem'
        label: string
        sku?: string | null
        quantity: number
        requiresShipping?: boolean | null
        originalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        finalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        originalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        finalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      shippingLines?: Array<{
        __typename?: 'ShopPayShippingLine'
        label: string
        code: string
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      deliveryMethods?: Array<{
        __typename?: 'ShopPayDeliveryMethod'
        label: string
        code: string
        minDeliveryDate?: string | null
        maxDeliveryDate?: string | null
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      discounts?: Array<{
        __typename?: 'ShopPayDiscount'
        label: string
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      subtotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      totalTax?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      totalShippingPrice?: {
        __typename?: 'ShopPayTotalShippingPrice'
        finalTotal: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        originalTotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      } | null
      total?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
    } | null
    errors?: Array<{
      __typename?: 'ShopPayUserError'
      type: ShopPayUserErrorType
      message: string
    }> | null
  } | null
}

export type ShopPayUpdateDiscountCodeMutationVariables = Exact<{
  cartId: Scalars['String']
  token: Scalars['String']
  discountCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>

export type ShopPayUpdateDiscountCodeMutation = {
  __typename?: 'Mutation'
  shopPayUpdateDiscountCode?: {
    __typename?: 'ShopPayPaymentRequestOutput'
    paymentRequest?: {
      __typename?: 'ShopPayPaymentRequest'
      discountCodes?: Array<string> | null
      locale?: string | null
      presentmentCurrency?: string | null
      lineItems?: Array<{
        __typename?: 'ShopPayLineItem'
        label: string
        sku?: string | null
        quantity: number
        requiresShipping?: boolean | null
        originalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        finalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        originalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        finalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      shippingLines?: Array<{
        __typename?: 'ShopPayShippingLine'
        label: string
        code: string
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      deliveryMethods?: Array<{
        __typename?: 'ShopPayDeliveryMethod'
        label: string
        code: string
        minDeliveryDate?: string | null
        maxDeliveryDate?: string | null
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      discounts?: Array<{
        __typename?: 'ShopPayDiscount'
        label: string
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      subtotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      totalTax?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      totalShippingPrice?: {
        __typename?: 'ShopPayTotalShippingPrice'
        finalTotal: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        originalTotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      } | null
      total?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
    } | null
    errors?: Array<{
      __typename?: 'ShopPayUserError'
      type: ShopPayUserErrorType
      message: string
    }> | null
  } | null
}

export type ShopPaySessionConfirmMutationVariables = Exact<{
  input: ShopPaySessionConfirmInput
}>

export type ShopPaySessionConfirmMutation = {
  __typename?: 'Mutation'
  shopPaySessionConfirm?: {
    __typename?: 'ShopPaySessionConfirmOutput'
    status: ShopPayConfirmStatus
    increment_id?: string | null
    source_identifier?: string | null
    updated_payment_request?: {
      __typename?: 'ShopPayPaymentRequest'
      discountCodes?: Array<string> | null
      locale?: string | null
      presentmentCurrency?: string | null
      lineItems?: Array<{
        __typename?: 'ShopPayLineItem'
        label: string
        sku?: string | null
        quantity: number
        requiresShipping?: boolean | null
        originalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        finalItemPrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        originalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        finalLinePrice: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      shippingLines?: Array<{
        __typename?: 'ShopPayShippingLine'
        label: string
        code: string
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      deliveryMethods?: Array<{
        __typename?: 'ShopPayDeliveryMethod'
        label: string
        code: string
        minDeliveryDate?: string | null
        maxDeliveryDate?: string | null
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      discounts?: Array<{
        __typename?: 'ShopPayDiscount'
        label: string
        amount: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
      }> | null
      subtotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      totalTax?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      totalShippingPrice?: {
        __typename?: 'ShopPayTotalShippingPrice'
        finalTotal: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string }
        originalTotal?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
      } | null
      total?: { __typename?: 'ShopPayMoney'; amount: number; currencyCode: string } | null
    } | null
    errors?: Array<{
      __typename?: 'ShopPayUserError'
      type: ShopPayUserErrorType
      message: string
    }> | null
  } | null
}

export type ShopPaySessionEndMutationVariables = Exact<{
  cartId: Scalars['String']
  token: Scalars['String']
}>

export type ShopPaySessionEndMutation = {
  __typename?: 'Mutation'
  shopPaySessionEnd?: { __typename?: 'ShopPaySessionEndOutput'; ok: boolean } | null
}

export type ShopPaySessionStartOverMutationVariables = Exact<{
  cartId: Scalars['String']
}>

export type ShopPaySessionStartOverMutation = {
  __typename?: 'Mutation'
  shopPaySessionStartOver?: {
    __typename?: 'ShopPaySessionStartOverOutput'
    copy_cart_id?: string | null
  } | null
}

export type ShopPayConfirmationQueryVariables = Exact<{
  sourceIdentifier: Scalars['String']
}>

export type ShopPayConfirmationQuery = {
  __typename?: 'Query'
  shopPayConfirmation?: {
    __typename?: 'ShopPayConfirmationOutput'
    status: ShopPayConfirmationStatus
    copy_cart_id?: string | null
    order?: { __typename?: 'ShopPayConfirmationOrder'; order_number: string } | null
  } | null
}

export type ShopPayPaymentInFlightQueryVariables = Exact<{
  cartId: Scalars['String']
}>

export type ShopPayPaymentInFlightQuery = {
  __typename?: 'Query'
  cart?: {
    __typename?: 'Cart'
    id: string
    shop_pay_payment_in_flight?: {
      __typename?: 'ShopPayPaymentInFlight'
      source_identifier: string
      minimum_duration_end: string
    } | null
  } | null
}

export type ApplyCustomerStoreCreditMutationVariables = Exact<{
  cartId: Scalars['String']
  amount: Scalars['Float']
}>

export type ApplyCustomerStoreCreditMutation = {
  __typename?: 'Mutation'
  MpStoreCreditCustomerSpending?: Array<{
    __typename?: 'TotalSegmentsOutput'
    code?: string | null
    title?: string | null
    value?: string | null
  } | null> | null
}

export type UpdateCustomerStoreCreditMutationVariables = Exact<{
  amount: Scalars['Float']
}>

export type UpdateCustomerStoreCreditMutation = {
  __typename?: 'Mutation'
  MpStoreCreditCustomerUpdate?: string | null
}

export type GetCustomerStoreCreditQueryVariables = Exact<{ [key: string]: never }>

export type GetCustomerStoreCreditQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    email?: string | null
    mp_store_credit?: {
      __typename?: 'MpStoreCreditCustomersOutput'
      mp_credit_balance?: number | null
    } | null
  } | null
}

export type TokenBaseCardFragment = {
  __typename?: 'TokenBaseCard'
  active?: boolean | null
  hash?: string | null
  label?: string | null
  last_use?: string | null
  updated_at?: string | null
  additional?: {
    __typename?: 'TokenBaseCardAdditional'
    cc_bin?: string | null
    cc_exp_month?: string | null
    cc_exp_year?: string | null
    cc_last4?: string | null
    cc_owner?: string | null
    cc_type?: string | null
  } | null
  address?: {
    __typename?: 'CustomerAddress'
    city?: string | null
    company?: string | null
    country_code?: CountryCodeEnum | null
    country_id?: string | null
    firstname?: string | null
    lastname?: string | null
    postcode?: string | null
    street?: Array<string | null> | null
    telephone?: string | null
    region?: {
      __typename?: 'CustomerAddressRegion'
      region?: string | null
      region_code?: string | null
      region_id?: number | null
    } | null
  } | null
}

export type TokenBaseCardsQueryVariables = Exact<{ [key: string]: never }>

export type TokenBaseCardsQuery = {
  __typename?: 'Query'
  tokenBaseCards?: Array<{
    __typename?: 'TokenBaseCard'
    active?: boolean | null
    hash?: string | null
    label?: string | null
    last_use?: string | null
    updated_at?: string | null
    additional?: {
      __typename?: 'TokenBaseCardAdditional'
      cc_bin?: string | null
      cc_exp_month?: string | null
      cc_exp_year?: string | null
      cc_last4?: string | null
      cc_owner?: string | null
      cc_type?: string | null
    } | null
    address?: {
      __typename?: 'CustomerAddress'
      city?: string | null
      company?: string | null
      country_code?: CountryCodeEnum | null
      country_id?: string | null
      firstname?: string | null
      lastname?: string | null
      postcode?: string | null
      street?: Array<string | null> | null
      telephone?: string | null
      region?: {
        __typename?: 'CustomerAddressRegion'
        region?: string | null
        region_code?: string | null
        region_id?: number | null
      } | null
    } | null
  } | null> | null
}

export type CompleteTruemedPaymentSessionMutationVariables = Exact<{
  payment_session_id: Scalars['String']
  state: Scalars['String']
}>

export type CompleteTruemedPaymentSessionMutation = {
  __typename?: 'Mutation'
  completeTruemedPaymentSession?: {
    __typename?: 'PlaceOrderOutput'
    order: {
      __typename?: 'Order'
      order_number: string
      truemed_payment_status?: string | null
      truemed_payment_status_summary?: string | null
    }
  } | null
}

export type StartTruemedPaymentSessionMutationVariables = Exact<{
  cart_id: Scalars['String']
  success_url: Scalars['String']
  failure_url: Scalars['String']
}>

export type StartTruemedPaymentSessionMutation = {
  __typename?: 'Mutation'
  startTruemedPaymentSession?: {
    __typename?: 'StartTruemedPaymentSessionOutput'
    payment_session_id: string
    redirect_url: string
    state: string
  } | null
}

export type GetCustomerVipDiscountQueryVariables = Exact<{ [key: string]: never }>

export type GetCustomerVipDiscountQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    email?: string | null
    vip_discount_name?: string | null
  } | null
}

export type CyberSourceFlexKeyMutationVariables = Exact<{ [key: string]: never }>

export type CyberSourceFlexKeyMutation = {
  __typename?: 'Mutation'
  generateFlexJsToken?: {
    __typename?: 'GenerateFlexJsTokenOutput'
    key_id?: string | null
    key_store?: string | null
  } | null
}

export type GetAuthenticatedProductsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']>
  currentPage?: InputMaybe<Scalars['Int']>
  filterInput?: InputMaybe<ProductAttributeFilterInput>
  search?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<ProductAttributeSortInput>
}>

export type GetAuthenticatedProductsQuery = {
  __typename?: 'Query'
  products?: {
    __typename?: 'Products'
    total_count?: number | null
    page_info?: {
      __typename?: 'SearchResultPageInfo'
      page_size?: number | null
      total_pages?: number | null
      current_page?: number | null
    } | null
    aggregations?: Array<{
      __typename?: 'Aggregation'
      attribute_code: string
      label?: string | null
      count?: number | null
      options?: Array<{
        __typename?: 'AggregationOption'
        label?: string | null
        value: string
        count?: number | null
      } | null> | null
    } | null> | null
    items?: Array<
      | {
          __typename?: 'BundleProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'ConfigurableProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          variant_index?: {
            __typename?: 'ConfigurableVariantIndex'
            used_attributes?: Array<string | null> | null
            attribute_values?: string | null
            mapping?: string | null
            product_index?: string | null
            attribute_product_list?: string | null
          } | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'DownloadableProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'GroupedProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'SimpleProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'StoreCreditProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'VirtualProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | null
    > | null
  } | null
}

export type GetBuilderProductsQueryVariables = Exact<{
  sku?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>
}>

export type GetBuilderProductsQuery = {
  __typename?: 'Query'
  products?: {
    __typename?: 'Products'
    items?: Array<
      | {
          __typename?: 'BundleProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          image?: { __typename?: 'ProductImage'; label?: string | null; url?: string | null } | null
        }
      | {
          __typename?: 'ConfigurableProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          image?: { __typename?: 'ProductImage'; label?: string | null; url?: string | null } | null
        }
      | {
          __typename?: 'DownloadableProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          image?: { __typename?: 'ProductImage'; label?: string | null; url?: string | null } | null
        }
      | {
          __typename?: 'GroupedProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          image?: { __typename?: 'ProductImage'; label?: string | null; url?: string | null } | null
        }
      | {
          __typename?: 'SimpleProduct'
          url_key?: string | null
          id?: number | null
          name?: string | null
          sku?: string | null
          price_tiers?: Array<{
            __typename?: 'TierPrice'
            final_price?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null> | null
          variant_index?: {
            __typename?: 'SimpleVariantIndex'
            used_attributes?: Array<string | null> | null
            attribute_values?: string | null
            description?: string | null
            short_description?: string | null
            thumbnail?: string | null
          } | null
          image?: { __typename?: 'ProductImage'; label?: string | null; url?: string | null } | null
        }
      | {
          __typename?: 'StoreCreditProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          image?: { __typename?: 'ProductImage'; label?: string | null; url?: string | null } | null
        }
      | {
          __typename?: 'VirtualProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          image?: { __typename?: 'ProductImage'; label?: string | null; url?: string | null } | null
        }
      | null
    > | null
  } | null
}

export type GetGuestProductsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']>
  currentPage?: InputMaybe<Scalars['Int']>
  filterInput?: InputMaybe<ProductAttributeFilterInput>
  search?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<ProductAttributeSortInput>
}>

export type GetGuestProductsQuery = {
  __typename?: 'Query'
  products?: {
    __typename?: 'Products'
    total_count?: number | null
    page_info?: {
      __typename?: 'SearchResultPageInfo'
      page_size?: number | null
      total_pages?: number | null
      current_page?: number | null
    } | null
    aggregations?: Array<{
      __typename?: 'Aggregation'
      attribute_code: string
      label?: string | null
      count?: number | null
      options?: Array<{
        __typename?: 'AggregationOption'
        label?: string | null
        value: string
        count?: number | null
      } | null> | null
    } | null> | null
    items?: Array<
      | {
          __typename?: 'BundleProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'ConfigurableProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          variant_index?: {
            __typename?: 'ConfigurableVariantIndex'
            used_attributes?: Array<string | null> | null
            attribute_values?: string | null
            mapping?: string | null
            product_index?: string | null
            attribute_product_list?: string | null
          } | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'DownloadableProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'GroupedProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'SimpleProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'StoreCreditProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'VirtualProduct'
          id?: number | null
          name?: string | null
          stock_status?: ProductStockStatus | null
          url_key?: string | null
          product_type_id?: string | null
          specialty?: Array<string | null> | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | null
    > | null
  } | null
}

export type GetOrderProductsQueryVariables = Exact<{
  sku?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>
}>

export type GetOrderProductsQuery = {
  __typename?: 'Query'
  products?: {
    __typename?: 'Products'
    items?: Array<
      | {
          __typename?: 'BundleProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'ConfigurableProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'DownloadableProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'GroupedProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'SimpleProduct'
          url_key?: string | null
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          price_tiers?: Array<{
            __typename?: 'TierPrice'
            final_price?: {
              __typename?: 'Money'
              currency?: CurrencyEnum | null
              value?: number | null
            } | null
          } | null> | null
          stock_configuration?: {
            __typename?: 'StockItemConfiguration'
            min_sale_qty?: string | null
          } | null
          variant_index?: {
            __typename?: 'SimpleVariantIndex'
            used_attributes?: Array<string | null> | null
            attribute_values?: string | null
            description?: string | null
            short_description?: string | null
            thumbnail?: string | null
          } | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'StoreCreditProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | {
          __typename?: 'VirtualProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          image?: { __typename?: 'ProductImage'; url?: string | null; label?: string | null } | null
        }
      | null
    > | null
  } | null
}

export type GetProductsByUrlKeyQueryVariables = Exact<{
  urlKey?: InputMaybe<Scalars['String']>
}>

export type GetProductsByUrlKeyQuery = {
  __typename?: 'Query'
  products?: {
    __typename?: 'Products'
    items?: Array<
      | {
          __typename?: 'BundleProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          stock_status?: ProductStockStatus | null
          product_form?: string | null
          specialty?: Array<string | null> | null
          url_key?: string | null
          doc_patient_education?: string | null
          doc_tech_sheet?: string | null
          doc_clinical_trials?: string | null
          advisor_tags?: Array<string | null> | null
          content_left_public?: string | null
          content_left_patient?: string | null
          content_left_professional?: string | null
          content_left_both?: string | null
          content_right_public?: string | null
          content_right_patient?: string | null
          content_right_professional?: string | null
          content_right_both?: string | null
          description?: { __typename?: 'ComplexTextValue'; html: string } | null
          short_description?: { __typename?: 'ComplexTextValue'; html: string } | null
        }
      | {
          __typename?: 'ConfigurableProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          stock_status?: ProductStockStatus | null
          product_form?: string | null
          specialty?: Array<string | null> | null
          url_key?: string | null
          doc_patient_education?: string | null
          doc_tech_sheet?: string | null
          doc_clinical_trials?: string | null
          advisor_tags?: Array<string | null> | null
          content_left_public?: string | null
          content_left_patient?: string | null
          content_left_professional?: string | null
          content_left_both?: string | null
          content_right_public?: string | null
          content_right_patient?: string | null
          content_right_professional?: string | null
          content_right_both?: string | null
          variant_index?: {
            __typename?: 'ConfigurableVariantIndex'
            used_attributes?: Array<string | null> | null
            attribute_values?: string | null
            mapping?: string | null
            product_index?: string | null
            attribute_product_list?: string | null
          } | null
          variants?: Array<{
            __typename?: 'ConfigurableVariant'
            product?: {
              __typename?: 'SimpleProduct'
              weight?: number | null
              id?: number | null
              name?: string | null
              sku?: string | null
              natural_product_number?: string | null
              specialty?: Array<string | null> | null
              stock_status?: ProductStockStatus | null
              out_of_stock_message?: string | null
              doc_patient_education?: string | null
              doc_tech_sheet?: string | null
              doc_clinical_trials?: string | null
              advisor_tags?: Array<string | null> | null
              content_left_public?: string | null
              content_left_patient?: string | null
              content_left_professional?: string | null
              content_left_both?: string | null
              content_right_public?: string | null
              content_right_patient?: string | null
              content_right_professional?: string | null
              content_right_both?: string | null
              options?: Array<
                | { __typename?: 'CustomizableAreaOption'; option_id?: number | null }
                | { __typename?: 'CustomizableCheckboxOption'; option_id?: number | null }
                | { __typename?: 'CustomizableDateOption'; option_id?: number | null }
                | {
                    __typename?: 'CustomizableDropDownOption'
                    option_id?: number | null
                    value?: Array<{
                      __typename?: 'CustomizableDropDownValue'
                      option_type_id?: number | null
                      price?: number | null
                      price_type?: PriceTypeEnum | null
                      title?: string | null
                    } | null> | null
                  }
                | { __typename?: 'CustomizableFieldOption'; option_id?: number | null }
                | { __typename?: 'CustomizableFileOption'; option_id?: number | null }
                | { __typename?: 'CustomizableMultipleOption'; option_id?: number | null }
                | { __typename?: 'CustomizableRadioOption'; option_id?: number | null }
                | null
              > | null
              stock_configuration?: {
                __typename?: 'StockItemConfiguration'
                min_sale_qty?: string | null
                max_sale_qty?: string | null
                qty_increments?: string | null
              } | null
              description?: { __typename?: 'ComplexTextValue'; html: string } | null
              short_description?: { __typename?: 'ComplexTextValue'; html: string } | null
              price_tiers?: Array<{
                __typename?: 'TierPrice'
                final_price?: {
                  __typename?: 'Money'
                  currency?: CurrencyEnum | null
                  value?: number | null
                } | null
              } | null> | null
            } | null
            attributes?: Array<{
              __typename?: 'ConfigurableAttributeOption'
              label?: string | null
              code?: string | null
              value_index?: number | null
            } | null> | null
          } | null> | null
          description?: { __typename?: 'ComplexTextValue'; html: string } | null
          short_description?: { __typename?: 'ComplexTextValue'; html: string } | null
        }
      | {
          __typename?: 'DownloadableProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          stock_status?: ProductStockStatus | null
          product_form?: string | null
          specialty?: Array<string | null> | null
          url_key?: string | null
          doc_patient_education?: string | null
          doc_tech_sheet?: string | null
          doc_clinical_trials?: string | null
          advisor_tags?: Array<string | null> | null
          content_left_public?: string | null
          content_left_patient?: string | null
          content_left_professional?: string | null
          content_left_both?: string | null
          content_right_public?: string | null
          content_right_patient?: string | null
          content_right_professional?: string | null
          content_right_both?: string | null
          description?: { __typename?: 'ComplexTextValue'; html: string } | null
          short_description?: { __typename?: 'ComplexTextValue'; html: string } | null
        }
      | {
          __typename?: 'GroupedProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          stock_status?: ProductStockStatus | null
          product_form?: string | null
          specialty?: Array<string | null> | null
          url_key?: string | null
          doc_patient_education?: string | null
          doc_tech_sheet?: string | null
          doc_clinical_trials?: string | null
          advisor_tags?: Array<string | null> | null
          content_left_public?: string | null
          content_left_patient?: string | null
          content_left_professional?: string | null
          content_left_both?: string | null
          content_right_public?: string | null
          content_right_patient?: string | null
          content_right_professional?: string | null
          content_right_both?: string | null
          description?: { __typename?: 'ComplexTextValue'; html: string } | null
          short_description?: { __typename?: 'ComplexTextValue'; html: string } | null
        }
      | {
          __typename?: 'SimpleProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          stock_status?: ProductStockStatus | null
          product_form?: string | null
          specialty?: Array<string | null> | null
          url_key?: string | null
          doc_patient_education?: string | null
          doc_tech_sheet?: string | null
          doc_clinical_trials?: string | null
          advisor_tags?: Array<string | null> | null
          content_left_public?: string | null
          content_left_patient?: string | null
          content_left_professional?: string | null
          content_left_both?: string | null
          content_right_public?: string | null
          content_right_patient?: string | null
          content_right_professional?: string | null
          content_right_both?: string | null
          description?: { __typename?: 'ComplexTextValue'; html: string } | null
          short_description?: { __typename?: 'ComplexTextValue'; html: string } | null
        }
      | {
          __typename?: 'StoreCreditProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          stock_status?: ProductStockStatus | null
          product_form?: string | null
          specialty?: Array<string | null> | null
          url_key?: string | null
          doc_patient_education?: string | null
          doc_tech_sheet?: string | null
          doc_clinical_trials?: string | null
          advisor_tags?: Array<string | null> | null
          content_left_public?: string | null
          content_left_patient?: string | null
          content_left_professional?: string | null
          content_left_both?: string | null
          content_right_public?: string | null
          content_right_patient?: string | null
          content_right_professional?: string | null
          content_right_both?: string | null
          description?: { __typename?: 'ComplexTextValue'; html: string } | null
          short_description?: { __typename?: 'ComplexTextValue'; html: string } | null
        }
      | {
          __typename?: 'VirtualProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          natural_product_number?: string | null
          stock_status?: ProductStockStatus | null
          product_form?: string | null
          specialty?: Array<string | null> | null
          url_key?: string | null
          doc_patient_education?: string | null
          doc_tech_sheet?: string | null
          doc_clinical_trials?: string | null
          advisor_tags?: Array<string | null> | null
          content_left_public?: string | null
          content_left_patient?: string | null
          content_left_professional?: string | null
          content_left_both?: string | null
          content_right_public?: string | null
          content_right_patient?: string | null
          content_right_professional?: string | null
          content_right_both?: string | null
          description?: { __typename?: 'ComplexTextValue'; html: string } | null
          short_description?: { __typename?: 'ComplexTextValue'; html: string } | null
        }
      | null
    > | null
  } | null
}

export type GetProductsByUrlKeysQueryVariables = Exact<{
  urlKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>
}>

export type GetProductsByUrlKeysQuery = {
  __typename?: 'Query'
  products?: {
    __typename?: 'Products'
    items?: Array<
      | { __typename: 'BundleProduct'; sku?: string | null; url_key?: string | null }
      | {
          __typename: 'ConfigurableProduct'
          sku?: string | null
          url_key?: string | null
          variants?: Array<{
            __typename?: 'ConfigurableVariant'
            product?: {
              __typename?: 'SimpleProduct'
              sku?: string | null
              stock_status?: ProductStockStatus | null
            } | null
            attributes?: Array<{
              __typename?: 'ConfigurableAttributeOption'
              label?: string | null
              code?: string | null
              value_index?: number | null
            } | null> | null
          } | null> | null
        }
      | { __typename: 'DownloadableProduct'; sku?: string | null; url_key?: string | null }
      | { __typename: 'GroupedProduct'; sku?: string | null; url_key?: string | null }
      | { __typename: 'SimpleProduct'; sku?: string | null; url_key?: string | null }
      | { __typename: 'StoreCreditProduct'; sku?: string | null; url_key?: string | null }
      | { __typename: 'VirtualProduct'; sku?: string | null; url_key?: string | null }
      | null
    > | null
  } | null
}

export type GetProductsVariantsByParentSkusQueryVariables = Exact<{
  skus?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>
}>

export type GetProductsVariantsByParentSkusQuery = {
  __typename?: 'Query'
  products?: {
    __typename?: 'Products'
    items?: Array<
      | {
          __typename?: 'BundleProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          url_key?: string | null
        }
      | {
          __typename?: 'ConfigurableProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          url_key?: string | null
          variant_index?: {
            __typename?: 'ConfigurableVariantIndex'
            used_attributes?: Array<string | null> | null
            attribute_values?: string | null
            mapping?: string | null
            product_index?: string | null
            attribute_product_list?: string | null
          } | null
          variants?: Array<{
            __typename?: 'ConfigurableVariant'
            product?: {
              __typename?: 'SimpleProduct'
              id?: number | null
              name?: string | null
              sku?: string | null
            } | null
            attributes?: Array<{
              __typename?: 'ConfigurableAttributeOption'
              label?: string | null
              code?: string | null
              value_index?: number | null
            } | null> | null
          } | null> | null
        }
      | {
          __typename?: 'DownloadableProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          url_key?: string | null
        }
      | {
          __typename?: 'GroupedProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          url_key?: string | null
        }
      | {
          __typename?: 'SimpleProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          url_key?: string | null
        }
      | {
          __typename?: 'StoreCreditProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          url_key?: string | null
        }
      | {
          __typename?: 'VirtualProduct'
          id?: number | null
          name?: string | null
          sku?: string | null
          url_key?: string | null
        }
      | null
    > | null
  } | null
}

export const CustomerAddressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'customerAddress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomerAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'region' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'country_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default_shipping' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default_billing' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerAddressFragment, unknown>
export const CartFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CartFragment, unknown>
export const OrderAddressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderAddress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderAddressFragment, unknown>
export const ShopPayMoneyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayMoney' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayMoney' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopPayMoneyFragment, unknown>
export const ShopPayPaymentRequestFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayPaymentRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresShipping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingLines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deliveryMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minDeliveryDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDeliveryDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountCodes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalTax' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalShippingPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentmentCurrency' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayMoney' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayMoney' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopPayPaymentRequestFragment, unknown>
export const ShopPayPaymentRequestOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequestOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopPayPaymentRequestOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayPaymentRequest' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayMoney' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayMoney' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayPaymentRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresShipping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingLines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deliveryMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minDeliveryDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDeliveryDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountCodes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalTax' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalShippingPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentmentCurrency' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopPayPaymentRequestOutputFragment, unknown>
export const TokenBaseCardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tokenBaseCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TokenBaseCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cc_bin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_owner' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last_use' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TokenBaseCardFragment, unknown>
export const GetCountriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCountries' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'two_letter_abbreviation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'three_letter_abbreviation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'full_name_locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'full_name_english' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_regions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCountriesQuery, GetCountriesQueryVariables>
export const CreateCustomerAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCustomerAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomerAddressInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCustomerAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'customerAddress' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'customerAddress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomerAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'region' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'country_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default_shipping' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default_billing' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCustomerAddressMutation, CreateCustomerAddressMutationVariables>
export const DeleteCustomerAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteCustomerAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCustomerAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCustomerAddressMutation, DeleteCustomerAddressMutationVariables>
export const UpdateCustomerAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCustomerAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomerAddressInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCustomerAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'customerAddress' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'customerAddress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomerAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'region' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'country_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default_shipping' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default_billing' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>
export const GetCustomerAddressesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCustomerAddresses' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'default_billing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'default_shipping' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'customerAddress' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'latestOrderAddress' },
                  name: { kind: 'Name', value: 'orders' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'sort_field' },
                            value: { kind: 'EnumValue', value: 'CREATED_AT' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'sort_direction' },
                            value: { kind: 'EnumValue', value: 'DESC' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'billing_address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'orderAddress' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'order_date' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shipping_address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'orderAddress' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'customerAddress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomerAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'region' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'country_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default_shipping' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default_billing' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderAddress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomerAddressesQuery, GetCustomerAddressesQueryVariables>
export const RequestApplePaySessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'requestApplePaySession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'validationUrl' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestApplePaySession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'validationUrl' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'validationUrl' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'session' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestApplePaySessionMutation,
  RequestApplePaySessionMutationVariables
>
export const CreateCustomerCardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCustomerCard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TokenBaseCardCreateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTokenBaseCard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tokenBaseCard' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tokenBaseCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TokenBaseCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cc_bin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_owner' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last_use' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCustomerCardMutation, CreateCustomerCardMutationVariables>
export const DeleteCustomerCardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteCustomerCard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hash' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTokenBaseCard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hash' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hash' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCustomerCardMutation, DeleteCustomerCardMutationVariables>
export const AddSimpleAndVirtualProductsToCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addSimpleAndVirtualProductsToCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'simpleCartItems' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SimpleProductCartItemInput' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualCartItems' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'VirtualProductCartItemInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addSimpleProductsToCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_items' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'simpleCartItems' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addVirtualProductsToCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_items' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'virtualCartItems' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddSimpleAndVirtualProductsToCartMutation,
  AddSimpleAndVirtualProductsToCartMutationVariables
>
export const AddSimpleProductsToCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addSimpleProductsToCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartItems' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SimpleProductCartItemInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addSimpleProductsToCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_items' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartItems' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddSimpleProductsToCartMutation,
  AddSimpleProductsToCartMutationVariables
>
export const ApplyCouponToCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'applyCouponToCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'couponCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyCouponToCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'coupon_code' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'couponCode' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>
export const SetBillingAddressAndPaymentMethodOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setBillingAddressAndPaymentMethodOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'billingAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BillingAddressInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentMethod' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentMethodInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setBillingAddressOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'billing_address' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'billingAddress' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setPaymentMethodOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'payment_method' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentMethod' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetBillingAddressAndPaymentMethodOnCartMutation,
  SetBillingAddressAndPaymentMethodOnCartMutationVariables
>
export const SetBillingAddressOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setBillingAddressOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'billingAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BillingAddressInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setBillingAddressOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'billing_address' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'billingAddress' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetBillingAddressOnCartMutation,
  SetBillingAddressOnCartMutationVariables
>
export const CreateEmptyCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEmptyCart' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createEmptyCart' } }],
      },
    },
  ],
} as unknown as DocumentNode<CreateEmptyCartMutation, CreateEmptyCartMutationVariables>
export const SetDropShipOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setDropShipOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dropShip' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setDropShipOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'drop_ship' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'dropShip' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetDropShipOnCartMutation, SetDropShipOnCartMutationVariables>
export const SetGuestEmailOnCartMinimalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetGuestEmailOnCartMinimal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setGuestEmailOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetGuestEmailOnCartMinimalMutation,
  SetGuestEmailOnCartMinimalMutationVariables
>
export const SetGuestEmailAndShippingAddressesOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setGuestEmailAndShippingAddressesOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shippingAddress' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShippingAddressInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setGuestEmailOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setShippingAddressesOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shipping_addresses' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shippingAddress' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetGuestEmailAndShippingAddressesOnCartMutation,
  SetGuestEmailAndShippingAddressesOnCartMutationVariables
>
export const SetGuestEmailOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setGuestEmailOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setGuestEmailOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetGuestEmailOnCartMutation, SetGuestEmailOnCartMutationVariables>
export const GetGuestCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getGuestCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cart_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetGuestCartQuery, GetGuestCartQueryVariables>
export const SetHoldUntilMondayOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setHoldUntilMondayOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'holdUntilMonday' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setHoldUntilMondayOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hold_until_monday' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'holdUntilMonday' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetHoldUntilMondayOnCartMutation,
  SetHoldUntilMondayOnCartMutationVariables
>
export const MergeCartsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'mergeCarts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceCartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'destinationCartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mergeCarts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'source_cart_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceCartId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'destination_cart_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'destinationCartId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MergeCartsMutation, MergeCartsMutationVariables>
export const SetPaymentMethodOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setPaymentMethodOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentMethod' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentMethodInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setPaymentMethodOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'payment_method' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentMethod' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetPaymentMethodOnCartMutation,
  SetPaymentMethodOnCartMutationVariables
>
export const RemoveAndAddSimpleProductsToCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeAndAddSimpleProductsToCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartItems' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SimpleProductCartItemInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeItemFromCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_item_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addSimpleProductsToCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_items' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartItems' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveAndAddSimpleProductsToCartMutation,
  RemoveAndAddSimpleProductsToCartMutationVariables
>
export const RemoveCouponFromCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeCouponFromCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'couponCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeCouponFromCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'coupon_code' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'couponCode' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>
export const RemoveItemFromCartLiteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeItemFromCartLite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeItemFromCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_item_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveItemFromCartLiteMutation,
  RemoveItemFromCartLiteMutationVariables
>
export const RemoveItemFromCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeItemFromCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeItemFromCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_item_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>
export const SetCartAttributesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setCartAttributes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'practitionerCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'wellWorldId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'wellWorldPracticeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'wellWorldPractitionerId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'wellWorldStoreId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dispensaryPromoCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eScriptCampaign' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCartAttributes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'practitioner_code' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'practitionerCode' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ww_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'wellWorldId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ww_practice_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'wellWorldPracticeId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ww_practitioner_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'wellWorldPractitionerId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ww_store_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'wellWorldStoreId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'dispensary_promo_code' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'dispensaryPromoCode' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'e_script_campaign' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'eScriptCampaign' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCartAttributesMutation, SetCartAttributesMutationVariables>
export const SetDispensaryPromoCodeOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setDispensaryPromoCodeOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dispensaryPromoCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setDispensaryPromoCodeOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'dispensary_promo_code' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'dispensaryPromoCode' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetDispensaryPromoCodeOnCartMutation,
  SetDispensaryPromoCodeOnCartMutationVariables
>
export const SetShippingAddressesOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setShippingAddressesOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shippingAddress' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShippingAddressInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setShippingAddressesOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shipping_addresses' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shippingAddress' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetShippingAddressesOnCartMutation,
  SetShippingAddressesOnCartMutationVariables
>
export const SetShippingMethodsOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setShippingMethodsOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shippingMethods' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShippingMethodInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setShippingMethodsOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shipping_methods' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shippingMethods' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetShippingMethodsOnCartMutation,
  SetShippingMethodsOnCartMutationVariables
>
export const UpdateCartItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCartItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartItems' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'CartItemUpdateInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCartItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_items' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartItems' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCartItemsMutation, UpdateCartItemsMutationVariables>
export const GetCustomerCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCustomerCart' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerCart' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomerCartQuery, GetCustomerCartQueryVariables>
export const CybersourceCardListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cybersourceCardList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tokenBaseCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additional' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'region' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'region_code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CybersourceCardListQuery, CybersourceCardListQueryVariables>
export const ExpressSetShippingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'expressSetShipping' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'setEmail' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'setAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shippingAddress' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShippingAddressInput' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'setHold' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'holdUntilMonday' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shippingMethods' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShippingMethodInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setGuestEmailOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'setEmail' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setShippingAddressesOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shipping_addresses' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shippingAddress' } },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'setAddress' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setHoldUntilMondayOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hold_until_monday' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'holdUntilMonday' } },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'setHold' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setShippingMethodsOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shipping_methods' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shippingMethods' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cart' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cart' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Cart' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorado_retail_delivery_fee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grand_total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_including_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotal_with_discount_excluding_tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hold_until_monday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'drop_ship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'available_payment_methods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing_address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'row_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_item_discount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item_attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_autoship_interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dfh_order_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flavor_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_sensitive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop_sixty_five' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short_description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prop65_message' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_configuration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_sale_qty' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'qty_increments' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'out_of_stock_message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VirtualCartItem' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customizable_options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sort_order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'values' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applied_coupons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipping_addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_shipping_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error_message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_shipping_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carrier_title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'method_title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selected_payment_method' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purchase_order_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenbase_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dispensary_promo_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'practitioner_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_store_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ww_practitioner_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'e_script_campaign' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExpressSetShippingMutation, ExpressSetShippingMutationVariables>
export const PlaceOrderWithPaymentMethodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'placeOrderWithPaymentMethod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentMethod' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentMethodInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PlaceOrderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setPaymentMethodOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'payment_method' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentMethod' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selected_payment_method' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'purchase_order_number' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tokenbase_card_id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tokenbase_data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'order_number' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlaceOrderWithPaymentMethodMutation,
  PlaceOrderWithPaymentMethodMutationVariables
>
export const PlaceOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'placeOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PlaceOrderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'order_number' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaceOrderMutation, PlaceOrderMutationVariables>
export const ShopPaySessionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shopPaySessionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shopPaySessionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkout_url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source_identifier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'copy_cart_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopPaySessionCreateMutation, ShopPaySessionCreateMutationVariables>
export const ShopPayUpdateShippingAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shopPayUpdateShippingAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayContactInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shopPayUpdateShippingAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'token' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'address' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'shopPayPaymentRequestOutput' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayMoney' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayMoney' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayPaymentRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresShipping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingLines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deliveryMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minDeliveryDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDeliveryDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountCodes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalTax' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalShippingPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentmentCurrency' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequestOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopPayPaymentRequestOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayPaymentRequest' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShopPayUpdateShippingAddressMutation,
  ShopPayUpdateShippingAddressMutationVariables
>
export const ShopPaySelectDeliveryMethodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shopPaySelectDeliveryMethod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shopPaySelectDeliveryMethod' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'token' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'code' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'shopPayPaymentRequestOutput' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayMoney' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayMoney' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayPaymentRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresShipping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingLines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deliveryMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minDeliveryDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDeliveryDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountCodes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalTax' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalShippingPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentmentCurrency' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequestOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopPayPaymentRequestOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayPaymentRequest' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShopPaySelectDeliveryMethodMutation,
  ShopPaySelectDeliveryMethodMutationVariables
>
export const ShopPaySelectDeliveryMethodTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shopPaySelectDeliveryMethodType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shopPaySelectDeliveryMethodType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'token' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'shopPayPaymentRequestOutput' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayMoney' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayMoney' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayPaymentRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresShipping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingLines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deliveryMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minDeliveryDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDeliveryDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountCodes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalTax' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalShippingPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentmentCurrency' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequestOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopPayPaymentRequestOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayPaymentRequest' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShopPaySelectDeliveryMethodTypeMutation,
  ShopPaySelectDeliveryMethodTypeMutationVariables
>
export const ShopPayUpdateDiscountCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shopPayUpdateDiscountCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'discountCodes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shopPayUpdateDiscountCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'token' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'discountCodes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'discountCodes' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'shopPayPaymentRequestOutput' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayMoney' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayMoney' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayPaymentRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresShipping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingLines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deliveryMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minDeliveryDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDeliveryDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountCodes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalTax' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalShippingPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentmentCurrency' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequestOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopPayPaymentRequestOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayPaymentRequest' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShopPayUpdateDiscountCodeMutation,
  ShopPayUpdateDiscountCodeMutationVariables
>
export const ShopPaySessionConfirmDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shopPaySessionConfirm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ShopPaySessionConfirmInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shopPaySessionConfirm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'increment_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source_identifier' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updated_payment_request' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'shopPayPaymentRequest' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayMoney' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayMoney' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'shopPayPaymentRequest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ShopPayPaymentRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresShipping' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalItemPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalLinePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingLines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deliveryMethods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minDeliveryDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDeliveryDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountCodes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalTax' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalShippingPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'shopPayMoney' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentmentCurrency' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopPaySessionConfirmMutation, ShopPaySessionConfirmMutationVariables>
export const ShopPaySessionEndDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shopPaySessionEnd' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shopPaySessionEnd' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'token' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'ok' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopPaySessionEndMutation, ShopPaySessionEndMutationVariables>
export const ShopPaySessionStartOverDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shopPaySessionStartOver' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shopPaySessionStartOver' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'copy_cart_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShopPaySessionStartOverMutation,
  ShopPaySessionStartOverMutationVariables
>
export const ShopPayConfirmationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shopPayConfirmation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceIdentifier' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shopPayConfirmation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'source_identifier' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceIdentifier' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'order_number' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'copy_cart_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopPayConfirmationQuery, ShopPayConfirmationQueryVariables>
export const ShopPayPaymentInFlightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shopPayPaymentInFlight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cart_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shop_pay_payment_in_flight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'source_identifier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minimum_duration_end' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopPayPaymentInFlightQuery, ShopPayPaymentInFlightQueryVariables>
export const ApplyCustomerStoreCreditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplyCustomerStoreCredit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'MpStoreCreditCustomerSpending' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cart_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cartId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplyCustomerStoreCreditMutation,
  ApplyCustomerStoreCreditMutationVariables
>
export const UpdateCustomerStoreCreditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCustomerStoreCredit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'MpStoreCreditCustomerUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCustomerStoreCreditMutation,
  UpdateCustomerStoreCreditMutationVariables
>
export const GetCustomerStoreCreditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCustomerStoreCredit' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mp_store_credit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mp_credit_balance' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomerStoreCreditQuery, GetCustomerStoreCreditQueryVariables>
export const TokenBaseCardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'tokenBaseCards' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tokenBaseCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tokenBaseCard' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tokenBaseCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TokenBaseCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cc_bin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_month' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_exp_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_last4' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_owner' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cc_type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region_id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last_use' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TokenBaseCardsQuery, TokenBaseCardsQueryVariables>
export const CompleteTruemedPaymentSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'completeTruemedPaymentSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payment_session_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeTruemedPaymentSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'payment_session_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'payment_session_id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'order_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'truemed_payment_status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'truemed_payment_status_summary' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteTruemedPaymentSessionMutation,
  CompleteTruemedPaymentSessionMutationVariables
>
export const StartTruemedPaymentSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'startTruemedPaymentSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cart_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'success_url' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'failure_url' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTruemedPaymentSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'cart_id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'success_url' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'success_url' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'failure_url' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'failure_url' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'payment_session_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redirect_url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartTruemedPaymentSessionMutation,
  StartTruemedPaymentSessionMutationVariables
>
export const GetCustomerVipDiscountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCustomerVipDiscount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vip_discount_name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomerVipDiscountQuery, GetCustomerVipDiscountQueryVariables>
export const CyberSourceFlexKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cyberSourceFlexKey' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateFlexJsToken' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key_store' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CyberSourceFlexKeyMutation, CyberSourceFlexKeyMutationVariables>
export const GetAuthenticatedProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAuthenticatedProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filterInput' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductAttributeFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductAttributeSortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filterInput' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'currentPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currentPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total_count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'page_info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total_pages' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'current_page' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'product_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'specialty' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ConfigurableProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variant_index' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'used_attributes' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute_values' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mapping' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'product_index' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute_product_list' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAuthenticatedProductsQuery, GetAuthenticatedProductsQueryVariables>
export const GetBuilderProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getBuilderProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sku' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SimpleProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price_tiers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'final_price' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'currency' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variant_index' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'used_attributes' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute_values' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_description' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBuilderProductsQuery, GetBuilderProductsQueryVariables>
export const GetGuestProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getGuestProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filterInput' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductAttributeFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductAttributeSortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filterInput' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'currentPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currentPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total_count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'page_info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total_pages' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'current_page' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attribute_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'product_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'specialty' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ConfigurableProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variant_index' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'used_attributes' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute_values' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mapping' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'product_index' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute_product_list' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetGuestProductsQuery, GetGuestProductsQueryVariables>
export const GetOrderProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOrderProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sku' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SimpleProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price_tiers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'final_price' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'currency' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stock_configuration' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'min_sale_qty' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variant_index' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'used_attributes' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute_values' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_description' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrderProductsQuery, GetOrderProductsQueryVariables>
export const GetProductsByUrlKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProductsByUrlKey' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'urlKey' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'url_key' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'urlKey' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'natural_product_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stock_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'product_form' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'specialty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'doc_patient_education' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'doc_tech_sheet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'doc_clinical_trials' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'advisor_tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content_left_public' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content_left_patient' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content_left_professional' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content_left_both' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content_right_public' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content_right_patient' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content_right_professional' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'content_right_both' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'html' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_description' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'html' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ConfigurableProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variant_index' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'used_attributes' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute_values' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mapping' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'product_index' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute_product_list' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variants' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'product' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'stock_configuration' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'min_sale_qty' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'max_sale_qty' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'qty_increments' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'natural_product_number' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'specialty' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'stock_status' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'out_of_stock_message' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'doc_patient_education' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'doc_tech_sheet' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'doc_clinical_trials' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'advisor_tags' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'content_left_public' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'content_left_patient' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'content_left_professional',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'content_left_both' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'content_right_public' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'content_right_patient' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'content_right_professional',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'content_right_both' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'description' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'html' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'short_description' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'html' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {
                                              kind: 'Name',
                                              value: 'PhysicalProductInterface',
                                            },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'weight' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'price_tiers' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'final_price' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'currency' },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'value' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'SimpleProduct' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'options' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'option_id' },
                                                    },
                                                    {
                                                      kind: 'InlineFragment',
                                                      typeCondition: {
                                                        kind: 'NamedType',
                                                        name: {
                                                          kind: 'Name',
                                                          value: 'CustomizableDropDownOption',
                                                        },
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'value' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'option_type_id',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'price',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'price_type',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'title',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'value_index' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProductsByUrlKeyQuery, GetProductsByUrlKeyQueryVariables>
export const GetProductsByUrlKeysDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProductsByUrlKeys' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'urlKeys' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'url_key' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'urlKeys' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ConfigurableProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variants' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'product' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'stock_status' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'value_index' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProductsByUrlKeysQuery, GetProductsByUrlKeysQueryVariables>
export const GetProductsVariantsByParentSkusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProductsVariantsByParentSkus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skus' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sku' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'skus' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ConfigurableProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variant_index' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'used_attributes' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute_values' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mapping' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'product_index' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute_product_list' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variants' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'product' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'value_index' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetProductsVariantsByParentSkusQuery,
  GetProductsVariantsByParentSkusQueryVariables
>
